import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import televisionprogram from '../videos/television-program.mp4';
import radioprogram from '../videos/radio-program.mp4';
import realestatemagazine from '../videos/real-estate-magazine.mp4';
import socialmedia from '../videos/social-media.mp4';
import website from '../videos/Website.mp4';
import realestateexhibition from '../videos/real-estate-exhibitions.mp4';
import mobileapp from '../videos/mobile-application.mp4';
import sportsclub from "../videos/sportsclubs.mp4"
import bankbranchs from '../videos/bankbranchs.mp4';


import feasability from '../videos/services/service-feasibility.mp4';
import marketing from '../videos/services/service-marketing.mp4';
import financing from '../videos/services/service-financing.mp4';
import immigration from '../videos/services/service-immigration.mp4';
import accounting from "../videos/services/service-accounting.mp4"

import buyingandselling from "../videos/services/Buying_and_selling.mp4"
import exchange from '../videos/services/exchange1.mp4';
import realestateappraisal from '../videos/services/estate_appraisal.mp4';
import auctions from '../videos/services/auctions.mp4';
import contractingandconstruction from "../videos/services/Contracting_and_construction .mp4";
import design from "../videos/services/design.mp4"
import maintenance from "../videos/services/maintenance.mp4"
import assetmanagement from "../videos/services/asset_management.mp4"
import investment from "../videos/services/investment.mp4"
import leasing from "../videos/services/leasing.mp4"
import certificate from "../videos/services/certificate.mp4"
import nationalProjects from "../videos/services/national_projects.mp4"
import conference from "../videos/services/conferences.mp4"
import legal from "../videos/services/service-legal.mp4"
import academy from "../videos/services/academy.mp4"
import { investmentPageAr, investmentPageEn } from '../content/investmentPageContent';
import { mediaInitiativePageAr, mediaInitiativePageEn } from '../content/mediaInitiativePageContent';
import { sportsClubsPageAr, sportsClubsPageEn } from '../content/sportsClubsPageContent';


const LanguageContext = createContext(null);

const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      audience: 'Club membership',
      who: 'Who we are',
      founder: 'Founder',
      strategy: 'Vision',
      phaseOne: 'Partners',
      investment: 'Investment',
      marketing: 'Media power',
      mediaInitiative: 'Media Initiative',
      sportsClubs: 'Sports Clubs',
      visualHub: 'Visual Hub',
      ideas: 'New ideas',
      cta: 'Join the club',
      aiAssistant: 'AI Assistant',
    },
    hero: {
      badge: 'The Real Estate Club',
      title: 'The world\'s destination — the ecosystem of the future',
      subtitle:
        '“Because we believe real estate is the world\'s shared language, we created a platform that unites continents in one system. We are not merely an option — we are the hub where investors from 100 countries meet to build a smart, secure, borderless future for real estate.”',
      explore: 'Explore services',
      latestProjects: 'Our latest projects',
      previousWork: 'Our previous work',
      latestProjectsHref: 'https://www.holol.club/',
      previousWorkHref: 'https://www.adhamelsharkawy.com/',
      marketing: 'Learn more',
      videoCaption: 'Holol Global Real Estate Club',
    },
    stats: [
      { value: '20', label: 'Integrated real estate services' },
      { value: '5', label: 'Target segments' },
      { value: '0%', label: 'No commissions or intermediaries' },
      { value: '100', label: 'Countries' },
      { value: '∞', label: 'Franchise potential worldwide' },
    ],
    intro: {
      eyebrow: '',
      title: 'Welcome to the Real Estate Club',
      pairs: [
        {
          leadGold: 'Holol Real Estate Club:',
          leadRest: '“Where wealth is stewarded… and visions become reality.”',
          body: 'Real estate is not mere walls; it is wealth that demands professional stewardship and sharp insight. We turn major ambitions and national projects into concrete outcomes through a system that connects smart capital with sovereign and national opportunities.',
        },
        {
          leadGold: 'Holol Real Estate Club:',
          leadRest: '“The great revolution in the world of assets.”',
          body: 'We came to change the rules of the game. At Holol Club we break the limits of traditional commissions and abolish the middleman, restoring power directly to seller and buyer under absolute transparency and innovative solutions the market has never seen before.',
        },
        {
          leadGold: 'Holol Real Estate Club:',
          leadRest: '“Investment without borders… trust without limits.”',
          body: 'We give you freedom to move across 100 countries at the push of a button, backed by a rigorous valuation and legal regime. Invest anywhere in the world and exchange your assets with flexibility, confident that your rights are protected by a powerful global trust framework.',
        },
        {
          leadGold: 'Holol Real Estate Club:',
          leadRest: '“The global system for real estate thought and investment.”',
          body: 'Successful investment begins with sound thinking. We do not only provide a buy-and-sell platform; we steward real estate culture and set international standards for valuation and management. We are the institution that merges media power with investment intelligence to build a complete ecosystem worthy of elite investors.',
        },
      ],
      link: 'Discover our vision',
    },
    homeIntroVideo: {
      title: 'Philosophy of Holol Real Estate Club',
      videoUrl: 'https://youtu.be/S76qRSo1su4',
    },
    studyOverview: {
      eyebrow: 'Project study',
      title: 'Themes of the founding study',
      subtitle:
        'A concise study of the Real Estate Club concept by Dr. Adham El-Sharkawy, Managing Director of Banan Integrated Solutions.',
      chapters: [
        { title: 'Club objectives', icon: 'flag' },
        { title: 'Member advantages', icon: 'workspace_premium' },
        { title: 'Who the study addresses', icon: 'gps_fixed' },
        { title: 'Club services', icon: 'apartment' },
        { title: 'New ideas', icon: 'lightbulb' },
        { title: 'Marketing approach', icon: 'campaign' },
        { title: 'Costs and revenues', icon: 'payments' },
        { title: 'General notes', icon: 'sticky_note_2' },
      ],
    },
    servicesHome: {
      title: 'Our core services',
      subtitle:
        'A full lifecycle of real estate solutions for individuals, companies, banks, and government entities.',
      moreTitle: 'Want to know more?',
      moreText: 'Browse the full list of every integrated real estate service the club provides.',
      moreCta: 'Learn more',
      learnMoreCta: 'To learn more, click here',
      deckHint: 'Hover to explore our services',
      deckHintTouch: 'Tap to explore our services',
    },
    cards: [
      {
        title: 'Buying & Selling',
        text: 'Direct buying and selling for individuals and companies — no commissions, no middlemen.',
        icon: 'real_estate_agent',
      },
      {
        title: 'Real Estate Financing',
        text: 'Strategic bank partnerships providing transparent financing to buyers and sellers.',
        icon: 'account_balance',
      },
      {
        title: 'Legal Consulting',
        text: 'Full legal coverage, contracts and compliance to protect every party in the deal.',
        icon: 'gavel',
      },
      {
        title: 'Real estate appraisal',
        text: 'Precise technical and market appraisal that protects investors and supports fair pricing.',
        icon: 'rule',
      },
      {
        title: 'Real estate marketing',
        text: 'Integrated media campaigns to market units and projects to qualified audiences.',
        icon: 'campaign',
      },
      {
        title: 'Property management',
        text: 'Professional operations and maintenance that preserve long-term asset value.',
        icon: 'apartment',
      },
    ],
    howItWorks: {
      eyebrow: 'How the club works',
      title: 'Why we are different',
      subtitle:
        'Six principles that set the Holol Real Estate Club apart from any other player in the market.',
      ctaText: 'Ready to join a trusted real estate ecosystem?',
      ctaButton: 'Submit a membership request',
      steps: [
        {
          number: '01',
          title: 'A direct meeting between buyer and seller',
          text: 'The club brings serious buyers and sellers together in one place, on one platform.',
          icon: 'handshake',
          image:
            'https://thehill.com/wp-content/uploads/sites/2/2022/01/tto2c2l.jpeg?strip=1',
        },
        {
          number: '02',
          title: 'No commissions and no intermediaries',
          text: 'Every sale, purchase and real estate service comes with no commissions and no middlemen.',
          icon: 'payments',
          image:
            'https://images.pexels.com/photos/4386431/pexels-photo-4386431.jpeg?auto=compress&cs=tinysrgb&w=1600',
        },
        {
          number: '03',
          title: 'Bank-backed assurance',
          text: 'Major banks back every deal, protecting trust and the rights of every party.',
          icon: 'verified_user',
          image:
            'https://images.unsplash.com/photo-1684679674829-fc7b436ec8e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fGJhbmt8ZW58MHx8MHx8fDA%3D',
        },
        {
          number: '04',
          title: 'The real estate revolution',
          text: 'We replace the traditional middleman with a system built to protect your rights.',
          icon: 'handshake',
          image:
            'https://plus.unsplash.com/premium_photo-1725404428224-664f5f0217b3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE3fHxiYW5rfGVufDB8fDB8fHww',
        },
        {
          number: '05',
          title: 'International reach',
          text: 'Invest in and swap property across 100 countries, backed by government and bank partners.',
          icon: 'globe',
          image:
            'https://images.pexels.com/photos/346885/pexels-photo-346885.jpeg?auto=compress&cs=tinysrgb&w=1600',
        },
        {
          number: '06',
          title: 'Fair appraisal',
          text: 'Mandatory technical and legal appraisal means every deal closes at a fair price.',
          icon: 'balance',
          image:
            'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROsHUFQ9710us1aVf1Y9bcVPYkRwgFkpT7ADE6yDkLkg&s',
        },
      ],
    },
    goalsSection: {
      eyebrow: 'Our mission',
      title: 'Objectives of the Real Estate Club',
      subtitle:
        'Five strategic objectives drawn from the Real Estate Club founding study.',
      items: [
        {
          title: 'Spread real estate awareness',
          text: 'Spread real estate awareness and culture among every participant in the market.',
        },
        {
          title: 'Mainstream real estate culture',
          text: 'Generalize the idea of real estate culture so it becomes a shared language in the market.',
        },
        {
          title: 'World-class best practices',
          text: 'Diffuse the world\'s best real estate practices into the local market.',
        },
        {
          title: 'Integrated marketing with data',
          text: 'Deliver every real estate marketing service and supply the data needed to achieve creative, non-traditional outcomes.',
        },
        {
          title: 'Elevate the sector',
          text: 'Advance the real estate sector and create innovative solutions for sales and marketing.',
        },
      ],
    },
    ideasHome: {
      eyebrow: 'Exclusive ideas',
      titleLead: "HOLOL's",
      titleHighlight: 'Investment Innovations',
      certificate: {
        title: 'Real Estate Investment Certificate',
        text: 'Own your property today and recover its full purchase value with a bank guarantee.',
      },
      supermarket: {
        title: 'The Real Estate Supermarket',
        text: 'Global properties and integrated services under one roof.',
      },
      cta: 'View all ideas',
    },
    founderHome: {
      eyebrow: 'The founder',
      title:
        "The founder's vision: reshaping real estate culture through media and direct solutions",
      name: 'Dr. Adham El-Sharkawy | Founder of Holol Global Real Estate Club',
      text:
        'We did not create Holol to be one more real estate platform: we launched it as a strategic engine that reshapes global real estate culture by merging the power of media with the intelligence of technology. We start from our conviction that specialised media is the real manager of the economy, and from there we are building the single global reference that connects individuals and institutions across 100 countries to an investment environment that is safe, transparent and free of middlemen, founded on fairness and true value.',
    },
    investmentHome: {
      eyebrow: 'Investment opportunity',
      title: 'The investment opportunity in HOLOL',
      subtitle:
        'A strategic invitation to major investors, family offices and private wealth managers around the world.',
      paragraphs: [
        'Holol Global Real Estate Club is the first ecosystem of its kind, built on an innovative investment model that redefines how real estate wealth is managed and grown internationally. The club rests on a multi-revenue platform that secures the highest levels of financial hedging and a wide spread of cash-flow sources: recurring membership fees and the accredited technical services package, international property auctions and cross-border property exchange, through to media sponsorships, exhibitions and conferences, and commissions on major institutional deals.',
        'The model is completed by a staged expansion plan that starts in 15 countries and reaches 100 countries worldwide within 5 years, giving investment partners and wealth managers an exceptional opportunity to share in the ownership and the growth of a secure, sustainable global economic platform.',
      ],
      cta: 'Learn more',
    },
    membershipHome: {
      eyebrow: 'Smart memberships',
      title: 'Invest smartly with smart memberships from Holol Global Real Estate Club',
      text:
        'At Holol Global Real Estate Club we created the smart membership system as a revolutionary alternative to commissions, saving our corporate, individual and government clients millions of dollars every year. Join us today and enjoy exclusive advantages and vast savings on all of your real estate transactions.',
      cta: 'Discover memberships',
    },
    ctaBanner: {
      title: 'Shape your real estate future today — join the elite!',
      subtitle: 'One alliance for individuals, companies, banks, clubs and government bodies.',
      primary: 'Join the club',
      secondary: 'Contact us',
    },
    comingSoon: {
      title: 'Holol Real Estate Club',
      subtitle:
        'A new era of solutions… we bring you an unmatched real estate experience.',
    },
    visualHook: {
      mapTitle: 'Global reach map',
      mapSubtitle: '100 target countries highlighted within a collaborative real estate–media network.',
      revolutionTitle: 'The real estate revolution',
      revolutionText:
        'The first global real estate club driven by media and artificial intelligence — no commissions and no middlemen.',
      mediaEngineTitle: 'Media integration',
      mediaEngineText:
        'A daily model that turns property into compelling media through television programming, social platforms, and global media partnerships.',
      uspsTitle: 'Innovative solutions',
      uspsItems: [
        'The Real Estate Certificate: higher financial security and guaranteed trust in the transaction.',
        'The property supermarket: a global property “shopping” experience in one click.',
      ],
      noCommissionTitle: 'A club system without commissions',
      noCommissionText:
        'A smart membership model that ends the traditional middleman role and delivers large savings for customers and investors.',
      partnersTitle: 'Strategic partners',
      partners: ['Banks', 'Government agencies', 'Media channels', 'Technology platforms'],
      expoTitle: 'The permanent global exhibition',
      expoText:
        'A digital–physical vision of a major annual global forum that brings sellers, buyers, companies, and institutions together on one platform.',
    },
    whoWeAre: {
      pageTitle: '',
      pageSubtitle: 'Holol Real Estate Club',
      visionTitle: 'Vision',
      visionText:
        'To be the world\'s foremost engine reshaping real estate culture through a digital and media ecosystem that crosses borders, becoming the sole trusted reference for safety and professionalism in assets.',
      missionTitle: 'Mission',
      missionText:
        'Empowering the global real estate community — individuals, institutions, and nations — through an integrated investment environment that merges media strength with technology intelligence to deliver comprehensive real estate solutions without commissions or intermediaries, founded on absolute transparency, justice, and true value.',
      goalsTitle: 'Our strategic objectives',
      goals: [
        'Thought leadership: spread and deepen sound real estate awareness and culture, and correct prevailing misconceptions in the market.',
        'Operational breadth: deliver an integrated suite of 20 real estate services under one administrative roof.',
        'Digital globalization: link real estate markets across 100 countries through one unified management system that ensures smooth exchange and investment.',
        'Institutional safety: make professional appraisal and legal protection baseline rights for every party in the ecosystem.',
      ],
      partnersTitle: 'Our messages to partners in success',
      partnersHint: 'Choose a segment to read its tailored message.',
      partnerMessages: [
        {
          id: 'individuals',
          label: 'To individuals',
          message:
            'Your property is your most precious holding, and protecting it is our first duty. We give you an environment to buy and sell with dignity and transparency, with fair value and full legal safety — without extra burdens or hidden commissions.',
        },
        {
          id: 'companies',
          label: 'To real estate companies and developers',
          message:
            'We are your global, intelligent marketing arm. We open the doors of 100 countries to you and turn your projects into success stories broadcast on major media platforms, carrying your product to the serious investor wherever they are.',
        },
        {
          id: 'banks',
          label: 'To banks and financial institutions',
          message:
            'We are the partner that guarantees seriousness and quality for you. We offer a rigorously appraised and inspected property portfolio and serious clients, reducing credit risk and opening new horizons for sustainable real estate financing programs.',
        },
        {
          id: 'clubs',
          label: 'To clubs',
          message:
            'We are here to add real value for your members; Holol Club is not a rival, but the umbrella that gives your members exclusive real estate privileges and investment security that strengthens their wellbeing and confidence.',
        },
        {
          id: 'governments',
          label: 'To governments and sovereign institutions',
          message:
            'We are the bridge that carries your nations\' visions to the world stage. We deploy our media and technology power to market national projects and smart cities, drawing international investment that matches your great national ambitions.',
        },
      ],
    },
    founder: {
      heroEyebrow: 'Founder',
      heroName: 'Dr. Adham El-Sharkawy',
      heroRole: 'Strategic expert in media and investment venture development',
      heroTagline: 'More than 25 years of leadership experience',
      introVideo: {
        eyebrow: 'Watch',
        title: 'Can media be more than just news?',
        text: 'Can it serve as an active driver of economic growth?\n\nAcross a 25+ year journey at the intersection of economic media, investment, and real estate, one principle has remained clear: developmental media should not merely report on the market—it should help manage, direct, and build economic opportunities.\n\nIn this brief video, I share the key milestones that shaped the founding vision behind Holol, and how we are bridging market intelligence with strategic media through our three core pillars:\n• Holol Consulting • Holol Media • Holol Real Estate Club.',
        attribution: 'Dr. Adham El-Sharkawy — Founder & President, Holol Global Real Estate Club',
        videoSrc: 'https://www.youtube.com/watch?v=RXlpdTghpM8',
        videoPlaceholder: 'Video coming soon',
      },
      aboutEyebrow: 'About',
      aboutTitle: 'Professional Profile',
      aboutTags: [
        '25+ Years Experience',
        'Media × Business Alliances',
        'Consulting & Real Estate',
        'Regional & International Scope',
      ],
      aboutText:
        'An entrepreneur and strategic concept developer with more than 25 years building and leading major economic entities. He specializes in designing strategic alliances that unite media power, digital solutions, and investment reality. He is known for turning complex visions into successful national and regional projects, with special depth in consulting and real estate.',
      careerEyebrow: 'Career',
      careerTitle: 'Key Milestones',
      careerSubtitle: 'A career that connects media power with investment reality',
      milestones: [
        {
          num: '01',
          org: 'CBC TV channels group',
          role: 'Director of media project development',
          bullets: [
            'Led innovation and the development of investment-oriented content within one of the largest media groups in the Middle East.',
            'Built a shared language between traditional media and the business community and strengthened institutional impact.',
          ],
        },
        {
          num: '02',
          org: '“Mazadat” project',
          role: 'Founder and originator',
          bullets: [
            'Vision and hands-on leadership of the first project combining visual media with real estate and investment exchange, in partnership with CBC.',
            'Evolved the idea of televised auctions into an effective economic instrument, with documented on-screen successes.',
          ],
        },
        {
          num: '03',
          org: 'Banan Group',
          role: 'Institutional leadership — general manager',
          bullets: [
            'Banan Integrated Solutions: administrative and strategic systems.',
            'Banan Real-Estate Marketing: major portfolio management.',
            'Banan Strategic & Marketing Services: brand building and market development.',
          ],
        },
      ],
      media: {
        eyebrow: 'Media & presence',
        title: '“Mazadat” program',
        subtitle:
          '“Mazadat” program | Dr. Adham El-Sharkawy on activating the project with Major General Tariq Mahdi, Governor of Alexandria.',
        videoSrc: 'https://www.youtube.com/watch?v=eklsLyv3sUc&t=1s',
        linksTitle: 'Contact Dr. Adham El-Sharkawy',
        links: [
          { label: 'www.holol.club', href: 'https://www.holol.club/', icon: 'language' },
          { label: 'adhamelsharkawy.com', href: 'https://www.adhamelsharkawy.com/', icon: 'work' },
          { label: 'Facebook | dr.adhamelsharkaawy', href: 'https://www.facebook.com/dr.adhamelsharkaawy/', icon: 'public' },
          { label: 'YouTube | adhamelsharkaawy', href: 'https://www.youtube.com/@adhamelsharkaawy', icon: 'language' },
          { label: 'LinkedIn | adhamelsharkaawy', href: 'https://www.linkedin.com/in/adhamelsharkaawy/', icon: 'work' },
        ],
      },
      visionEyebrow: "What's next",
      visionTitle: 'Current Vision',
      visionIntro:
        'Dr. Adham now channels decades of expertise into building the next generation of clubs and platforms, including:',
      visionItems: [
        {
          num: '01',
          title: 'Holol Consulting Club',
          text: 'A digital consulting franchise powered by artificial intelligence and media.',
        },
        {
          num: '02',
          title: 'Holol Real Estate Club',
          text: 'A global platform for exchanging and managing real estate services (50 integrated services).',
        },
        {
          num: '03',
          title: 'Holol Media (media solutions)',
          text: 'The media and production arm that will lead investment content across 50 countries.',
        },
      ],
      philosophyEyebrow: 'Work philosophy',
      philosophyQuote:
        'Media is not merely a publishing tool; it is the fundamental engine for steering global ideas and building trust in markets.',
      philosophyAttribution: 'Dr. Adham El-Sharkawy',
      ctaJoin: 'Join the Club',
      ctaHome: 'Back to Home',
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Contact us',
      subtitle: 'Reach our team directly by email or phone.',
      phoneLabel: 'Phone Number',
      phoneValue: '+44 7832 180705',
      phoneHref: '++447832180705',
      emailLabel: 'Email Address',
      emailValue: 'info@hololrealestate.club',
      whatsappAria: 'Chat with us on WhatsApp',
    },
    footer: {
      brand: 'The Real Estate Club',
      tagline: 'A project by Holol Global Company — Dr. Adham El-Sharkawy.',
      copy: '© 2026 The Real Estate Club. All rights reserved.',
      socialNavAria: 'Social media and websites',
      socialLinks: [
        { label: 'Holol Club website', href: 'https://www.holol.club/', iconId: 'globe' },
        { label: 'AdhamElSharkawy.com', href: 'https://www.adhamelsharkawy.com/', iconId: 'link' },
        { label: 'Facebook', href: 'https://www.facebook.com/dr.adhamelsharkaawy/', iconId: 'facebook' },
        { label: 'YouTube', href: 'https://www.youtube.com/@adhamelsharkaawy', iconId: 'youtube' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/company/hololrealestateclub', iconId: 'linkedin' },
      ],
    },
    servicesPage: {
      eyebrow: 'Club services',
      title: 'Comprehensive real estate solutions',
      subtitle:
        '20 integrated services covering the full property lifecycle — from purchase and financing through contracting, finishing, and furnishing.',
      features: [
        {
          title: 'Buying and selling',
          text: 'Buying and selling for individuals and companies directly through the club, without commissions.',
          icon: 'real_estate_agent',
        },
        {
          title: 'Real estate exchange',
          text: 'Real estate exchange service in an organized, transparent manner.',
          icon: 'swap_horiz',
        },
        {
          title: 'Real estate financing',
          text: 'Real estate financing solutions supported by partner banks and tailored to each client.',
          icon: 'account_balance',
        },
        {
          title: 'Real estate appraisal',
          text: 'Precise appraisals grounded in data, market analytics, and field expertise.',
          icon: 'analytics',
        },
        {
          title: 'Legal consulting',
          text: 'Contract review, legal structuring, and specialized follow-up.',
          icon: 'gavel',
        },
        {
          title: 'Auctions',
          text: 'Exclusive real estate auctions, including auctions dedicated to partner banks.',
          icon: 'campaign',
        },
        {
          title: 'Contracting and construction',
          text: 'Full management of contracting and construction for clients and partners.',
          icon: 'construction',
        },
        {
          title: 'Decor and finishing',
          text: 'Interior upgrades and distinguished finishes that raise property value.',
          icon: 'format_paint',
        },
        {
          title: 'Furnishing and furniture',
          text: 'Complete furnishing and outfitting services for residential and commercial properties.',
          icon: 'chair',
        },
      ],
    },
    servicesCatalog: {
      groups: [
        {
          label: 'Primary engines',
          title: 'Core services',
          items: [
            {
              id: '01',
              name: 'Buying and selling (individuals and companies)',
              video: buyingandselling,
              platformTitle: 'Solutions market: direct deals without limits',
              marketing:
                'A smart platform that gathers serious buyers and sellers in one place. We abolish traditional commissions and intermediaries to give you the best real estate value with the highest transparency standards — whether you are an individual seeking a home or a company managing a large portfolio.',
              detail: {
                heroDesc:
                  "Professionalism, speed, and legal security — a buying and selling system that is nothing like traditional brokerage",
                details: [
                  "Buying and selling at Holol Real Estate Club is the primary engine of the market — but operating on a model that fundamentally differs from traditional brokerage. The focus is on professionalism, speed, legal security, and services calibrated for both individuals seeking a home and corporations acquiring landmark assets.",
                  "From off-market property access and expert negotiation to PropTech virtual tours, interactive price maps, and watertight Escrow-backed contracts, our 25 professional services cover every stage of a transaction for every type of buyer and seller.",
                  "Members replace the commission with a smart membership that connects them directly to serious counterparties, elite deal flow, and full legal protection — making every transaction faster, cheaper, and safer.",
                ],
                categories: [
                  {
                    title: "I. Buyer's services",
                    icon: "search",
                    services: [
                      { name: "Bespoke property hunting", desc: "A dedicated team searching for properties that match the client's exact criteria — location, budget, and intended use." },
                      { name: "Off-market access", desc: "Members get priority access to exclusive deals before they are offered to the general public." },
                      { name: "Fair market value analysis", desc: "A report clarifying whether the asking price is fair or inflated, benchmarked against real comparable transactions in the area." },
                      { name: "Professional negotiation", desc: "Taking over the negotiation on behalf of the client to achieve the lowest price and best payment terms." },
                      { name: "Technical & structural inspection", desc: "A structural and systems survey of the property before purchase — walls, plumbing, and electrical integrity verified." },
                      { name: "Mortgage facilitation", desc: "Connecting buyers to the best financing programmes from the Club's partner banks at the most competitive rates." },
                    ],
                  },
                  {
                    title: "II. Seller's services",
                    icon: "sell",
                    services: [
                      { name: "Smart pricing strategy", desc: "Setting the optimal asking price that guarantees a fast sale without leaving value on the table." },
                      { name: "Professional media package", desc: "Photography, drone footage, and cinematic video production for compelling property marketing." },
                      { name: "Elite investor outreach", desc: "Presenting the property directly to the database of 100 influential investors and companies inside the Club." },
                      { name: "Open house event management", desc: "Organising structured viewing events for a group of serious buyers simultaneously — creating healthy competitive tension." },
                      { name: "Buyer qualification & screening", desc: "Verifying the financial credibility of every prospective buyer before committing the seller's time to viewings." },
                    ],
                  },
                  {
                    title: "III. Corporate & B2B services",
                    icon: "domain",
                    services: [
                      { name: "Corporate headquarters acquisition", desc: "Helping companies identify premises that match their operational scale and institutional image." },
                      { name: "Raw land acquisition", desc: "End-to-end services for purchasing development-ready land — residential, commercial, and industrial." },
                      { name: "Bulk purchase deals", desc: "Acquiring full floors or entire buildings for resale or portfolio rental income strategies." },
                      { name: "Portfolio analysis & repositioning", desc: "Reviewing a company's property assets and recommending strategic sales to reposition into higher-yield locations." },
                      { name: "Exit strategy planning", desc: "Planning the timing and method of asset disposal to maximise capital gains at the point of sale." },
                    ],
                  },
                  {
                    title: "IV. Legal security & documentation",
                    icon: "gavel",
                    services: [
                      { name: "Full legal due diligence", desc: "Tracing ownership history and confirming the property is free of planning violations, debts, or encumbrances." },
                      { name: "Neutral Escrow service", desc: "Securing contract funds in the Club's neutral Escrow account until title transfer is officially completed." },
                      { name: "Legally airtight contract drafting", desc: "Preparing sale and purchase agreements with zero loopholes — fully protecting both parties against future disputes." },
                      { name: "Title registration & transfer management", desc: "Handling all government procedures at land registry offices through to issuance of the new title deed." },
                    ],
                  },
                  {
                    title: "V. PropTech transaction tools",
                    icon: "devices",
                    services: [
                      { name: "Virtual reality property tours", desc: "Enabling international buyers to walk through a property as if they were physically inside it — from anywhere in the world." },
                      { name: "Real-time property alerts", desc: "Instant notifications to members the moment a property matching their saved preferences becomes available." },
                      { name: "Interactive price heat map", desc: "Clients can view average sale prices in any area at the touch of a button for fully informed decision-making." },
                    ],
                  },
                  {
                    title: "VI. Value-added services",
                    icon: "add_circle",
                    services: [
                      { name: "Post-purchase concierge", desc: "Connecting buyers immediately to décor, contracting, and property management services the moment the deal closes." },
                      { name: "Real estate tax advisory", desc: "Expert guidance on managing fees and taxes arising from the transaction in a legally sound and financially efficient way." },
                    ],
                  },
                ],
              },
            },
            {
              id: '02',
              name: 'International real estate exchange',
              video: exchange,
              platformTitle: 'Asset barter: exchange your property worldwide',
              marketing:
                'The breakthrough solution for moving your investments across continents. Exchange your property in one country for another in a different country through a precise appraisal system that balances opportunities and protects assets.',
              detail: {
                heroDesc:
                  "Sell and buy in a single step — the smart asset exchange system that eliminates commissions, unlocks frozen capital, and repositions portfolios across borders",
                details: [
                  "Real estate exchange at Holol Club is one of the most powerful tools driving the property revolution — because it relies on asset intelligence rather than cash alone, saving investors enormous sums in commissions and taxes.",
                  "From dual comparative appraisals and AI-powered smart matchmaking to cross-border swaps, land-for-units developer models, and elite closed-circle VIP exchanges, our 25 professional services cover every scenario where exchange outperforms a conventional sale.",
                  "The result: investors move from stagnant sectors to active ones, portfolios are repositioned with minimal friction, and liquidity problems are solved without ever requiring a cash sale.",
                ],
                categories: [
                  {
                    title: "I. Matching & valuation services",
                    icon: "compare_arrows",
                    services: [
                      { name: "Dual comparative appraisal", desc: "Independent valuation of both properties in the exchange to guarantee price fairness based on actual market value." },
                      { name: "Smart matchmaking algorithm", desc: "A technology system that matches exchange requests intelligently — e.g. a land owner seeking apartments paired with the right counterpart." },
                      { name: "Heterogeneous asset exchange", desc: "Exchanging a residential property for a commercial or administrative one to restructure an investment portfolio." },
                      { name: "Best-use analysis", desc: "Assessing whether the exchange will generate a higher investment return for both parties than holding the current asset." },
                    ],
                  },
                  {
                    title: "II. Innovative exchange models",
                    icon: "swap_horiz",
                    services: [
                      { name: "Land-for-units exchange", desc: "Developer model: exchanging raw land for a percentage of the completed units to be built on it." },
                      { name: "Off-plan-for-ready exchange", desc: "Swapping an under-construction unit for a ready-to-occupy or immediately rentable completed property." },
                      { name: "Bulk portfolio swap", desc: "Exchanging multiple small units as a package for a single administrative building or hotel asset." },
                      { name: "Cross-border international swap", desc: "Exchanging a property in one country for a property in another within Holol Club's global network." },
                      { name: "Upgrade swap", desc: "Trading an older or smaller property for a newer or larger one, with the price difference settled separately." },
                    ],
                  },
                  {
                    title: "III. Financial engineering & cash solutions",
                    icon: "calculate",
                    services: [
                      { name: "Boot financing (price-gap funding)", desc: "Financing solutions for the party required to pay the cash difference in value between the two exchanged properties." },
                      { name: "Mortgage clearance for exchange", desc: "Resolving banking encumbrances on mortgaged properties to enable a clean exchange transaction." },
                      { name: "Tax optimisation advisory", desc: "Legal consulting to minimise taxes and government fees generated by the exchange versus a conventional sale-and-purchase." },
                      { name: "Timed financial escrow", desc: "Securing cash differentials in a neutral escrow account until simultaneous title transfer is completed for both properties." },
                    ],
                  },
                  {
                    title: "IV. Legal, documentation & escrow",
                    icon: "gavel",
                    services: [
                      { name: "Barter & exchange contracts", desc: "Drafting professional exchange agreements that protect both parties' rights and prevent future disputes." },
                      { name: "Dual legal due diligence", desc: "Verifying the title documents and encumbrance-free status of both properties before the exchange proceeds." },
                      { name: "Escrow & neutral settlement", desc: "Acting as an independent neutral party to guarantee simultaneous ownership transfer to both sides." },
                      { name: "Coordinated title registration", desc: "Completing ownership transfer procedures at government land registries for both properties simultaneously." },
                    ],
                  },
                  {
                    title: "V. Technical & logistical services",
                    icon: "engineering",
                    services: [
                      { name: "Dual structural condition report", desc: "Technical and engineering survey of both properties to identify any hidden defects before the exchange is finalised." },
                      { name: "Renovation-for-exchange service", desc: "Raising the value of the weaker property through targeted rapid refurbishment to improve its acceptance in a strong exchange." },
                      { name: "Exchange marketing content", desc: "Professional photography and listing of each property in the platform's dedicated exchange section, highlighting its swap strengths." },
                    ],
                  },
                  {
                    title: "VI. VIP & elite exchange services",
                    icon: "workspace_premium",
                    services: [
                      { name: "Closed VIP exchange circle", desc: "A private network for major investors to exchange palaces, hotels, and large land holdings away from public listings." },
                      { name: "Usufruct right exchange", desc: "Swapping rental yields or occupancy rights for a defined period without transferring the underlying property ownership." },
                      { name: "Real estate-for-equity exchange", desc: "Exchanging a property for shares in a real estate development company or investment fund." },
                      { name: "Exchange with full maintenance guarantee", desc: "Guaranteeing the new property is delivered with a complimentary one-year maintenance contract." },
                      { name: "Portfolio repositioning consultancy", desc: "A strategic plan showing the investor how to migrate from a stagnant sector to an active one through a chain of smart exchanges." },
                    ],
                  },
                ],
              },
            },
            {
              id: '03',
              name: 'Professional real estate appraisal',
              video: realestateappraisal,
              platformTitle: 'The value scale: the appraisal you trust',
              marketing:
                'We steer real estate culture by making professional appraisal a baseline standard. No more random pricing: every property in the club is documented with technical and legal appraisal that gives you full confidence before you decide.',
              detail: {
                heroDesc:
                  "Professional appraisal built on international standards (RICS / IVS) and powered by AI — giving banks, companies, and investors the most accurate property values for confident decision-making",
                details: [
                  "Holol Club's professional appraisal service replaces guesswork with precision. By adopting international appraisal standards — RICS and IVS — and combining them with artificial intelligence, we deliver reports that banks trust for financing, companies rely on for financial reporting, and investors use to make high-stakes decisions.",
                  "From mortgage valuations and IFRS asset reporting to legal dispute appraisals and PropTech-powered automated models, our 25 specialized services cover every scenario where an accurate property value is required.",
                  "Our certified valuers operate across the GCC and Arab markets, delivering RICS-compliant reports accepted by regulators, courts, and financial institutions.",
                ],
                categories: [
                  {
                    title: "I. Financial & banking appraisal",
                    icon: "account_balance",
                    services: [
                      { name: "Mortgage appraisal", desc: "Certified reports delivered to banks and financing institutions to support loan origination and property-backed lending." },
                      { name: "Asset valuation for financial reporting (IFRS)", desc: "Estimating the fair value of company-owned real estate assets for inclusion in annual balance sheets under IFRS standards." },
                      { name: "Liquidation value appraisal", desc: "Estimating the realisable price of a property in forced-sale or insolvency scenarios for creditor protection." },
                      { name: "Reinstatement value for insurance", desc: "Estimating the cost of rebuilding a property after a disaster to establish the correct insurance policy coverage." },
                    ],
                  },
                  {
                    title: "II. Investment & strategic appraisal",
                    icon: "trending_up",
                    services: [
                      { name: "Highest & best use (HBU) analysis", desc: "Analysing a property to identify the activity that achieves the maximum financial return and market value." },
                      { name: "Real estate portfolio appraisal", desc: "Valuing hundreds of units in a single engagement for investment funds and REITs requiring bulk portfolio assessments." },
                      { name: "Usufruct & leasehold valuation", desc: "Estimating the value of the right to use or operate a property over long-term periods without ownership transfer." },
                      { name: "Fair rental yield analysis", desc: "Determining the true market rental value to prevent landlord losses and ensure investor returns are benchmarked accurately." },
                    ],
                  },
                  {
                    title: "III. Legal & judicial appraisal",
                    icon: "gavel",
                    services: [
                      { name: "Estate & inheritance appraisal", desc: "Dividing real estate assets among heirs based on independent and defensible fair market value assessments." },
                      { name: "Litigation appraisal", desc: "Providing certified expert witness appraisal reports accepted by courts in property-related disputes." },
                      { name: "Merger & acquisition appraisal", desc: "Estimating the value of real estate assets during corporate mergers, acquisitions, or company sales." },
                      { name: "Tax & zakat appraisal", desc: "Estimating the taxable value of properties for real estate tax or sharia-compliant zakat purposes." },
                    ],
                  },
                  {
                    title: "IV. Technical appraisal for projects & development",
                    icon: "construction",
                    services: [
                      { name: "Raw land appraisal", desc: "Estimating land value based on future development potential using the residual value method." },
                      { name: "Under-construction project appraisal", desc: "Estimating the value of completed work to date and the budget required to reach practical completion." },
                      { name: "Distressed property appraisal", desc: "Analysing the causes of distress and estimating current market value against the cost of remediation." },
                      { name: "Green & sustainable building valuation", desc: "Quantifying the value premium delivered by energy-efficient, environmentally certified properties." },
                    ],
                  },
                  {
                    title: "V. PropTech & smart valuation",
                    icon: "smart_toy",
                    services: [
                      { name: "Automated valuation model (AVM)", desc: "Instant AI-powered property valuations based on real-time market data and algorithmic analysis." },
                      { name: "Big data & price trend analysis", desc: "Monitoring price movements in surrounding areas to forecast future property values with statistical confidence." },
                      { name: "GIS geographic valuation", desc: "Linking property value to urban master plans, infrastructure projects, and national development initiatives in the vicinity." },
                      { name: "Portfolio value monitor", desc: "Quarterly updates to the client's real estate portfolio value, alerting them to material increases or decreases." },
                    ],
                  },
                  {
                    title: "VI. Specialized niche appraisal",
                    icon: "hotel",
                    services: [
                      { name: "Hotel & hospitality valuation", desc: "Specialised appraisal based on room count, occupancy rates, RevPAR, and operating income methodology." },
                      { name: "Industrial & warehousing appraisal", desc: "Valuation based on storage capacity, logistics infrastructure, and operational efficiency parameters." },
                      { name: "Medical centres & hospital valuation", desc: "Applying specialist criteria based on equipment, licensing, and operational cash flows." },
                      { name: "Shopping mall valuation", desc: "Appraising retail developments based on footfall, anchor tenants, and purchasing power of the catchment area." },
                      { name: "Second opinion appraisal", desc: "Independent review of valuation reports issued by other parties to verify their accuracy and credibility." },
                    ],
                  },
                ],
              },
            },
            {
              id: '04',
              name: 'Real estate auctions',
              video: auctions,
              platformTitle: 'The deal stage: auctions in the spotlight',
              marketing:
                'Media power in service of real estate. We turn distinguished properties into winning deals through professionally run public auctions that reach millions of interested viewers via our partner media channels — securing the highest price and fastest liquidity.',
              detail: {
                heroDesc:
                  "The most powerful tool for converting property into liquidity — a global digital auction platform backed by AI, live streaming, and blockchain transparency",
                details: [
                  "Real estate auctions at Holol Club are the heartbeat of fast, transparent sales. We have transformed the auction from a local gathering into a global digital platform that connects property owners with serious international investors in real time.",
                  "From pre-auction legal due diligence and AI-powered appraisals to live-streamed bidding, proxy systems, VR property tours, and blockchain-recorded transactions, our 25 services cover every stage of the auction lifecycle.",
                  "Whether liquidating distressed assets, auctioning usufruct rights, or running a reverse acquisition process, Holol Club's auction infrastructure delivers maximum value with maximum transparency.",
                ],
                categories: [
                  {
                    title: "I. Pre-auction preparation & appraisal",
                    icon: "checklist",
                    services: [
                      { name: "Certified technical appraisal", desc: "Setting the opening price based on current market standards and projected cash flows, backed by a certified valuation report." },
                      { name: "Legal due diligence", desc: "Preparing a complete legal file for every auctioned property to guarantee it is free of disputes or encumbrances before listing." },
                      { name: "Auction feasibility study", desc: "Determining whether auction is the optimal sale method for a specific property to ensure the highest possible return for the owner." },
                      { name: "Bidding guarantee management", desc: "Managing bidder deposits via Escrow accounts to verify the financial seriousness of every participant before bidding opens." },
                    ],
                  },
                  {
                    title: "II. E-auction technology & smart bidding",
                    icon: "display_settings",
                    services: [
                      { name: "Live-streaming digital auction platform", desc: "Real-time audio and video online bidding accessible from anywhere in the world — no physical attendance required." },
                      { name: "Proxy bidding system", desc: "An intelligent system that allows bidders to set a maximum price and automatically bids on their behalf up to that ceiling." },
                      { name: "Virtual reality (VR) property tours", desc: "Full 360-degree immersive walkthroughs of every auctioned property available before the auction begins." },
                      { name: "Blockchain documentation", desc: "All bids recorded in a tamper-proof ledger providing the highest level of transparency and dispute-free audit trails." },
                    ],
                  },
                  {
                    title: "III. Auction marketing & reach",
                    icon: "campaign",
                    services: [
                      { name: "Targeted investor outreach", desc: "Reaching the 100 most influential investors in each target country — the exact audience most likely to drive the highest bid." },
                      { name: "Premium digital property catalogue", desc: "A professional profile for each property covering full technical, legal, and financial details in a polished presentation." },
                      { name: "Media exposure for major auctions", desc: "Leveraging the Club's TV programmes and social media ecosystem to amplify reach and drive competitive bidding." },
                      { name: "Pre-auction open house viewings", desc: "Organising structured viewing days for interested parties to inspect the property on-site before the auction date." },
                    ],
                  },
                  {
                    title: "IV. Live auction management",
                    icon: "gavel",
                    services: [
                      { name: "Professional auctioneer", desc: "Expert auction management that stimulates competition among bidders and drives the final price to its highest achievable level." },
                      { name: "Multi-currency live bidding", desc: "Real-time currency conversion for international bidders — removing all financial barriers to global participation." },
                      { name: "Real-time notification system", desc: "Instant mobile alerts to bidders the moment their offer is outbid, keeping them engaged and in the race." },
                      { name: "Sealed / closed auction management", desc: "Digital sealed-envelope bid submission for situations requiring full confidentiality and discretion." },
                    ],
                  },
                  {
                    title: "V. Financial support",
                    icon: "payments",
                    services: [
                      { name: "Pre-approved financing", desc: "Connecting bidders to partner banks for instant financing approval if the auction is knocked down in their favour." },
                      { name: "Price-gap payment facilities", desc: "Credit solutions that help investors bridge any gap between the winning bid and the funds immediately available." },
                      { name: "Instant payment collection", desc: "An electronic system that collects the deposit the moment the hammer falls, securing the deal without delay." },
                    ],
                  },
                  {
                    title: "VI. Post-auction services",
                    icon: "task_alt",
                    services: [
                      { name: "Fast title transfer", desc: "Completing all government and tax procedures immediately upon full payment to hand over clean title without delay." },
                      { name: "Property management for auction winners", desc: "Transitioning the acquired property directly to the Smart Asset Management division to begin generating returns immediately." },
                      { name: "Title insurance", desc: "An insurance policy guaranteeing the validity of ownership for the new buyer against any future legal challenges." },
                    ],
                  },
                  {
                    title: "VII. Specialized auction formats",
                    icon: "shuffle",
                    services: [
                      { name: "Distressed asset auctions", desc: "Liquidating bank-owned or corporate properties that require rapid conversion to cash at the best achievable market price." },
                      { name: "Usufruct right auctions", desc: "Auctioning the right to use and operate a property for extended periods — without transferring the underlying ownership." },
                      { name: "Reverse auctions", desc: "The Club posts a property acquisition brief and owners compete by bidding the lowest acceptable sale price." },
                    ],
                  },
                ],
              },
            },
            {
              id: '05',
              name: 'International trade finance',
              video: financing,
              platformTitle: 'Your gateway to global commerce: LCs, LGs & trade finance solutions',
              marketing:
                'We connect businesses to the full suite of international trade finance instruments — from documentary letters of credit and standby LCs to performance bonds and advance payment guarantees — backed by our strategic relationships with leading correspondent banks worldwide.',
              detail: {
                heroDesc:
                  "Securing cross-border transactions with precision — a complete LC, LG, and trade finance advisory platform backed by global banking networks",
                details: [
                  "Holol Consulting Club's international trade finance division is the bridge between ambition and execution in global commerce. We have built a comprehensive advisory and execution platform that equips businesses with the financial instruments they need to trade confidently across borders — from the first shipment to the largest long-term supply contract.",
                  "From documentary letters of credit (LCs) and standby LCs to performance bonds, advance payment guarantees, and tender bonds, our 25 specialised services cover every stage of the trade finance lifecycle — from structuring and issuance through to presentation, discounting, and settlement.",
                  "Whether your business is an importer seeking payment security, an exporter requiring working capital against confirmed LCs, or a contractor tendering on government projects requiring bid bonds, Holol Club's trade finance infrastructure delivers certainty, speed, and compliance at every step.",
                ],
                categories: [
                  {
                    title: "I. Letters of Credit (LCs) — core instruments",
                    icon: "receipt_long",
                    services: [
                      { name: "Documentary Letter of Credit (DLC)", desc: "The gold-standard trade payment mechanism — issued by the buyer's bank, guaranteeing payment to the seller upon presentation of compliant shipping documents." },
                      { name: "Standby Letter of Credit (SBLC)", desc: "A secondary guarantee instrument that pays only when the applicant defaults — widely used in project financing and recurring supply arrangements." },
                      { name: "Revolving Letter of Credit", desc: "A self-renewing credit facility for businesses with recurring import or export flows — eliminating the need to open a new LC for each transaction." },
                      { name: "Transferable & Back-to-Back LCs", desc: "Enabling middlemen, trading houses, and brokers to pass the credit to the actual supplier without exposing their margin or commercial relationship." },
                    ],
                  },
                  {
                    title: "II. Letters of Guarantee (LGs) — bid, performance & payment bonds",
                    icon: "verified_user",
                    services: [
                      { name: "Bid Bond (Tender Guarantee)", desc: "Issued to assure the tender authority that the bidder will sign the contract if awarded — a mandatory entry ticket for government and large corporate tenders." },
                      { name: "Performance Guarantee", desc: "Provides the project owner with a financial backstop if the contractor fails to deliver on the agreed scope, timeline, or quality standard." },
                      { name: "Advance Payment Guarantee", desc: "Returned to the employer if the contractor misuses or fails to account for the advance payment released at contract commencement." },
                      { name: "Warranty / Maintenance Guarantee", desc: "Covers the defects liability period post-completion, giving the client assurance that all rectification obligations will be honoured in full." },
                    ],
                  },
                  {
                    title: "III. Trade finance structuring & advisory",
                    icon: "account_balance",
                    services: [
                      { name: "Pre-trade documentation review", desc: "Reviewing contracts, purchase orders, and incoterms before issuance to ensure the LC or LG structure eliminates discrepancy risk from day one." },
                      { name: "LC negotiation & amendment management", desc: "Expert handling of LC amendments, extensions, and documentary discrepancies to prevent payment delays on both sides of the transaction." },
                      { name: "Bank-to-bank confirmation & re-issuance", desc: "Adding confirmation from a prime bank to reduce country and issuing-bank risk for exporters operating in volatile or emerging markets." },
                      { name: "SWIFT messaging compliance", desc: "Ensuring all MT700, MT760, and MT799 messages conform to UCP 600 and URDG 758 standards to avoid costly compliance failures." },
                    ],
                  },
                  {
                    title: "IV. Import & export financing",
                    icon: "import_export",
                    services: [
                      { name: "Pre-shipment export financing", desc: "Working capital secured against a confirmed LC or firm purchase order — enabling exporters to fund production without depleting cash reserves." },
                      { name: "Post-shipment LC discounting", desc: "Unlocking immediate liquidity by discounting accepted LCs or bills of exchange — converting future receivables into instant cash at competitive rates." },
                      { name: "Documentary collection services (D/P & D/A)", desc: "A lower-cost alternative to LCs — managing collections through our correspondent banking network to protect both buyer and seller interests." },
                      { name: "Import financing (Murabaha / deferred payment)", desc: "Sharia-compliant import payment facilities that allow importers to receive goods and settle within agreed credit terms." },
                    ],
                  },
                  {
                    title: "V. Risk management & trade credit insurance",
                    icon: "security",
                    services: [
                      { name: "Country & political risk assessment", desc: "Evaluating sovereign risk, payment transfer restrictions, and political instability before committing to trade terms with any new counterparty." },
                      { name: "Counterparty credit due diligence", desc: "Independent financial analysis of the buyer's or seller's creditworthiness — identifying red flags before the first LC is opened." },
                      { name: "Trade credit insurance placement", desc: "Arranging cover against buyer default or insolvency — enabling exporters to trade on open account terms with full financial protection." },
                      { name: "Foreign currency hedging advisory", desc: "Forward contract and option strategies to lock in exchange rates and eliminate FX volatility from international trade cash flows." },
                    ],
                  },
                  {
                    title: "VI. Digital trade finance & compliance",
                    icon: "cloud_sync",
                    services: [
                      { name: "Electronic LC (e-LC) platform", desc: "Issuing and processing LCs through digital trade finance platforms — reducing turnaround time, eliminating paper, and streamlining compliance." },
                      { name: "AML & sanctions screening", desc: "Automated screening of all trade finance transactions against global sanction lists to ensure full regulatory compliance and correspondent bank acceptability." },
                      { name: "Real-time transaction tracking dashboard", desc: "Full visibility of every LC and LG from issuance through presentation to settlement — with instant status alerts and audit trails." },
                      { name: "Trade finance training & capacity building", desc: "Workshops and certification programs for treasury and procurement teams on LC mechanics, discrepancy management, and trade finance best practices." },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'Engineering and execution solutions',
          title: 'Delivery services',
          items: [
            {
              id: '06',
              name: 'Contracting and construction',
              video: contractingandconstruction,
              platformTitle: 'Build system: we build your vision',
              marketing:
                'Our service does not stop at the sale. We provide an integrated contracting and construction system supervised by top engineers to deliver your projects with the highest quality and lowest cost, with full adherence to schedules.',
              detail: {
                heroDesc:
                  "Smart, sustainable construction solutions that translate blueprints into landmarks — lower cost, higher quality, zero compromise",
                details: [
                  "Holol Club's contracting and construction arm is the executive force behind the property revolution — transforming the traditional contractor model into smart, sustainable building solutions that save cost and raise quality simultaneously.",
                  "From integrated design-build delivery and value engineering to MEP systems, smart building infrastructure, green construction, and elite project rescue services, our 25 professional services cover every stage from ground break to handover.",
                  "Members benefit from access to the Club's vetted network of elite construction companies — delivering 5-star quality at competitive rates under rigorous technical supervision that tolerates no error.",
                ],
                categories: [
                  {
                    title: "I. Planning & pre-construction services",
                    icon: "architecture",
                    services: [
                      { name: "Integrated design-build", desc: "A complete solution from engineering drawings through to execution, ensuring full alignment between design vision and site reality." },
                      { name: "Value engineering", desc: "Reviewing designs to reduce costs without compromising quality, safety, or structural integrity." },
                      { name: "Soil investigation & foundation studies", desc: "Geotechnical assessment to verify building safety and determine the optimal foundation type for the site." },
                      { name: "Permits & regulatory approvals management", desc: "Managing all bureaucratic procedures with government authorities to enable a legally compliant project start." },
                    ],
                  },
                  {
                    title: "II. Structural & civil works",
                    icon: "foundation",
                    services: [
                      { name: "Reinforced concrete structure (black structure)", desc: "Executing foundations, columns, and slabs to the highest precision and structural standards." },
                      { name: "Steel structures", desc: "Constructing hangars, warehouses, and fast-assembly buildings using pre-engineered steel systems." },
                      { name: "Building restoration & structural strengthening", desc: "Treating cracks and reinforcing the structural frames of ageing or distressed buildings." },
                      { name: "Infrastructure works", desc: "Executing water networks, sewage systems, and road works for residential and mixed-use developments." },
                    ],
                  },
                  {
                    title: "III. Fit-out & finishing",
                    icon: "format_paint",
                    services: [
                      { name: "Luxury turnkey finishing", desc: "Delivering units fully completed to a 5-star hotel standard — ready to occupy from the moment of handover." },
                      { name: "Modern façade works", desc: "Installing curtain walls, cladding systems, and natural stone façades to the highest architectural standards." },
                      { name: "Waterproofing & thermal insulation", desc: "Protecting buildings from water ingress and improving energy efficiency through advanced insulation systems." },
                      { name: "Landscaping & outdoor works", desc: "Designing external spaces, swimming pools, and smart irrigation systems around the building." },
                    ],
                  },
                  {
                    title: "IV. Mechanical, electrical & plumbing (MEP)",
                    icon: "electrical_services",
                    services: [
                      { name: "Central HVAC systems", desc: "Designing and installing energy-efficient air conditioning and ventilation networks for all building types." },
                      { name: "Electrical works & smart lighting", desc: "Installing distribution boards and smart lighting networks that reduce consumption and enhance ambience." },
                      { name: "Fire protection systems", desc: "Installing alarm and automatic suppression systems fully compliant with civil defence requirements." },
                      { name: "Plumbing & drainage", desc: "Executing internal and external pipe networks using the latest materials and installation technologies." },
                    ],
                  },
                  {
                    title: "V. Construction technology & smart buildings",
                    icon: "smart_toy",
                    services: [
                      { name: "Smart infrastructure readiness", desc: "Equipping buildings with fibre optic networks and centralised control systems — smart home and BMS ready from day one." },
                      { name: "Solar energy systems", desc: "Installing photovoltaic panels to provide clean energy and significantly reduce utility bills for owners." },
                      { name: "Pre-cast construction", desc: "Using rapid pre-cast building technologies to compress timelines on large-scale projects." },
                      { name: "Green building solutions", desc: "Building with eco-certified materials to reduce carbon footprint, lower running costs, and extend asset lifespan." },
                    ],
                  },
                  {
                    title: "VI. Site management, quality & specialist services",
                    icon: "engineering",
                    services: [
                      { name: "Integrated engineering supervision", desc: "Resident engineers on-site ensuring every detail is executed exactly to specification and drawing." },
                      { name: "Project schedule management", desc: "Guaranteeing on-time delivery of projects and actively managing programmes to avoid delay penalties." },
                      { name: "Quality control & material testing", desc: "Laboratory testing of concrete and all structural materials to certify durability and compliance." },
                      { name: "Project rescue service", desc: "Taking over responsibility for completing stalled or technically distressed projects abandoned by previous contractors." },
                      { name: "Long-term structural maintenance contracts", desc: "Post-handover maintenance agreements covering the structural frame and core building systems for the long term." },
                    ],
                  },
                ],
              },
            },
            {
              id: '07',
              name: 'Interior design and furnishing',
              video: design,
              platformTitle: 'Solutions touches: art in the details',
              marketing:
                'Turn your walls into inspiring living spaces. We provide interior design, décor, and full furnishing with global touches that match your taste and add real investment value to your property.',
              detail: {
                heroDesc:
                  "The finishing touch that gives a property its soul and its value — design as an ROI tool, not just an aesthetic choice",
                details: [
                  "Interior design and furnishing at Holol Club is the art that transforms bare walls into living environments worth more than the sum of their materials. We position design not merely as aesthetics, but as a proven tool for raising ROI and making every property sale-ready or lease-ready at its highest possible price.",
                  "From immersive 3D visualisation and bespoke furniture fabrication to smart home integration, sustainable materials, and home staging for investors, our 25 professional services cover every dimension of interior space — residential, commercial, hospitality, and beyond.",
                  "Whether you are finishing a luxury residence, outfitting a hotel, staging a property for sale, or designing a high-performance office, the Club's network of elite interior specialists delivers world-class results with full turnkey accountability.",
                ],
                categories: [
                  {
                    title: "I. Design concept & visual identity",
                    icon: "palette",
                    services: [
                      { name: "3D interior visualisation", desc: "Photorealistic renders and virtual walkthroughs of the entire space before any physical work begins." },
                      { name: "Space planning", desc: "Intelligent layout of every square metre to maximise comfort, flow, and functional efficiency." },
                      { name: "Custom mood board", desc: "A curated board of materials, colours, and fabrics to align all stakeholders on the design vision before execution." },
                      { name: "Colour psychology consultancy", desc: "Selecting colours calibrated to the purpose of the space — productivity for offices, calm for homes, energy for retail." },
                      { name: "Specialist lighting design", desc: "Distributing light sources to accentuate décor features and achieve both aesthetic and functional objectives." },
                    ],
                  },
                  {
                    title: "II. Artistic finishes & décor execution",
                    icon: "brush",
                    services: [
                      { name: "Gypsum board suspended ceilings", desc: "Contemporary ceiling designs that elegantly conceal HVAC ducts, lighting tracks, and structural elements." },
                      { name: "Wall cladding — timber & marble", desc: "Adding luxury character using natural materials or their high-quality engineered equivalents." },
                      { name: "Wallpapers & decorative paint techniques", desc: "Advanced painting finishes and moisture-resistant, scratch-resistant wallcoverings applied with precision." },
                      { name: "Specialist flooring", desc: "Installing marble, natural hardwood parquet, or epoxy systems for industrial and commercial environments." },
                      { name: "Decorative metalwork", desc: "Stainless steel and brass elements for partitions, feature walls, and architectural accessories." },
                    ],
                  },
                  {
                    title: "III. Bespoke furniture & furnishing",
                    icon: "chair",
                    services: [
                      { name: "Custom furniture design & manufacture", desc: "Fabricating unique pieces designed specifically for the property's dimensions and the client's identity." },
                      { name: "Kitchen units & fitted wardrobes", desc: "Smart, modern built-in storage solutions integrated seamlessly into walls." },
                      { name: "Hospitality-grade furnishing", desc: "Outfitting hotel apartments and tourism projects with furniture meeting international durability standards." },
                      { name: "Soft furnishings & curtains coordination", desc: "Selecting fabrics and textiles that harmonise with the furniture style and colour palette." },
                      { name: "Art curation & decorative accessories", desc: "Sourcing artworks and collectibles that add both investment value and visual distinction to the space." },
                    ],
                  },
                  {
                    title: "IV. Smart & sustainable design",
                    icon: "smart_toy",
                    services: [
                      { name: "Smart home integration", desc: "Embedding control of lighting, curtains, and climate systems invisibly within the interior design." },
                      { name: "Eco-friendly & sustainable design", desc: "Using recycled materials and VOC-free paints to meet green building standards and health requirements." },
                      { name: "Indoor landscaping", desc: "Integrating living plants into interior spaces to improve air quality, wellbeing, and visual appeal." },
                      { name: "Acoustic treatment solutions", desc: "Sound insulation and acoustic design for meeting rooms, home cinemas, and noise-sensitive environments." },
                    ],
                  },
                  {
                    title: "V. Investor-focservices",
                    icon: "trending_up",
                    services: [
                      { name: "Home staging for sale", desc: "Furnishing the property with temporary, styled furniture to impress buyers instantly and accelerate the sale at a higher price." },
                      { name: "Economy investment furnishing packages", desc: "Furnishing rental apartments to the highest quality at the lowest cost — fastest path to positive cash flow." },
                      { name: "Office & corporate space fit-out", desc: "Designing work environments that motivate staff and project the company's strength to visiting clients." },
                      { name: "Furniture restoration & upcycling", desc: "Updating valuable existing pieces to integrate them into the new design in a contemporary, relevant way." },
                    ],
                  },
                  {
                    title: "VI. Logistics, delivery & aftercare",
                    icon: "local_shipping",
                    services: [
                      { name: "Full turnkey delivery", desc: "Complete end-to-end responsibility from the first design concept through to placing the last accessory in position." },
                      { name: "Annual décor & furniture maintenance contracts", desc: "Scheduled maintenance agreements to preserve the look, feel, and market value of the finished space over time." },
                    ],
                  },
                ],
              },
            },
            {
              id: '08',
              video: maintenance,
              name: 'Maintenance and restoration',
              platformTitle: 'Asset care: your property always safe',
              marketing:
                'Preserving property value begins with caring for its details. Our specialized team handles all routine maintenance and restoration to sustain quality and extend useful life.',
              detail: {
                heroDesc:
                  "Integrated engineering maintenance management — keeping every property at zero-defect standard and protecting owners from the cost of neglect",
                details: [
                  "Maintenance and restoration at Holol Club is the protective shield of every real estate asset — guaranteeing a property remains in peak condition regardless of age. We move beyond the traditional handyman model to deliver integrated engineering maintenance that raises market value and prevents the large repair bills that negligence always produces.",
                  "From annual maintenance contracts and predictive HVAC care to structural restoration, smart system upkeep, 24/7 emergency response, and full technical condition reports, our 25 professional services cover every physical and systems dimension of property care.",
                  "Whether you are protecting a residential unit, maintaining a commercial tower, or restoring a distressed asset to market readiness, the Club's certified maintenance engineers deliver consistent, documented results — with every intervention tracked and reported to the owner.",
                ],
                categories: [
                  {
                    title: "I. Preventive & periodic maintenance",
                    icon: "event_repeat",
                    services: [
                      { name: "Annual maintenance contracts (AMC)", desc: "Subscription packages covering periodic inspection of all building systems — electrical, plumbing, and HVAC." },
                      { name: "HVAC system maintenance", desc: "Filter cleaning, refrigerant level checks, and unit servicing to ensure consistent cooling efficiency year-round." },
                      { name: "Electrical network periodic inspection", desc: "Load testing, circuit breaker checks, and connection integrity verification to prevent fire hazards." },
                      { name: "Plumbing & drainage maintenance", desc: "Early leak detection, tank cleaning, and pump efficiency inspection to prevent water damage." },
                      { name: "Swimming pool & water feature maintenance", desc: "Water sanitation, filter inspection, and submerged lighting servicing for pools and decorative water features." },
                    ],
                  },
                  {
                    title: "II. Structural restoration",
                    icon: "foundation",
                    services: [
                      { name: "Crack & fissure treatment", desc: "Repairing structural and surface cracks using specialist chemical compounds designed for long-term durability." },
                      { name: "Column & slab strengthening", desc: "Reinforcing concrete structures in ageing buildings to extend their design life significantly." },
                      { name: "Steel reinforcement corrosion treatment", desc: "Removing rust from rebar and applying epoxy anti-corrosion coatings to protect structural integrity." },
                      { name: "Façade restoration", desc: "Refreshing paint finishes, treating stone surfaces, or upgrading cladding systems to restore the property's appearance." },
                      { name: "Roof & bathroom waterproofing renewal", desc: "Replacing degraded waterproofing and thermal insulation membranes using the latest technologies to eliminate water ingress." },
                    ],
                  },
                  {
                    title: "III. Corrective maintenance & finishing repairs",
                    icon: "build",
                    services: [
                      { name: "Marble & floor polishing", desc: "Restoring the lustre of floors and repairing deteriorated grout joints to renew surface appearance." },
                      { name: "Wall & ceiling repainting", desc: "Fast, clean painting services to refresh room aesthetics with minimal disruption to occupants." },
                      { name: "Carpentry & door maintenance", desc: "Repairing doors, windows, and kitchen units, and replacing worn fittings and hardware." },
                      { name: "Aluminium & glazing repairs", desc: "Servicing uPVC and aluminium window systems to maintain sound and thermal insulation performance." },
                      { name: "Bathroom & kitchen renewal", desc: "Replacing and renewing sanitary ware, mixers, and damaged ceramic tiling." },
                    ],
                  },
                  {
                    title: "IV. Smart & specialist systems maintenance",
                    icon: "settings",
                    services: [
                      { name: "Lift & escalator maintenance", desc: "Periodic service contracts guaranteeing user safety and smooth, reliable vertical movement." },
                      { name: "Fire protection system maintenance", desc: "Inspecting sprinkler heads, fire extinguishers, and smoke detectors in compliance with civil defence requirements." },
                      { name: "Smart home system maintenance", desc: "Software updates and inspection of cameras, access control, and smart building automation systems." },
                      { name: "Solar panel system maintenance", desc: "Panel cleaning and inverter checks to ensure continuous and efficient energy production." },
                    ],
                  },
                  {
                    title: "V. Environmental & logistical services",
                    icon: "eco",
                    services: [
                      { name: "Water tank cleaning & sterilisation", desc: "Ensuring drinking water quality by purifying tanks and eliminating sediment and bacterial contamination." },
                      { name: "Structural pest control", desc: "Protection against termites and rodents that can cause serious damage to property foundations and interiors." },
                      { name: "Landscaping & garden maintenance", desc: "Tree trimming, irrigation network servicing, and lawn renewal to keep external spaces pristine." },
                      { name: "Mechanical façade glass cleaning", desc: "Using cradle and rope-access systems to clean glazed façades on towers and high-rise administrative buildings." },
                    ],
                  },
                  {
                    title: "VI. Emergency response & technical assessment",
                    icon: "emergency",
                    services: [
                      { name: "24/7 emergency maintenance", desc: "A rapid-response team on call around the clock for sudden failures — burst pipes, total power outages, and critical breakdowns." },
                      { name: "Property technical condition report", desc: "A comprehensive engineering inspection by specialist surveyors assessing the full technical condition of a property before any sale or purchase." },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'Investment management and logistics services',
          title: 'Growth services',
          items: [
            {
              id: '09',
              video: legal,
              name: 'Legal consulting',
              platformTitle: 'Safety shield: comprehensive legal protection',
              marketing:
                'Invest with peace of mind. We provide a strong legal umbrella to review all contracts and documents and verify title, so every deal inside the club is free of gaps or legal obstacles.',
              detail: {
                heroDesc:
                  "Your investment's legal fortress — 25 specialised services covering every stage from company formation to dispute resolution, real estate transactions, and high-net-worth private client matters",
                details: [
                  "Legal consulting is the cornerstone of investor confidence. At Holol Club, we believe that every successful investment must rest on an impeccable legal foundation — from the moment an idea is conceived through its growth, expansion, and eventual exit.",
                  "Our 25 professional legal services span seven practice areas: corporate formation and governance, real estate and construction law, commercial contracts, employment and HR law, intellectual property and digital commerce, litigation and debt recovery, and private client services for individuals and high-net-worth families.",
                  "Backed by a network of licensed law firms and specialist legal consultants across the GCC and Arab world, Holol's legal arm provides members with the same calibre of legal protection previously reserved only for the largest institutional investors.",
                ],
                categories: [
                  {
                    title: "I. Corporate formation & governance",
                    icon: "business",
                    services: [
                      { name: "Company formation (LLC, JSC & sole-owner entities)", desc: "Selecting the legally and tax-optimal corporate structure and completing all registration procedures with the relevant authorities." },
                      { name: "Articles of association & founding contracts", desc: "Drafting and amending constitutional documents to guarantee partner rights, profit distribution, and management authority from day one." },
                      { name: "Board secretariat services", desc: "Organising board meetings, drafting formal minutes, and maintaining the statutory registers required by corporate law." },
                      { name: "Shareholders' agreements", desc: "Protecting minority and majority shareholder rights, governing partner exits, and preventing governance deadlock." },
                      { name: "Compliance & corporate governance", desc: "Ensuring the company's operations conform with local legislation, sector-specific regulations, and international best practice." },
                    ],
                  },
                  {
                    title: "II. Real estate & construction law",
                    icon: "gavel",
                    services: [
                      { name: "Property legal due diligence", desc: "Verifying the full legal integrity of a property's title, encumbrances, and ownership chain before any purchase commitment." },
                      { name: "Title registration & transfer", desc: "Managing all official real estate registration and notarisation procedures to secure clean title for the buyer." },
                      { name: "Construction & FIDIC contracts", desc: "Drafting and reviewing construction agreements — including FIDIC-based contracts — governing contractors, subcontractors, and suppliers." },
                      { name: "Tenancy dispute management", desc: "Drafting residential and commercial lease agreements, managing eviction proceedings, and recovering rental arrears." },
                      { name: "Real estate investment fund formation", desc: "Legal structuring of the financing and development vehicles for real estate investment funds and special purpose vehicles." },
                    ],
                  },
                  {
                    title: "III. Commercial contracts & operations",
                    icon: "handshake",
                    services: [
                      { name: "Commercial contract drafting", desc: "Supply, distribution, commercial agency, and brokerage agreements drafted to protect the client's position and reduce litigation risk." },
                      { name: "Franchise agreements", desc: "Drafting franchise contracts and protecting the intellectual property rights of both franchisor and franchisee." },
                      { name: "Contract audit & legal risk review", desc: "Assessing the legal risk embedded in existing contracts the client has already signed — flagging gaps before they become disputes." },
                      { name: "NDAs & non-competition agreements", desc: "Protecting trade secrets and confidential information during negotiations with prospective partners, employees, or investors." },
                    ],
                  },
                  {
                    title: "IV. Employment & HR law",
                    icon: "people",
                    services: [
                      { name: "Employment contract drafting", desc: "Compliant contracts that protect the employer from legal vulnerabilities while meeting all local labour law requirements." },
                      { name: "Internal HR regulations", desc: "Drafting the disciplinary and reward policy approved by the Ministry of Labour for the client's workforce." },
                      { name: "Labour dispute representation", desc: "Representing companies before labour courts and dispute settlement committees." },
                    ],
                  },
                  {
                    title: "V. Intellectual property & digital commerce",
                    icon: "verified",
                    services: [
                      { name: "Trademark registration & IP protection", desc: "Registering trademarks, industrial designs, and patents — and enforcing those rights against infringement." },
                      { name: "E-commerce law (T&C & privacy policy)", desc: "Drafting legally compliant terms and conditions, privacy policies, and data protection notices for websites and applications." },
                    ],
                  },
                  {
                    title: "VI. Litigation & debt recovery",
                    icon: "balance",
                    services: [
                      { name: "Debt collection (amicable & judicial)", desc: "Issuing formal legal notices and initiating enforcement proceedings to recover outstanding debts efficiently." },
                      { name: "Judicial representation", desc: "Full representation in civil and commercial proceedings at all court levels." },
                      { name: "Arbitration & mediation", desc: "Resolving disputes outside court through arbitration and mediation — faster, confidential, and enforceable." },
                    ],
                  },
                  {
                    title: "VII. Private client & family office services",
                    icon: "family_restroom",
                    services: [
                      { name: "Estate planning & wealth transfer", desc: "Drafting wills and structuring cross-generational wealth transfer to protect family assets (Family Office Support)." },
                      { name: "Investment residency & citizenship by investment", desc: "Legal advisory on investor residency and citizenship-by-investment programmes across target jurisdictions." },
                      { name: "Comprehensive investor legal audit", desc: "A periodic report identifying legal gaps and vulnerabilities across all of the client's current investments and corporate structures." },
                    ],
                  },
                ],
              },
            },
            {
              id: '10',
              name: 'Property and asset management',
              video: assetmanagement,
              platformTitle: 'Elite management: your investment grows while you rest',
              marketing:
                'We lift the daily management burden from you — from rent collection and tenant follow-up to operating administrative and commercial properties — to secure the highest return with the least effort.',
              detail: {
                heroDesc:
                  "Smart PropTech-powered asset management that transforms your property from a passive asset into an optimised investment — maximum returns, zero daily hassle",
                details: [
                  "Holol Club's smart property management service redefines the traditional model, moving beyond mere rent collection to full asset value maximisation through technology. The goal is complete owner peace of mind and peak operational efficiency for every property in your portfolio.",
                  "From a real-time owner dashboard and AI-powered tenant screening to predictive IoT maintenance, automated financial reporting, and short-term rental management, our 25 innovative services cover every dimension of modern property management.",
                  "We replace the old commission model with a professional membership system that guarantees investors quality, transparency, and measurable returns — turning every property into a smart investment project managed with minimal human intervention.",
                ],
                categories: [
                  {
                    title: "I. PropTech platform & remote control",
                    icon: "dashboard",
                    services: [
                      { name: "Owner digital dashboard", desc: "A mobile app giving owners real-time visibility of all their properties, contracts, and collections — any time, anywhere." },
                      { name: "Smart tenant app", desc: "Enabling tenants to pay rent, submit maintenance requests, and communicate with management entirely through a digital portal." },
                      { name: "Digital contract automation", desc: "Automated issuance and renewal of tenancy contracts linked to official government platforms (e.g. Ejar)." },
                      { name: "Automated payment collection", desc: "Rent collected via multiple digital payment channels with direct-debit functionality to ensure consistent on-time payments." },
                      { name: "Virtual 3D tours for vacant units", desc: "Showcasing empty units through immersive virtual reality to reduce vacancy periods and attract quality tenants faster." },
                    ],
                  },
                  {
                    title: "II. Maintenance & operations management",
                    icon: "build",
                    services: [
                      { name: "Predictive maintenance (IoT)", desc: "IoT sensors that detect faults before they occur — from water leaks to elevator malfunctions — preventing costly emergency repairs." },
                      { name: "Automated work order system", desc: "Maintenance requests routed directly to the nearest certified technician, with completion tracked by photos and reports." },
                      { name: "Energy-efficient utilities management", desc: "Smart solutions to reduce electricity and water consumption in common areas, cutting operational costs for the owner." },
                      { name: "Digital periodic inspections", desc: "Automatic photo and video inspection reports on the structural and technical condition of the property sent directly to the owner." },
                      { name: "Smart waste management", desc: "Contracts with fast-response recycling and cleaning services for compliant, efficient waste handling." },
                    ],
                  },
                  {
                    title: "III. Financial management & transparency",
                    icon: "account_balance_wallet",
                    services: [
                      { name: "Instant financial reporting", desc: "One-tap profit & loss statements and balance sheets for each property, always up to date and fully transparent." },
                      { name: "Expense & tax management", desc: "Paying utilities, property taxes, and insurance on the owner's behalf with full scheduling and documentation." },
                      { name: "Rental yield analysis", desc: "Periodic benchmarking studies comparing the property's rent against market averages to ensure the highest achievable return." },
                      { name: "Asset value maximisation strategy", desc: "Tailored upgrade and improvement plans to increase the property's market value ahead of any sale or exchange." },
                    ],
                  },
                  {
                    title: "IV. Tenant relations & compliance",
                    icon: "people",
                    services: [
                      { name: "AI tenant screening", desc: "Automated system assessing the financial solvency and credit behaviour of prospective tenants before any contract is signed." },
                      { name: "AI concierge (virtual assistant)", desc: "A smart chatbot answering tenant queries and resolving issues around the clock without human intervention." },
                      { name: "Tenant loyalty programme", desc: "Discounts and perks for long-term compliant tenants to maximise retention and minimise costly tenant turnover." },
                      { name: "Digital dispute resolution", desc: "Fast-track legal services for handling rent arrears and contractual violations efficiently and professionally." },
                    ],
                  },
                  {
                    title: "V. Security & logistics",
                    icon: "security",
                    services: [
                      { name: "Keyless smart entry system", desc: "Electronic lock and access management with instant code updates for new tenants — no physical key changes required." },
                      { name: "Smart security & surveillance", desc: "Property cameras linked to an AI video analytics system that detects suspicious activity and alerts management instantly." },
                      { name: "Smart parking management", desc: "Licence plate recognition system that organises and controls parking access for residents and visitors." },
                    ],
                  },
                  {
                    title: "VI. Value-added services",
                    icon: "star",
                    services: [
                      { name: "Common area space monetisation", desc: "Managing the rental of rooftops, halls, and advertising surfaces within the property to generate additional owner income." },
                      { name: "Furnished unit packages", desc: "Smart furnishing packages for vacant units to increase their rental value and attract premium tenants." },
                      { name: "Short-term rental management", desc: "Operating units on Airbnb and similar platforms during peak seasons to achieve rental returns several times higher than standard leases." },
                      { name: "Green building certification", desc: "Converting properties to eco-friendly standards to unlock preferential bank financing and potential tax relief." },
                    ],
                  },
                ],
              },
            },
            {
              id: '11',
              video: investment,
              name: 'Real estate investment (funds and portfolios)',
              platformTitle: 'Investors club: building wealth',
              marketing:
                'Participate in major global real estate opportunities. We provide investment advisory and diversified portfolios that let you enter large projects you could not reach alone, with fair distribution of returns.',
              detail: {
                heroDesc:
                  "The highest tier of Holol Club — from individual unit transactions to managing large-scale real estate wealth through funds, portfolios, and institutional-grade investment structures",
                details: [
                  "Real estate investment funds and portfolios represent the apex of Holol Club's offering — moving beyond individual unit transactions to the intelligent management of large-scale real estate wealth. This service is the primary draw for banks, sovereign institutions, and corporations seeking to deploy millions in capital with precision and security.",
                  "From REIT structuring and SPV formation to fractional ownership, distressed asset acquisition, investor dashboards, and IPO preparation, our 25 professional services cover every stage of the investment lifecycle — from strategy through to profitable exit.",
                  "Members access exclusive off-market deal flow, institutional financial engineering, and governance frameworks that meet the standards of capital market regulators — making the Club the most trusted real estate investment partner in the region.",
                ],
                categories: [
                  {
                    title: "I. Portfolio strategy & fund formation",
                    icon: "account_balance",
                    services: [
                      { name: "Investment strategy design", desc: "Defining the client's objectives — periodic yield, capital growth, or both — calibrated to their risk tolerance profile." },
                      { name: "REIT structuring", desc: "Legal and financial structuring support for publicly traded or private real estate investment trusts." },
                      { name: "Asset allocation", desc: "Diversifying the portfolio across sectors — residential, commercial, administrative, and industrial — to optimise the risk-return profile." },
                      { name: "Special purpose vehicle (SPV) formation", desc: "Creating independent legal entities for each investment project to ring-fence investor assets from other liabilities." },
                      { name: "IRR & NPV financial modelling", desc: "Sophisticated financial models projecting internal rate of return (IRR) and net present value (NPV) for every opportunity." },
                    ],
                  },
                  {
                    title: "II. Acquisition & deal sourcing",
                    icon: "search",
                    services: [
                      { name: "Exclusive off-market deal sourcing", desc: "Access to assets not listed publicly through the Club's private network — first-mover advantage on the best opportunities." },
                      { name: "Fractional ownership investment", desc: "Enabling smaller investors to own proportional stakes in large-scale assets — towers, hotels, and landmark developments." },
                      { name: "Land banking", desc: "Acquiring land in high-growth corridors and holding it for development or future sale at a significant premium." },
                      { name: "Distressed asset acquisition", desc: "Purchasing properties below market value and executing value-add rehabilitation to realise the uplift." },
                      { name: "Investment due diligence", desc: "Comprehensive economic and legal feasibility assessment of an asset before any capital is committed." },
                    ],
                  },
                  {
                    title: "III. Asset management & portfolio growth",
                    icon: "trending_up",
                    services: [
                      { name: "Portfolio restructuring", desc: "Divesting underperforming assets and redeploying capital into faster-growing, higher-yielding properties." },
                      { name: "Rental yield maximisation", desc: "Applying operational strategies to increase annual rental returns across the entire portfolio." },
                      { name: "Fund cash flow management", desc: "Scheduling collections and expenditures to ensure consistent, reliable periodic dividend distributions to shareholders." },
                      { name: "Market benchmarking", desc: "Comparing portfolio performance against global and local real estate market indices to identify gaps and opportunities." },
                      { name: "Portfolio tax optimisation", desc: "Using intelligent investment structures to minimise the tax burden on returns and capital gains." },
                    ],
                  },
                  {
                    title: "IV. Financial engineering & funding",
                    icon: "calculate",
                    services: [
                      { name: "Investment leverage strategy", desc: "Using carefully structured bank financing to scale the portfolio and multiply the return on equity." },
                      { name: "Asset refinancing", desc: "Extracting liquidity from appreciated assets through refinancing and redeploying it into new high-yield opportunities." },
                      { name: "Real estate sukuk issuance", desc: "Converting real estate assets into tradable Islamic bonds to attract immediate institutional liquidity." },
                    ],
                  },
                  {
                    title: "V. Investor reporting & governance",
                    icon: "dashboard",
                    services: [
                      { name: "Investor digital dashboard", desc: "A real-time app showing each investor the growth of their real estate wealth and live cash flow movements." },
                      { name: "Quarterly portfolio valuation reports", desc: "Certified quarterly reports disclosing the current market value of all fund assets to every stakeholder." },
                      { name: "Governance & regulatory compliance reports", desc: "Ensuring the fund remains fully aligned with financial regulations and capital market authority requirements." },
                    ],
                  },
                  {
                    title: "VI. Exit strategies",
                    icon: "exit_to_app",
                    services: [
                      { name: "Profitable exit planning", desc: "Identifying the optimal timing and method for selling portfolio assets to maximise capital gains." },
                      { name: "IPO preparation", desc: "Structuring the real estate portfolio for listing as a public shareholding company on a stock exchange." },
                      { name: "Orderly fund liquidation", desc: "Managing the sale of assets and distribution of returns to all investors at the end of the fund's term." },
                      { name: "Whole-portfolio swap", desc: "Exchanging an entire real estate portfolio for a stake in a national project or large-scale development." },
                    ],
                  },
                ],
              },
            },
            {
              id: '12',
              video: leasing,
              name: 'Residential and commercial leasing',
              platformTitle: 'The rental market: your first choice',
              marketing:
                'A large database of serious tenants and landlords. We help you find the right tenant or the ideal unit for lease in record time under fair terms for both sides.',
              detail: {
                heroDesc:
                  'Holol\'s leasing service is the oxygen that keeps investment portfolios breathing — not just "renting a unit" but managing an intelligent contractual relationship that maximises the landlord\'s return, delivers the best tenant experience, and drives vacancy periods to an absolute minimum.',
                details: [
                  'An empty property costs money every day it sits vacant. At Holol, we approach leasing as an active management discipline: market-benchmarked pricing, AI-powered tenant screening, professional visual documentation, and targeted digital campaigns that place your asset in front of the right occupant — fast.',
                  'Our 25-service leasing suite spans the full landlord-tenant lifecycle: from the moment a property is listed to contract drafting, deposit escrow, automated rent collection, renewal negotiation, and vacancy-minimisation strategy. Whether the asset is a luxury apartment, a corporate headquarters, or a retail unit in a mixed-use development, we manage every stage with institutional rigour.',
                  'Beyond the transaction, Holol adds compounding value through short-term rental management, concierge services that raise tenant retention, and strategic repositioning advice — turning underperforming assets into high-yield income engines aligned with the owner\'s long-term wealth goals.',
                ],
                categories: [
                  {
                    title: 'Landlord services',
                    icon: 'home_work',
                    services: [
                      { name: 'Target rental yield analysis', desc: 'Market study to determine the highest competitive price, ensuring the unit leases quickly.' },
                      { name: 'Targeted digital marketing', desc: 'Showcasing units in the platform\'s premium rentals section to reach companies and senior-tier professionals.' },
                      { name: 'Smart tenant screening', desc: 'Verifying the financial standing, credit history, and behavioural record of a prospective tenant before signing.' },
                      { name: 'Professional photography & documentation', desc: 'Full visual package (video + photos + VR tour) to present the unit at its best.' },
                      { name: 'Lease-ready unit preparation', desc: 'Quick interior-design consultations to raise rental value — fresh paint, smart lighting, and more.' },
                    ],
                  },
                  {
                    title: 'Tenant services',
                    icon: 'person_search',
                    services: [
                      { name: 'Bespoke search & shortlisting', desc: 'Options precisely matched to the residential or corporate-office requirements of the tenant.' },
                      { name: 'Virtual viewing service', desc: 'Enabling tenants — especially international ones — to inspect a unit via interactive video before visiting in person.' },
                      { name: 'Digital payment facilitation', desc: 'Rent payment options via credit cards or automated bank transfers.' },
                      { name: 'Renter\'s insurance', desc: 'Insurance policies protecting tenants from major incidents or damage within the unit.' },
                    ],
                  },
                  {
                    title: 'Legal & contract management',
                    icon: 'description',
                    services: [
                      { name: 'Standardised certified contracts', desc: 'Legally sound agreements protecting both parties and compliant with government platforms (such as "Ejar").' },
                      { name: 'Instant e-notarisation', desc: 'Completing contract notarisation digitally to create an enforceable title that protects the landlord.' },
                      { name: 'Security deposit escrow', desc: 'Holding the deposit in a Holol intermediary account for fair return or allocation to repairs at tenancy end.' },
                      { name: 'Dispute mediation', desc: 'Amicable resolution of any landlord-tenant conflict through Club experts before resorting to court.' },
                    ],
                  },
                  {
                    title: 'Commercial & office leasing',
                    icon: 'business',
                    services: [
                      { name: 'Corporate headquarters leasing', desc: 'Dedicated services helping global companies find offices in strategic locations.' },
                      { name: 'Retail & mall unit leasing', desc: 'Analysing the retail mix of malls to ensure units are leased to activities that complement one another.' },
                      { name: 'Technical office fit-out advisory', desc: 'Helping tenant companies plan workspaces and space-allocate for their teams (space planning).' },
                      { name: 'Managed sub-leasing', desc: 'Overseeing the sub-leasing of large spaces in a way that maximises the investor\'s return.' },
                    ],
                  },
                  {
                    title: 'Financial solutions & rent collection',
                    icon: 'payments',
                    services: [
                      { name: 'Automated rent collection', desc: 'A system that sends tenant reminders, collects rent, and deposits funds into the landlord\'s account automatically.' },
                      { name: 'Advance rent financing', desc: 'Financial solutions allowing the landlord to receive a full year\'s rent upfront while the tenant pays in instalments to Holol or the bank.' },
                      { name: 'Cash-flow reports', desc: 'Monthly and annual reports showing the landlord\'s net rental income after deducting all expenses.' },
                    ],
                  },
                  {
                    title: 'Value-added & operational services',
                    icon: 'manage_accounts',
                    services: [
                      { name: 'Renewal management', desc: 'Negotiating annual rent increases and following up on contract renewals well before expiry.' },
                      { name: 'Check-in / check-out inspection', desc: 'Detailed technical condition report at handover to protect against undisclosed damage.' },
                      { name: 'Short-term & vacation rentals', desc: 'Managing units on a daily or weekly basis to maximise income during peak tourist seasons.' },
                      { name: 'Tenant concierge services', desc: 'Providing cleaning, maintenance, and internet services to tenants to increase retention rates.' },
                      { name: 'Rental repositioning strategy', desc: 'Advising landlords on converting a unit\'s use category (e.g. residential to commercial) when it yields a higher rent.' },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'Innovation and training',
          title: 'Future and culture',
          items: [
            {
              id: '13',
              video: certificate,
              name: 'The Real Estate Certificate',
              platformTitle: 'The golden certificate: seal of real estate trust',
              marketing:
                'Our proprietary innovation to secure rights. A club-issued certificate that attests to developer and buyer seriousness, acts as a financial trust tool between parties, and facilitates subsequent banking dealings.',
              detail: {
                heroDesc:
                  'The Holol Real Estate Certificate is not a piece of paper — it is a passport of trust and a quality seal that guarantees to every buyer and investor that this property or professional has passed through Holol\'s rigorous verification filters.',
                details: [
                  'In markets where information asymmetry and undisclosed defects cost buyers billions every year, the Holol Certificate is a game-changer. It is the Club\'s proprietary innovation: a standardised, independently verified credential that eliminates ambiguity and replaces "trust me" with provable, documented facts — legal, structural, financial, and historical.',
                  'Twenty-five services are bundled into the certificate ecosystem, spanning property-asset safety attestations, investor financial privileges, professional accreditation for members and companies, blockchain-secured digital credentials, and government fast-track registration. Each element is designed to make certified assets and certified professionals the obvious first choice in every transaction.',
                  'Beyond individual deals, the Certificate becomes a market force: a five-star rating system that drives owner competition for quality, annual "Real Estate Oscar" awards that celebrate excellence, and international recognition that enables seamless cross-border investment — making Holol the custodian of trust across the region\'s real estate markets.',
                ],
                categories: [
                  {
                    title: 'Asset safety certification (properties)',
                    icon: 'verified',
                    services: [
                      { name: 'Legal due-diligence seal', desc: 'Certification confirming the property is 100% legally sound with no disputes, liens, or encumbrances.' },
                      { name: 'Structural quality certificate', desc: 'Accredited technical report confirming the integrity of the structure, foundations, electrical, and plumbing systems.' },
                      { name: 'Fair-price guarantee', desc: 'Club-backed assurance that the asking price aligns with genuine market valuation, preventing price manipulation.' },
                      { name: 'Property history card', desc: 'A digital record of ownership history, repairs, and improvements made to the property over time.' },
                      { name: 'Energy sustainability certificate', desc: 'Rating the property\'s energy efficiency, raising its value for environmentally conscious buyers.' },
                    ],
                  },
                  {
                    title: 'Financial & investment privileges',
                    icon: 'savings',
                    services: [
                      { name: 'Priority bank financing', desc: 'Agreements with partner banks to accept the Certificate as a guarantee, accelerating mortgage approvals.' },
                      { name: 'Reduced insurance premiums', desc: 'Special discounts from insurance companies for certified properties due to their lower risk profile.' },
                      { name: 'Expected-yield certificate', desc: 'A documented Club study showing the projected rental return on the asset, encouraging investors to commit.' },
                      { name: 'Resale guarantee', desc: 'Club commitment to market certified properties as a top priority across its global platforms.' },
                    ],
                  },
                  {
                    title: 'Professional accreditation (members & companies)',
                    icon: 'badge',
                    services: [
                      { name: 'Certified Developer seal', desc: 'Awarded to companies that meet delivery-date and quality-standard commitments, building instant client trust.' },
                      { name: 'Elite Broker licence', desc: 'Individual credential proving the member completed all training programmes and operates under the Club\'s code of ethics.' },
                      { name: 'Strategic Partner badge', desc: 'Displayed on company offices and websites as an accredited member of the influential 100-company network.' },
                    ],
                  },
                  {
                    title: 'PropTech & digital credentials',
                    icon: 'qr_code_2',
                    services: [
                      { name: 'Blockchain-secured digital certificate (NFT)', desc: 'A tamper-proof credential linked to the property electronically, guaranteeing original ownership.' },
                      { name: 'QR code at the property', desc: 'Scan the code at the entrance to instantly view the full certificate details and features on any device.' },
                      { name: 'Annual certificate refresh', desc: 'A yearly review service updating the property\'s market value and technical condition within the certificate.' },
                    ],
                  },
                  {
                    title: 'Government facilitations & legal protection',
                    icon: 'gavel',
                    services: [
                      { name: 'Fast-track registration', desc: 'Collaboration with government bodies to accept Club technical reports and accelerate ownership-transfer procedures.' },
                      { name: 'Certificate legal protection', desc: 'A dedicated legal team that defends the validity of the data contained in the certificate before any authority.' },
                      { name: 'Violation-free confirmation', desc: 'Official confirmation that the property complies with urban planning maps and carries no building violations.' },
                    ],
                  },
                  {
                    title: 'Marketing & branding',
                    icon: 'stars',
                    services: [
                      { name: 'Star rating system', desc: 'Properties in the certificate are graded 1–5 stars based on inspection results, driving owner competition for excellence.' },
                      { name: '"Real Estate Oscars" ceremony', desc: 'Annual gala honouring property owners and companies holding the highest Holol Certificate ratings.' },
                      { name: '"Certificate Holders" club', desc: 'Exclusive perks (décor discounts, maintenance) available only to owners whose properties carry a Holol Certificate.' },
                      { name: 'International certificate recognition', desc: 'Developing recognition of the certificate among Saudi and UAE investors to facilitate cross-border real estate export.' },
                      { name: 'Full-transparency guarantee', desc: 'The certificate discloses any property defects (if present) and how they have been or can be remedied — building unparalleled credibility.' },
                      { name: 'Pre-certification advisory', desc: 'Advice to owners on exactly what must be improved before inspection to achieve the Diamond tier.' },
                      { name: 'Free certification for the first 100 properties', desc: 'A launch marketing offer to attract early adopters and let them experience first-hand how the certificate accelerates sales.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '14',
              video: conference,
              name: 'Global exhibitions and conferences',
              platformTitle: 'Giants forum: the pulse of global real estate',
              marketing:
                'We organize major real estate gatherings that bring developers, investors, and decision-makers under one roof to exchange expertise and close major deals face to face.',
              detail: {
                heroDesc:
                  'At Holol, exhibitions and conferences are not about renting floor space — they are platforms for deal-making, strategic positioning, and direct access to an elite circle of global investors.',
                details: [
                  'Major real estate players — Class A developers, investment banks, and government institutions — don\'t participate in events simply to "be present." They participate to dominate their segment, forge high-value relationships, and close deals that cannot be made anywhere else. Holol\'s global exhibition and conference service is engineered for exactly that ambition.',
                  'Our 25-service exhibition package covers every dimension of a world-class corporate presence: from diamond-tier media exposure and custom VIP pavilion design, to AI-powered lead generation, augmented-reality project showcases, and pre-arranged meetings with pre-qualified investors — all within the atmosphere of Holol\'s elite real estate gatherings.',
                  'Beyond the event itself, participation translates into a year-long promotional cycle through the Club\'s digital and print platforms, priority placement at future international tours, and a permanent seat at the Holol Partners Club — making every exhibition an investment with compounding returns.',
                ],
                categories: [
                  {
                    title: 'Elite branding & media exposure',
                    icon: 'stars',
                    services: [
                      { name: 'Diamond sponsorship', desc: 'Top-of-page placement across all promotional materials (online and offline) as an official strategic partner of the Club.' },
                      { name: 'Exclusive TV coverage', desc: 'Dedicated segments and executive interviews on television programmes affiliated with or contracted by the Club.' },
                      { name: 'International magazine feature', desc: 'Journalistic reports and success stories in the conference\'s official printed and digital publications.' },
                      { name: 'Promotional documentary film', desc: 'A professionally produced video showcasing the company\'s projects, screened on the main exhibition screens throughout the event.' },
                      { name: 'Intensive social media campaigns', desc: 'Paid campaigns targeting the Club\'s qualified audience to promote the company\'s pavilion before and during the event.' },
                    ],
                  },
                  {
                    title: 'Premium location & space',
                    icon: 'villa',
                    services: [
                      { name: 'VIP-designed pavilions', desc: 'Prime spots at main entrances or at the heart of the exhibition floor, with exceptional bespoke décor.' },
                      { name: 'Private meeting rooms', desc: 'In-pavilion rooms for signing contracts and closing major deals away from the public floor.' },
                      { name: 'VIP lounge access', desc: 'Exclusive entry for company executives and their clients to the elite rest and hospitality area.' },
                      { name: 'Giant LED screen advertising', desc: 'Company advertisements on the main screens at all conference hall entrances and exits.' },
                    ],
                  },
                  {
                    title: 'Networking & business opportunities',
                    icon: 'group',
                    services: [
                      { name: 'Pre-arranged matchmaking meetings', desc: 'Confirmed appointments between the company and investors with a specific interest in its sector.' },
                      { name: 'Elite dinner invitation', desc: 'Permanent seats for company executives at closed-door gala dinners with senior officials and international investors.' },
                      { name: 'Visitor database access', desc: 'Detailed data and analytics on visitor interests (privacy-compliant) for post-event deal follow-up.' },
                      { name: 'Keynote panel sponsorship', desc: 'Opportunity for the company chairman to speak as a keynote at seminars and plenary sessions.' },
                    ],
                  },
                  {
                    title: 'Concierge & logistics services',
                    icon: 'room_service',
                    services: [
                      { name: 'Exhibit shipping & storage', desc: 'Full responsibility for transporting and safely storing the company\'s exhibits to and from the venue.' },
                      { name: 'Luxury hospitality package', desc: 'Five-star hotel accommodation and VIP transport for the company team throughout the event.' },
                      { name: 'Professional reception team', desc: 'Multi-lingual, trained hosts and hostesses to represent the company at its pavilion.' },
                      { name: 'Simultaneous interpretation', desc: 'Specialist interpreters for technical and legal negotiations during international meetings.' },
                    ],
                  },
                  {
                    title: 'Smart event technology',
                    icon: 'phone_iphone',
                    services: [
                      { name: 'Live event streaming', desc: 'Broadcasting the company\'s project launches via the Club\'s digital platform to millions of followers worldwide.' },
                      { name: 'AI lead generation system', desc: 'QR and AI-powered technology to capture qualified lead data the moment visitors arrive at the pavilion.' },
                      { name: 'Augmented reality (AR) showcase', desc: 'Helping the company present under-construction projects using AR technology inside the pavilion.' },
                    ],
                  },
                  {
                    title: 'Post-event value-added services',
                    icon: 'workspace_premium',
                    services: [
                      { name: 'Performance analysis report', desc: 'A comprehensive report detailing pavilion engagement volume and the approximate return on participation investment.' },
                      { name: 'Year-long remarketing', desc: 'Continuous promotion of the company\'s profile on the Club platform for a full year after the exhibition closes.' },
                      { name: 'Priority at future exhibitions', desc: 'Guaranteed priority booking for prime locations at all upcoming Club international tours (Egypt, Saudi Arabia, UAE, and more).' },
                      { name: 'Real estate excellence awards', desc: 'Nomination for the Club\'s annual awards presented at the close of its major conferences.' },
                      { name: 'Partners Club membership', desc: 'Listing the company as a permanent partner across all Club events, including smaller gatherings and monthly sessions.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '15',
              video: academy,
              name: 'Real estate training and development (Academy)',
              platformTitle: 'Solutions Academy: building tomorrow\'s experts',
              marketing:
                'We do not only manage the market — we shape it. We offer global training programs to qualify real estate cadres and spread sound culture, elevating real estate marketing to new professional levels.',
              detail: {
                heroDesc:
                  'Solutions Academy is the factory that produces the talent capable of executing the real estate revolution — a unified, world-class knowledge catalogue that transforms enthusiasts into internationally certified experts.',
                details: [
                  'To guarantee the success of 100 member companies and thousands of individual members, Holol invests in the knowledge infrastructure that underpins every transaction. Our Academy doesn\'t teach "brokerage" — it cultivates strategic thinking, technical mastery, and the ethical standards that define elite real estate professionals worldwide.',
                  'The curriculum spans seven tracks and 25 programmes, covering everything from internationally accredited diplomas and PropTech skills to deal-negotiation psychology, financial engineering, and anti-money-laundering compliance. Delivery formats include in-person intensives, field immersion at landmark projects, live simulations, and a 24/7 self-learning digital library.',
                  'For corporates, the Academy offers tailored solutions: staff competency audits, branded training academies, and a developer-transformation programme that turns contractors into full-cycle real estate investors. Graduates earn the Holol Certified Member seal — a quality stamp recognised by banks, government bodies, and institutional partners across the region.',
                ],
                categories: [
                  {
                    title: 'Accredited programmes & professional diplomas',
                    icon: 'school',
                    services: [
                      { name: 'International real estate brokerage diploma', desc: 'Qualifying brokers to operate to global standards that go far beyond traditional agency practice.' },
                      { name: 'Certified real estate appraiser', desc: 'Intensive programme on scientific valuation methods (cost, market, and income approaches) in partnership with international bodies.' },
                      { name: 'Asset & investment portfolio management', desc: 'Training senior investors and fund managers on growing real estate wealth strategically.' },
                      { name: 'Smart property management programme', desc: 'Training operations teams to use PropTech in running and maintaining buildings efficiently.' },
                    ],
                  },
                  {
                    title: 'Technical & technology training (Smart Real Estate)',
                    icon: 'devices',
                    services: [
                      { name: 'Advanced digital real estate marketing', desc: 'Training on smart targeting tools, social-media sales, and high-impact content creation.' },
                      { name: 'AI applications in real estate', desc: 'How members use artificial intelligence to analyse market data and forecast prices.' },
                      { name: 'Real estate photography & VR production', desc: 'Workshops for photographers and marketers to present properties in a cinematic, immersive way.' },
                      { name: 'Big data management', desc: 'Training companies to analyse market trends and make informed buy/sell decisions from data.' },
                    ],
                  },
                  {
                    title: 'Leadership & sales skills (Soft Skills)',
                    icon: 'psychology',
                    services: [
                      { name: 'Negotiation mastery for major deals', desc: 'Strategies for closing billion-dollar transactions with corporations and banks.' },
                      { name: 'Body language & real estate protocol', desc: 'Training agents on how to engage Elite Members with a refined, high-calibre approach.' },
                      { name: 'Real estate crisis management', desc: 'How companies navigate market downturns or sudden legislative changes.' },
                      { name: 'Strategic leadership for development firms', desc: 'A dedicated programme for chairmen and CEOs to sharpen institutional vision and governance.' },
                    ],
                  },
                  {
                    title: 'Legal & financial literacy',
                    icon: 'account_balance',
                    services: [
                      { name: 'Real estate law & international regulations', desc: 'Understanding contracts, property taxes, and registration law across Egypt, Saudi Arabia, and the UAE.' },
                      { name: 'Financial engineering for projects', desc: 'Training accountants and managers on IRR, ROI, and project feasibility calculations.' },
                      { name: 'Anti-money-laundering in real estate', desc: 'Compliance workshops for international and local regulations to ensure transaction transparency.' },
                    ],
                  },
                  {
                    title: 'Field development & simulation',
                    icon: 'construction',
                    services: [
                      { name: '"Field immersion" programme', desc: 'Educational visits to major national projects to learn how mega-site operations are managed.' },
                      { name: 'Real estate auction simulation', desc: 'Hands-on training in running auctions and handling bidders with intelligence and poise.' },
                      { name: '"Real estate exchange" workshops', desc: 'Training members on the art of property barter and persuading both parties to commit to a swap deal.' },
                    ],
                  },
                  {
                    title: 'Digital transformation & continuous learning (E-Learning)',
                    icon: 'laptop',
                    services: [
                      { name: 'Holol self-learning platform', desc: 'A digital library of hundreds of training hours available to members around the clock.' },
                      { name: '"Real Estate Secrets" podcast', desc: 'Regular sessions with global experts transferring experience and lessons learned.' },
                      { name: 'Weekly webinars', desc: 'Live discussions of the latest market shifts and real-time investment opportunities.' },
                    ],
                  },
                  {
                    title: 'Corporate & elite services',
                    icon: 'corporate_fare',
                    services: [
                      { name: 'Staff professional identity programme', desc: 'Training company employees to represent the corporate brand with polish and consistency.' },
                      { name: 'Real estate talent assessment', desc: 'Competency testing and evaluation of client-company employees to map strengths and development gaps.' },
                      { name: '"Developer factory" programme', desc: 'Transforming contractors into real estate developers who own the full investment and development mindset.' },
                      { name: 'Holol Certified Member credential', desc: 'A quality seal awarded by the Club to individuals and companies who successfully complete all required programmes.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '16',
              name: 'Feasibility studies',
              platformTitle: 'Feasibility: data-led decisions',
              marketing:
                'A data-driven market analysis and predictive models for projects to validate demand, pricing, and risk before execution.',
              video: feasability,
              detail: {
                heroDesc:
                  "The roadmap that protects investors' capital before execution — C-Suite level analysis covering marketing, technical, financial, and legal dimensions.",
                details: [
                  "Before allocating capital, you need complete clarity. Holol Club's feasibility experts conduct rigorous market and financial analyses that give you a definitive answer on the viability of your project.",
                  "Our studies cover demand analysis, competitive landscape mapping, financial forecasting, risk assessment, and ROI modeling — all tailored to your sector and geography.",
                  "With a Holol Club feasibility report, you can approach banks, investors, and regulators with total confidence.",
                ],
                categories: [
                  {
                    title: 'I. Market feasibility & strategic analysis',
                    icon: 'analytics',
                    services: [
                      {
                        name: 'Supply & demand analysis',
                        desc: 'Assess current and projected market size and identify available investment gaps.',
                      },
                      {
                        name: 'Competitor analysis',
                        desc: 'Map strengths and weaknesses of direct and indirect competitors.',
                      },
                      {
                        name: 'Consumer behavior study',
                        desc: 'Define target segments and understand preferences and purchasing power.',
                      },
                      {
                        name: 'SWOT analysis',
                        desc: 'Identify project strengths, weaknesses, opportunities, and threats.',
                      },
                      {
                        name: 'PESTEL analysis',
                        desc: 'Evaluate political, economic, social, technological, environmental, and legal factors.',
                      },
                    ],
                  },
                  {
                    title: 'II. Technical & engineering feasibility',
                    icon: 'engineering',
                    services: [
                      {
                        name: 'Optimal site selection',
                        desc: 'Analyze proposed locations and select the best option logistically.',
                      },
                      {
                        name: 'Service/production process definition',
                        desc: 'Design an end-to-end workflow from start to finish.',
                      },
                      {
                        name: 'Asset requirements estimation',
                        desc: 'Specify required machines, equipment, and devices with technical specs.',
                      },
                      {
                        name: 'Human resources planning',
                        desc: 'Define org structure, roles, and required skills.',
                      },
                      {
                        name: 'Raw materials & suppliers estimation',
                        desc: 'Identify supply sources and estimate expected costs.',
                      },
                    ],
                  },
                  {
                    title: 'III. Financial feasibility & modeling',
                    icon: 'price_change',
                    services: [
                      {
                        name: 'CAPEX estimation',
                        desc: 'Calculate setup costs, construction, and asset purchases.',
                      },
                      {
                        name: 'OPEX estimation',
                        desc: 'Estimate monthly and yearly operating expenses (salaries, rent, utilities).',
                      },
                      {
                        name: 'Revenue modeling',
                        desc: 'Forecast sales using scenarios (optimistic, base, pessimistic).',
                      },
                      {
                        name: 'Financial KPIs (ROI & IRR)',
                        desc: 'Compute return on investment and internal rate of return.',
                      },
                      {
                        name: 'Payback period',
                        desc: 'Determine when the project starts covering its costs.',
                      },
                      {
                        name: 'Break-even analysis',
                        desc: 'Identify the sales volume needed to avoid losses.',
                      },
                      {
                        name: 'Sensitivity analysis',
                        desc: 'Test impacts of changes in exchange rates or raw material prices.',
                      },
                    ],
                  },
                  {
                    title: 'IV. Specialized feasibility studies',
                    icon: 'real_estate_agent',
                    services: [
                      {
                        name: 'Real estate feasibility (Club specialty)',
                        desc: 'Analyze best use for land and construction projects.',
                      },
                      {
                        name: 'Industrial feasibility',
                        desc: 'For projects requiring production lines and complex industrial licensing.',
                      },
                      {
                        name: 'Startup feasibility (tech projects)',
                        desc: 'Focus on scalability and digital market share.',
                      },
                    ],
                  },
                  {
                    title: 'V. Legal aspects & risk',
                    icon: 'gavel',
                    services: [
                      {
                        name: 'Legal & regulatory study',
                        desc: 'Identify required permits and governing regulations.',
                      },
                      {
                        name: 'Risk assessment & contingency plans',
                        desc: 'Define key risks and set proactive mitigation solutions.',
                      },
                      {
                        name: 'Environmental & social impact study',
                        desc: 'Ensure compliance with environmental standards and social responsibility.',
                      },
                    ],
                  },
                  {
                    title: 'VI. Outputs & investor pitching',
                    icon: 'present_to_all',
                    services: [
                      {
                        name: 'Business plan preparation',
                        desc: 'A complete document describing how the project will be operated after feasibility.',
                      },
                      {
                        name: 'Investor pitch deck',
                        desc: 'Convert feasibility into a compelling visual presentation for funders and partners.',
                      },
                    ],
                  },
                ],
              },
            },
            {
              id: '17',
              name: 'Advertising and marketing',
              platformTitle: 'Launch your brand globally',
              video: marketing,
              marketing:
                'Campaign strategy, creative, and media execution to put your project in front of the right audience and accelerate conversions.',
              detail: {
                heroDesc:
                  "The engine that transforms your ideas into dominant brands — from identity design to global media campaigns",
                details: [
                  "In a crowded marketplace, your brand is your most powerful asset. holol Club's marketing partners help you craft compelling narratives and deploy them across the right channels to reach your ideal audience.",
                  "Our services span brand strategy, digital advertising, social media management, content production, influencer marketing, and performance analytics to provide a comprehensive view of your project.",
                  "Whether you are entering a new market or reinforcing an existing presence, we build campaigns tailored specifically for you.",
                ],
                categories: [
                  {
                    title: "I. Identity & brand building",
                    icon: "palette",
                    services: [
                      { name: "Full visual identity design", desc: "Logo, colors, typography, and official stationery — every visual element that defines your brand." },
                      { name: "Brand Story", desc: "Crafting your vision, mission, and values into a compelling narrative that resonates with your audience." },
                      { name: "Brand Guidelines", desc: "A comprehensive guide to ensure your brand looks and feels consistent across every touchpoint." },
                      { name: "Rebranding", desc: "Revitalizing established companies with a modern identity that keeps pace with today's market." },
                    ],
                  },
                  {
                    title: "II. Digital marketing & platform management",
                    icon: "ads_click",
                    services: [
                      { name: "Social media management", desc: "Full management of Facebook, Instagram, LinkedIn, Twitter, and TikTok with a content strategy that builds community." },
                      { name: "Paid ad campaigns", desc: "ROI-focused ad campaigns across all platforms to maximize reach and conversion rates." },
                      { name: "Search engine optimization (SEO)", desc: "Ensuring your website appears at the top of Google search results for maximum organic visibility." },
                      { name: "Google Ads", desc: "Search network and YouTube display campaigns designed to reach high-intent buyers when it matters most." },
                      { name: "Influencer marketing", desc: "Selecting the right personalities for each sector to build authentic credibility with your target audience." },
                    ],
                  },
                  {
                    title: "III. Creative content production",
                    icon: "movie",
                    services: [
                      { name: "Marketing copywriting", desc: "Persuasive ad copy, sales content, and company profiles that speak directly to your customers." },
                      { name: "Promotional video production", desc: "Motion graphics, explainer videos, and promo reels that capture attention and drive action." },
                      { name: "Professional photography", desc: "Product, premises, and team photography that elevates your brand's visual presence." },
                      { name: "Corporate podcast production", desc: "Positioning your company as a thought leader in its field through a high-quality branded podcast." },
                    ],
                  },
                  {
                    title: "IV. Public relations & media presence",
                    icon: "newspaper",
                    services: [
                      { name: "Press & magazine publishing", desc: "Official news coverage and opinion articles in print and digital publications to build credibility." },
                      { name: "TV & radio appearances", desc: "Coordinating interviews and features that increase your brand's trustworthiness before a mass audience." },
                      { name: "Events & conference management", desc: "Organizing summits, conferences, and official project launch ceremonies with full production support." },
                      { name: "Media crisis management", desc: "Protecting your brand's reputation with rapid, strategic response when issues arise." },
                    ],
                  },
                  {
                    title: "V. Direct marketing & tech solutions",
                    icon: "devices",
                    services: [
                      { name: "Landing page design", desc: "Conversion-optimized landing pages built to capture qualified leads and drive measurable results." },
                      { name: "Email marketing", desc: "Periodic newsletters and drip campaigns that keep your clients informed and engaged." },
                      { name: "WhatsApp marketing", desc: "Targeted WhatsApp broadcast campaigns with intelligent automated responses for instant engagement." },
                      { name: "Website design & development", desc: "Corporate brochure sites and full e-commerce stores built to perform and convert." },
                    ],
                  },
                  {
                    title: "VI. Traditional & field marketing",
                    icon: "storefront",
                    services: [
                      { name: "Exhibition booth design", desc: "Innovative, eye-catching exhibition booth concepts that command attention on the show floor." },
                      { name: "Outdoor advertising", desc: "Billboards and digital screens in prime public locations for maximum mass-market exposure." },
                      { name: "Printed materials & corporate gifts", desc: "Flyers, brochures, and premium branded corporate gifts that leave a lasting impression." },
                      { name: "Market research & competitor analysis", desc: "Data-driven market studies and competitive intelligence to inform smart marketing decisions." },
                    ],
                  },
                ],
              },
            },
            {
              id: '18',
              name: 'Immigration and relocation',
              platformTitle: 'Your gateway to global mobility',
              video: immigration,
              marketing:
                'A smooth transition across countries through guided relocation support and trusted partners, so you can move and settle with confidence.',
              detail: {
                heroDesc:
                  "Citizenship, residency, and relocation services designed to give investors freedom of movement and a second layer of protection for their assets",
                details: [
                  "Residency, citizenship, and immigration-by-investment services are among the most sought-after solutions for investors and HNWIs — and a natural complement to Holol Club's platform. These services give clients freedom of movement and an additional layer of protection for their investments.",
                  "With 25 specialized services spanning citizenship-by-investment programs, golden visas, entrepreneur visas, professional migration pathways, legal documentation support, and full relocation assistance, we manage every step of your immigration journey from first consultation to final settlement.",
                  "Our network of licensed immigration lawyers and relocation specialists operates across 40+ countries, ensuring your file is built correctly, submitted on time, and approved with confidence.",
                ],
                categories: [
                  {
                    title: "I. Citizenship by investment (CBI)",
                    icon: "travel_explore",
                    services: [
                      { name: "Caribbean citizenship programs", desc: "Dominica, St. Kitts, Antigua & Barbuda, and more — passports granting visa-free access to 140+ countries." },
                      { name: "Turkish citizenship by investment", desc: "Full file management from property purchase or bank deposit through to passport delivery." },
                      { name: "European citizenship programs", desc: "Malta and other EU programs offering full citizenship rights and freedom of movement across the European Union." },
                      { name: "Due diligence file preparation", desc: "Security background screening to guarantee your application is accepted before formal submission." },
                    ],
                  },
                  {
                    title: "II. Golden & permanent residency",
                    icon: "star",
                    services: [
                      { name: "UAE Golden Visa (10 years)", desc: "Long-term residency for investors, exceptional talents, and real estate owners in the UAE." },
                      { name: "Saudi Premium Residency", desc: "All tracks covered — investor, entrepreneur, and exceptional competency routes." },
                      { name: "European Golden Visas", desc: "Greece, Spain, and Portugal programs granting residency and Schengen zone freedom of movement." },
                      { name: "US EB-5 Investor Program", desc: "A path to a US Green Card through investment in USCIS-approved commercial projects." },
                    ],
                  },
                  {
                    title: "III. Entrepreneur & startup visas",
                    icon: "rocket_launch",
                    services: [
                      { name: "UK Innovator Founder Visa", desc: "For founders looking to build and scale their innovative business in the UK market." },
                      { name: "Startup Visa programs", desc: "Canada, France, and other top destinations welcoming high-potential entrepreneurs and innovators." },
                      { name: "Freelance Visas", desc: "Designed for independent professionals and international consultants seeking legal residency abroad." },
                      { name: "Digital Nomad Visa", desc: "For remote workers seeking long-term residence in tourist or business-friendly countries." },
                    ],
                  },
                  {
                    title: "IV. Professional & skilled migration",
                    icon: "workspace_premium",
                    services: [
                      { name: "Canadian Express Entry & PNP", desc: "The fastest route to Canadian permanent residency through federal and provincial nominee programs." },
                      { name: "Global Talent Visa", desc: "Fast-track residency for leaders in technology, arts, and scientific research." },
                      { name: "EU Blue Card", desc: "Attracting highly qualified professionals to work and live anywhere in the European Union." },
                      { name: "Study-to-immigration consulting", desc: "Securing university admissions as a gateway to work permits and permanent residency." },
                    ],
                  },
                  {
                    title: "V. Legal & administrative support",
                    icon: "gavel",
                    services: [
                      { name: "Document apostille & notarization", desc: "Embassy and foreign ministry legalization of all documents required for immigration files." },
                      { name: "Certified legal translation", desc: "Accredited translation of all documents into the required language for your immigration application." },
                      { name: "International criminal record clearance", desc: "Obtaining police clearance certificates and facilitating required medical examinations." },
                      { name: "Family reunification services", desc: "Processing visas for the investor's spouse, children, and dependent parents." },
                    ],
                  },
                  {
                    title: "VI. Relocation & settlement services",
                    icon: "home_pin",
                    services: [
                      { name: "International bank account opening", desc: "Non-resident banking setup to facilitate the smooth transfer of investment funds." },
                      { name: "Tax number registration", desc: "Obtaining the new country's tax identification number to ensure full legal compliance." },
                      { name: "Residential property search", desc: "Finding properties that meet residency or citizenship program requirements in the target country." },
                      { name: "School & university admissions consulting", desc: "Securing placements for children at top international schools in the destination country." },
                      { name: "Soft landing services", desc: "Airport reception, local ID card, driver's license, and health insurance — everything to start the new chapter." },
                    ],
                  },
                ],
              },
            },
            {
              id: '19',
              name: 'Accounting and financial consulting',
              video: accounting,
              platformTitle: 'The numbers language: financial clarity for smart investment',
              marketing:
                'Comprehensive accounting, tax, and financial advisory services that give investors the data-driven clarity they need to make sound decisions — from daily bookkeeping to strategic financial planning.',
              detail: {
                heroDesc:
                  "End-to-end accounting, taxation, and financial strategy services for businesses at every stage — from bookkeeping and VAT compliance to business valuation and investor pitch decks",
                details: [
                  "Numbers are the universal language of business — and mastering them is the foundation of every smart investment decision. Holol Club's accounting and financial consulting service brings CFO-level expertise to businesses of all sizes, from startups to large enterprises.",
                  "With 25 specialized services spanning accounting systems design, periodic financial statements, VAT and corporate tax compliance, strategic tax planning, financial feasibility studies, cash flow management, business valuation, and full funding support, we cover every financial dimension of your business.",
                  "Our team of certified accountants, tax advisors, and financial analysts operates across the GCC, Egypt, and the wider Arab world — ensuring your financials are always accurate, compliant, and positioned for growth.",
                ],
                categories: [
                  {
                    title: "I. Accounting & compliance",
                    icon: "calculate",
                    services: [
                      { name: "Accounting structure design", desc: "Building the document cycle and selecting the right cloud accounting systems for your business." },
                      { name: "Bookkeeping", desc: "Recording daily transactions and reviewing journal entries to ensure accuracy at every step." },
                      { name: "Periodic financial statements", desc: "Monthly and quarterly balance sheets, income statements, and cash flow statements prepared to international standards." },
                      { name: "Outsourced CFO services", desc: "Senior financial expertise made available to startups and SMEs at a flexible, cost-effective engagement model." },
                      { name: "Internal auditing & review", desc: "Independent examination of records to verify data accuracy and the integrity of financial performance." },
                      { name: "Year-end accounts preparation", desc: "Preparing closing accounts and readying files for annual external audit and regulatory submission." },
                    ],
                  },
                  {
                    title: "II. Taxation & zakat",
                    icon: "receipt_long",
                    services: [
                      { name: "VAT services", desc: "Registration, return preparation, and compliance advisory to keep your business fully aligned with VAT regulations." },
                      { name: "Corporate tax (UAE, KSA & Egypt)", desc: "Full compliance with the latest corporate tax laws across key GCC and Arab markets." },
                      { name: "Strategic tax planning", desc: "Minimising the tax burden through all legally available structures and reliefs." },
                      { name: "Tax authority representation", desc: "Representing clients before tax authorities in inspections, objections, and dispute resolution." },
                      { name: "Transfer pricing", desc: "Compliant transfer pricing documentation and advisory for companies with international subsidiaries or related-party transactions." },
                    ],
                  },
                  {
                    title: "III. Financial planning & investment strategy",
                    icon: "trending_up",
                    services: [
                      { name: "Economic feasibility studies", desc: "Comprehensive financial and operational analysis for new projects to validate viability before capital commitment." },
                      { name: "Budgeting & forecasting", desc: "Building detailed annual budgets and expenditure plans aligned with business strategy." },
                      { name: "Cash flow management", desc: "Ensuring the liquidity required for day-to-day operations and long-term growth is always available." },
                      { name: "Business valuation", desc: "Determining fair market value for sales, mergers, acquisitions, and new partner onboarding." },
                      { name: "Financial due diligence", desc: "Deep financial investigation before acquisitions or partnerships to surface all risks and opportunities." },
                    ],
                  },
                  {
                    title: "IV. Funding & growth",
                    icon: "rocket_launch",
                    services: [
                      { name: "Capital structure advisory", desc: "Optimising the balance between self-funding and bank debt to reduce cost of capital and maximise returns." },
                      { name: "Bank financing file preparation", desc: "Preparing the full documentation package to help businesses secure loans and credit facilities." },
                      { name: "Investor pitch deck preparation", desc: "Crafting compelling financial narratives and projections to attract venture capital and strategic investors." },
                      { name: "IPO & corporate restructuring advisory", desc: "Managing the financial dimensions of share issuance, corporate transformation, and ownership broadening." },
                    ],
                  },
                  {
                    title: "V. Specialized real estate & compliance services",
                    icon: "domain",
                    services: [
                      { name: "Real estate ROI & IRR analysis", desc: "Detailed return-on-investment and internal rate of return analysis for real estate portfolios." },
                      { name: "Project & cost accounting", desc: "Specialized cost tracking for contracting firms and real estate developers across project lifecycles." },
                      { name: "Payroll management", desc: "Full payroll processing, entitlements management, and social insurance compliance for your workforce." },
                      { name: "AML compliance services", desc: "Preparing anti-money laundering reports, policies, and procedures required by law." },
                      { name: "Forensic accounting", desc: "Investigative accounting for embezzlement cases and complex financial disputes requiring expert witness-level analysis." },
                    ],
                  },
                ],
              },
            },
          ],
        },
      ],
      sovereign: {
        id: '20',
        video: nationalProjects,
        name: 'National projects and government cooperation',
        platformTitle: 'Future gateway: marketing sovereign visions and national projects',
        marketing:
          'We do not market units alone — we market countries\' visions and peoples\' futures. Through strategic cooperation protocols with housing and investment ministries across countries, Holol Real Estate Club acts as a global marketing arm for national projects and smart cities (such as the New Administrative Capital and Saudi Vision 2030). We deploy our media and technology power to connect international investors with major sovereign opportunities, as the bridge through which national ambition reaches the world stage.',
        detail: {
          heroDesc:
            'Holol Real Estate Club acts as a strategic partner to governments — transforming public assets into economic engines, attracting billions in investment, and marketing sovereign visions on the world stage.',
          details: [
            'National projects and sovereign real estate represent the most consequential arena of economic development. At Holol, we don\'t treat governments as licensing authorities — we engage them as strategic partners. We translate national visions into bankable projects, connecting state ambition with the capital, technology, and expertise required to realise them.',
            'From mega-project feasibility to digital land registries, from PPP structuring to nation branding, our integrated suite of 25 sovereign services covers every dimension of government real estate engagement — ensuring that public assets generate maximum national value and that investment frameworks attract global capital.',
            'Through cooperation protocols with housing and investment ministries across the region, Holol deploys its media power, analytical rigour, and PropTech capabilities to bridge the gap between sovereign vision and on-the-ground execution — making us the global marketing arm of choice for national projects and smart cities.',
          ],
          categories: [
            {
              title: 'Strategic consultancy & national planning',
              icon: 'account_balance',
              services: [
                { name: 'Mega-project feasibility studies', desc: 'Comprehensive feasibility studies for new cities, industrial zones, and world-class tourism resorts.' },
                { name: 'Urban master plans', desc: 'Consulting on urban mapping and land-use planning to maximise national returns.' },
                { name: 'Smart city strategy development', desc: 'Designing the technological infrastructure of modern cities to ensure their long-term sustainability.' },
                { name: 'Economic & social impact analysis', desc: 'Assessing the impact of national projects on job creation and population growth.' },
              ],
            },
            {
              title: 'Government asset monetisation',
              icon: 'real_estate_agent',
              services: [
                { name: 'Unused-asset inventory & valuation', desc: 'Building a digital database of government land and buildings and estimating their current market value.' },
                { name: 'Land investment launch plans', desc: 'Designing offering models (sale, usufruct, or partnership) to attract developers.' },
                { name: 'Heritage building conversion', desc: 'Rehabilitating palaces and heritage buildings to become high-yield hotels or cultural centres.' },
                { name: 'Sovereign real estate portfolio management', desc: 'Professional management services for sovereign real estate funds.' },
              ],
            },
            {
              title: 'Public-Private Partnerships (PPP)',
              icon: 'handshake',
              services: [
                { name: 'PPP project structuring', desc: 'Establishing legal and financial frameworks that protect state rights while incentivising private investors.' },
                { name: 'Foreign direct investment (FDI) attraction', desc: 'Marketing national projects at international forums to attract foreign capital.' },
                { name: 'Joint venture formation', desc: 'Facilitating the creation of entities that bring together government and leading investors to execute specific projects.' },
                { name: 'National tender & bid management', desc: 'Organising government procurement processes with global transparency and professionalism.' },
              ],
            },
            {
              title: 'Legislative & regulatory support',
              icon: 'gavel',
              services: [
                { name: 'Real estate law drafting', desc: 'Providing recommendations to develop legislation that facilitates real estate investment and supports real estate export.' },
                { name: 'One-stop-shop licensing', desc: 'Designing digital systems that eliminate bureaucracy and accelerate the issuance of construction and investment permits.' },
                { name: 'Special investment zones', desc: 'Advising on the establishment of zones with incentivised tax and customs laws for investors.' },
              ],
            },
            {
              title: 'State marketing & media promotion',
              icon: 'campaign',
              services: [
                { name: 'Global investment summits', desc: 'Organising major events to promote investment opportunities in the country, including national real estate exhibitions.' },
                { name: 'Mega-project media campaigns', desc: 'Using Club platforms to spotlight national achievements and attract attention to landmark developments.' },
                { name: 'Nation branding', desc: 'Positioning the country as a safe, profitable destination for global real estate investment.' },
              ],
            },
            {
              title: 'Technology & government digital transformation',
              icon: 'developer_board',
              services: [
                { name: 'Blockchain land registry', desc: 'Helping governments migrate land ownership records to blockchain, ensuring tamper-proof title.' },
                { name: 'GIS investment maps', desc: 'Building interactive platforms that display available investment opportunities nationwide in real time.' },
                { name: 'Smart city operations centres', desc: 'Implementing intelligent control rooms for managing utilities and services in national projects.' },
              ],
            },
            {
              title: 'Social responsibility & sustainable development',
              icon: 'eco',
              services: [
                { name: 'Affordable housing models', desc: 'Designing innovative solutions for low-income housing projects with private-sector participation.' },
                { name: 'National green building standards', desc: 'Setting environmental sustainability benchmarks for state-executed real estate projects.' },
                { name: 'Real estate crisis management', desc: 'Providing proactive plans for governments to handle market fluctuations and real estate bubbles.' },
                { name: 'Government staff training programmes', desc: 'Raising the competency of employees in real estate and investment authorities to operate at Club professional standards.' },
              ],
            },
          ],
        },
      },
    },
    serviceDetail: {
      backLink: 'Back to services',
      overviewTitle: 'Service overview',
      detailsTitle: 'Service details',
      otherServices: 'Other services',
      videoTitle: 'Learn more',
      knowMore: 'Learn more',
    },
    audiencePage: {
      eyebrow: 'Target segments',
      title: 'Built for every side of the real estate market',
      subtitle:
        'Membership of Holol Global Real Estate Club opens tailored investment horizons for every part of the real estate market — individuals, banks and financial institutions, companies and developers, and government bodies — through executive tools and exceptional incentives that suit each segment and maximise the value of its assets and its exchanges worldwide.',
      who: 'Club system and membership',
      conceptTitle: 'Core idea',
      conceptText:
        'Goodbye to intermediaries — welcome to the ecosystem. We replaced the traditional commission model with smart membership that saves millions and gives you direct access to comprehensive real estate services under one roof, with full transparency.',
      benefitsTitle: 'Advantage details by segment',
      storyTitle: 'How membership works in practice',
      cards: [
        {
          title: 'For individuals (buyer and seller)',
          text: 'A direct, secure buying and selling experience without commissions, with flexibility for international exchange.',
          icon: 'person',
          bullets: [
            'Zero commissions: keep large sums that used to go to intermediaries and reinvest in the quality of your property.',
            'Absolute safety: access only to properties technically appraised and legally vetted by the club.',
            'International exchange: swap your residential unit inside or outside the country through a smart barter system.',
          ],
        },
        {
          title: 'For real estate companies and developers',
          text: 'Reach serious clients faster with lower marketing cost and greater media power.',
          icon: 'domain',
          bullets: [
            'Lower marketing cost: direct access to a database of millions of serious (verified) subscribers.',
            'Media strength: place company projects in the club\'s dedicated media programs and coverage.',
            'Accelerated sales: the club\'s system shortens the paperwork and time needed to close deals.',
          ],
        },
        {
          title: 'For banks and financial institutions',
          text: 'More reliable assets and a direct channel for financing and stronger cash flows.',
          icon: 'account_balance',
          bullets: [
            'Lower credit risk: assets appraised with precision and transparency for safer financing.',
            'Direct sales channel: offer mortgage and savings programs straight to targeted segments inside the club.',
            'Higher deposits: attract large cash flows from buy, sell, and exchange activity through the system.',
          ],
        },
        {
          title: 'For social and sports clubs',
          text: 'A partnership that adds value for members and opens new operating revenue for the club.',
          icon: 'sports_soccer',
          bullets: [
            'Added value for members: offer the club\'s real estate services as an exclusive privilege for your members.',
            'Operating returns: create cooperation and joint-investment opportunities that benefit the club\'s budget.',
            'Exhibitions: host elite real estate events on club premises under “Holol Club” sponsorship.',
          ],
        },
      ],
      partnershipPortal: {
        title: 'Partners portal: join the global ecosystem',
        subtitle:
          'This is not a simple contact form — it is a strategic partnership gateway for institutions that aspire to lead.',
        bullets: [],
        cta:
          'We are not looking for subscribers; we are forging a global alliance. If you represent an institution that aspires to lead and to work under a banner of professionalism and safety, we invite you to submit your official application to join the Holol Real Estate Club. Join the elite that will redraw the real estate map across 100 countries.',
      },
      applicationSection: {
        title: 'Individual membership application',
        subtitle: 'Join the Holol Global Real Estate Club',
        subtitleSecond: 'and choose the membership that fits your needs.',
        intro:
          'This form is for individuals applying for one of the club\'s three membership tiers — Individual, Pioneer, or Elite. Select the tier that suits you, complete your details, and we will review your application and contact you to finalize your membership and start accessing the club\'s international real estate ecosystem.',
        next: 'Next',
        back: 'Back',
        stepProgress: 'Step {current} of {total}',
        sections: {
          category: 'Choose your membership tier',
          basic: 'Basic information',
          professional: 'Professional profile (institutions and companies only)',
          interests: 'Membership interests',
          motivation: 'Statement of intent to join',
          confirmation: 'Seriousness confirmation',
        },
        basicFields: {
          fullName: 'Full name',
          country: 'Country (from 100-country list)',
          city: 'City',
          whatsapp: 'Contact number (international WhatsApp)',
          email: 'Email',
        },
        professionalFields: {
          license: 'Commercial registration / professional license number',
          portfolio: 'Track record (website link or company profile)',
          impact: 'Geographic reach (local / regional / international)',
        },
        interestPrompt: 'What are you seeking from Holol Club?',
        interestOptions: [
          'Benefit from the international real estate exchange system.',
          'Market projects through the club media ecosystem.',
          'Access accredited real estate valuation services.',
          'Partner in major real estate auctions.',
          'Provide member-focused real estate financing solutions.',
          'Other',
        ],
        motivationPlaceholder:
          'Please write a short summary of your goals in joining the Holol Real Estate Club…',
        confirmationLabel:
          'I confirm the accuracy of the information provided and agree to the Real Estate Club policies and smart membership terms.',
        submit: 'Submit membership application',
      },
    },
    strategyPage: {
      eyebrow: 'Our vision and goals',
      title: 'Precision in real estate strategy',
      subtitle:
        'Our mission is to elevate real estate culture through data-driven insight and innovative marketing solutions that raise the entire market.',
      goals: 'Our strategic objectives',
      items: [
        {
          title: 'Spread real estate culture',
          text: 'Spread real estate awareness and generalize the concept of real estate culture across the market.',
          icon: 'public',
        },
        {
          title: 'Global best practices',
          text: 'Bring the world\'s best real estate practices into the local market.',
          icon: 'language',
        },
        {
          title: 'Integrated marketing services',
          text: 'Deliver every real estate marketing service supported by data.',
          icon: 'campaign',
        },
        {
          title: 'Creative, non-traditional outcomes',
          text: 'Achieve creative, non-traditional outcomes through accurate data.',
          icon: 'auto_awesome',
        },
        {
          title: 'Elevate the sector',
          text: 'Elevate the real estate sector and create innovative solutions for sales and marketing.',
          icon: 'rocket_launch',
        },
      ],
      benefitsEyebrow: 'Membership advantages',
      benefitsTitle: 'Advantages for every segment',
      benefits: {
        companies: {
          title: 'For Companies',
          items: [
            'Accelerate sales and achieve sales targets',
            'Access every media channel to market projects',
            'Exhibitions and offices to sell properties globally',
            'Solve collection and administrative issues via the Real Estate Certificate',
          ],
        },
        banks: {
          title: 'For Banks',
          items: [
            'An essential strategic partner that guarantees seriousness, trust, and the rights of all parties',
            'Attract large numbers of customers to invest through the bank',
            'Expand the bank into new customer segments',
            'Grow real estate financing volumes',
            'Use every media channel to spread bank services',
            'Market bank-owned auctions through the club',
          ],
        },
        clubs: {
          title: 'For clubs',
          items: [
            'Deliver a new service to all members',
            'Material benefit to the club from this model',
            'Promotion and marketing for the club and its services through the large-scale marketing campaign',
          ],
        },
        customers: {
          title: 'For Customers',
          items: [
            'A direct meeting place for buyers and sellers only',
            'All services without commissions',
            'All services without middlemen',
            'Buy property and receive your money back through the Real Estate Certificate',
          ],
        },
      },
    },
    principlesSection: {
      eyebrow: 'Principles of success',
      title: 'How we realize the vision',
      subtitle:
        'General notes for project success — taken directly from the founding study.',
      items: [
        {
          title: 'Excellent choice of advertising channels',
          text: 'Advertising media must be selected carefully so the service is presented in the best possible way.',
          icon: 'ads_click',
        },
        {
          title: 'Cooperation protocols',
          text: 'Establish cooperation protocols with banks and clubs to make full use of the concept.',
          icon: 'handshake',
        },
        {
          title: 'Leadership at the highest level',
          text: 'Appoint an administrative team at the highest level to run this concept successfully.',
          icon: 'workspace_premium',
        },
        {
          title: 'Gradual launch',
          text: 'A separate study exists to roll the idea out in brief form on social media first, before reaching the full-scale model.',
          icon: 'route',
        },
      ],
    },
    marketingPage: {
      sectionTitle: 'Media power',
      title: 'The comprehensive marketing strategy and media power',
      points: [
        {
          label: 'Strategic media direction',
          text: 'Partnerships with the largest global economic networks and channels, to steer investment opinion and create financial momentum.',
        },
        {
          label: 'Economic marketing for the state',
          text: 'Coordination with official platforms and sovereign institutions, to frame real estate opportunities and activate direct investment appeal.',
        },
        {
          label: 'Cross-border digital reach',
          text: 'Advanced digital platforms and executive networks that reach elite segments and investment institutions directly, worldwide.',
        },
      ],
      // Home page "Media power" section: the text beside the globe, and the globe's description.
      homeEyebrow: 'Media reach without borders',
      titleLead: 'A strategy for media inclusion and',
      titleHighlight: 'sovereign marketing',
      homeText:
        'A cross-border marketing system built on the belief that media runs the economy. It brings together the largest global media networks, advanced digital platforms and the economic marketing arms of states in one integrated, multi-channel approach, creating investment momentum and steering capital flows towards major real estate opportunities worldwide.',
      globeLabel:
        "A turning globe circled by the club's nine media channels: television, radio, exhibitions, banks, the magazine, sports clubs, social media, the website and the mobile app.",
      methods: 'Media power',
      methodsSub:
        '“Property in the spotlight.” We are the media engine that never sleeps: we turn your property into a success story through our various marketing channels and a global platform, carrying your investment opportunity to elites everywhere.',
      items: [
        {
          title: "Television program",
          text: "A global television program, produced in collaboration with a prestigious media network, designed to reinforce the Club’s position as a leading international authority in real estate by highlighting future trends, groundbreaking innovations, and emerging opportunities that are redefining the global real estate landscape.",
          icon: "tv",
          video: televisionprogram,
        },
        {
          title: "Radio program",
          text: "A distinguished radio program dedicated to highlighting the Real Estate Club’s services and exclusive advantages, while showcasing the opportunities and innovative solutions it offers to its members and strategic partners across diverse real estate markets.",
          icon: "radio",
          video: radioprogram,
        },
        {
          title: "Real estate exhibitions",
          text: "The International Real Estate Exhibition of the Real Estate Club is a global destination that brings together leading figures in the real estate sector from more than 1,000 international companies and institutions. It showcases the latest innovations, services, and advanced solutions, while creating high-value opportunities for investment, collaboration, and cross-border partnerships—further strengthening its position as one of the world’s most prominent real estate gatherings.",
          icon: "storefront",
          video: realestateexhibition,
        },
        {
          title: "Banks",
          text: "The Real Estate Club collaborates with leading global banks to provide integrated financing and investment services to its clients, ensuring access to advanced financial solutions that support and enhance real estate investment opportunities worldwide.",
          icon: "account_balance",
          video: bankbranchs,
        },
        {
          title: "Real estate magazine",
          text: "A specialized real estate magazine featuring a distinguished group of experts and professionals in the real estate sector, aimed at highlighting and publishing innovative solutions and advanced insights that contribute to the development of the industry and enhance its efficiency.",
          icon: "menu_book",
          video: realestatemagazine,
        },
        {
          title: "Sports clubs",
          text: "The Real Estate Club provides its integrated real estate services to leading global sports clubs, reflecting its pioneering expertise in delivering and developing real estate solutions in accordance with the highest international standards.",
          icon: "newsmode",
          video: sportsclub,
        },
        {
          title: "Social media",
          text: "Intensive marketing and media campaigns launched by the Real Estate Club across YouTube, Facebook, Instagram, and Twitter, aimed at solidifying the concept, expanding its reach, and promoting it in a highly professional and impactful manner.",
          icon: "share",
          video: socialmedia,
        },
        {
          title: "Website",
          text: "An integrated and large-scale website dedicated to the Real Estate Club, serving as an advanced digital platform that reflects its institutional identity and presents its services and strategic vision in a professional manner, thereby strengthening its presence within the real estate sector.",
          icon: "language",
          video: website,
        },
        {
          title: "Mobile application",
          text: "A dedicated mobile application for the Real Estate Club, designed to promote its vision and expand its reach, while providing an integrated digital platform that enables clients to access all services easily, smoothly, and with high efficiency.",
          icon: "smartphone",
          video: mobileapp,
        },
      ],
      partnerships: {
        eyebrow: "How we market the concept",
        title: 'Direct reach through strategic contracts',
        subtitle:
          'Direct advertising to everyone interested in property, with strategic contracts that turn every bank and every club into a distribution channel for the club\'s services.',
        items: [
          {
            title: 'Direct advertising',
            text: 'Direct advertising through the TV and radio programs, the real estate exhibition, the real estate magazine, the website, and all social media channels.',
            icon: 'campaign',
          },
          {
            title: 'Contracting with every club',
            text: 'Contracting with every club to deliver every Real Estate Club service to its clients.',
            icon: 'groups',
          },
          {
            title: 'Contracting with every bank',
            text: 'Contracting with every bank to deliver every Real Estate Club service to its clients.',
            icon: 'account_balance',
          },
        ],
      },
    },
    ideasPage: {
      eyebrow: 'Exclusive ideas',
      title: 'New ideas inside the Real Estate Club',
      subtitle:
        'Two distinctive concepts that energize the real estate market and offer a new model for buying and trading.',
      cards: [
        {
          title: 'Real Estate Investment Certificate',
          text:
            'An innovative investment model that redefines real estate dynamics; allowing investors to acquire physical real estate while guaranteeing a 100% full recovery of the initial purchase value upon the completion of a defined term. Structured through strategic banking partnerships, this model leverages guaranteed compound yield mechanisms, offering seamless property ownership paired with absolute capital preservation.',
          icon: 'verified',
        },
        {
          title: 'The Real Estate Supermarket',
          text:
            'A comprehensive operational platform bringing together premium global real estate opportunities alongside HOLOL\'s full suite of legal, engineering, and advisory services under one roof. Designed to deliver an end-to-end investment experience, it empowers clients to discover, acquire, and manage international properties seamlessly through a single, unified gateway.',
          icon: 'storefront',
        },
      ],
      certificateDeep: {
        eyebrow: 'Pillar innovation',
        title: 'Inside the Real Estate Certificate idea',
        subtitle: 'A three-part concept that redefines real estate ownership.',
        points: [
          {
            title: 'Encourage buying and selling',
            text: 'Speeds up buying and selling activity across the entire real estate market.',
            icon: 'rocket_launch',
          },
          {
            title: 'Activate the real estate market',
            text: 'Recycles idle capital and stagnant stock in the market.',
            icon: 'bolt',
          },
          {
            title: 'The property and your full funds',
            text: 'The client receives the property and the full amount after a set period, guaranteed by major partner banks.',
            icon: 'verified_user',
          },
        ],
      },
      extrasEyebrow: 'Sovereign track',
      extrasTitle: 'We are the bridge that carries our nations\' visions to the world stage',
      extras: [
        {
          title: 'Sovereign Pathway & Nation Branding',
          subtitle:
            'The strategic bridge projecting sovereign projects and national visions onto the global stage.',
          text: 'A strategic framework designed for direct engagement with government entities and ministries (including Investment, Housing, and Media) to structure and market mega-developments and state-owned land assets across our global executive and media platforms. Centered on “Economic Nation Branding”, this pathway transforms national economic visions into prime destinations for institutional and cross-border capital flows.',
          icon: 'domain',
        },
        {
          title: 'Global Real Estate Franchise',
          subtitle:
            'Global institutional expansion through the first integrated real estate franchise model.',
          text: 'An innovative operational framework enabling the international expansion of the HOLOL Real Estate Club brand through a structured global franchise model. This concept empowers global partners to operate under HOLOL’s institutional identity, supported by our proprietary operational systems, extensive media-capital network, and integrated technical-legal infrastructure — redefining cross-border agency operations.',
          icon: 'language',
        },
      ],
    },
    investmentPage: investmentPageEn,
    mediaInitiativePage: mediaInitiativePageEn,
    sportsClubsPage: sportsClubsPageEn,
    phaseOnePage: {
      eyebrow: 'Strategic partners & service providers',
      title: 'Holol Real Estate Club Network Profile',
      subtitle:
        'An integrated international platform building a corporate, service, and media network — connecting real estate companies, specialized providers, clubs, banks, institutions, and markets within one ecosystem.',
      video: {
        title: 'Overview for service providers and strategic partners',
        placeholder: 'Video coming soon',
        videoUrl: "https://www.youtube.com/watch?v=SJvMHYv2hqY",
        videoSrc: null,
      },
      sections: [
        {
          title: 'Who We Are',
          text: '',
          paragraphs: [
            'Holol Real Estate Club is an integrated international platform designed to build a corporate, service, and media network connecting real estate companies, specialized service providers, clubs, banks, institutions, government entities, and local and international markets within one ecosystem built on inclusiveness, reach, integration, and added value.',
            'We are not building a traditional brokerage or direct-sales model. Instead, we are building an integrated ecosystem that connects demand, supply, service, media, and membership, turning the platform into a meeting point for multiple real estate and service market stakeholders across several countries.',
          ],
          icon: 'hub',
        },
        {
          title: 'Why Us Now?',
          text: '',
          paragraphs: [
            'The real estate, service, and investment sectors in the region and worldwide are undergoing a clear transformation in how services are delivered, trust is built, relationships are managed, and influence is expanded.',
            'Success is no longer driven by a single service offering, but by a platform\'s ability to:',
          ],
          bullets: [
            'bring services together in one place',
            'open new markets',
            'build strong institutional relationships',
            'deliver real media and commercial value',
            'and facilitate access to clients and opportunities in a more professional way',
          ],
          closingParagraph:
            'Hence, Holol Real Estate Club presents a model different from traditional models — one that goes beyond real estate marketing or brokerage into a broader and more comprehensive ecosystem that creates real value for every party within it.',
          icon: 'trending_up',
        },
        {
          title: 'What has been achieved so far',
          text:
            'The project\'s core foundations have already been developed — confirming that this is not merely a theoretical idea, but a platform already evolving into real operations.',
          bullets: [
            'Defining the club\'s overall vision',
            'Building the multi-service and multi-stream model',
            'Launching a promotional platform for the project',
            'Beginning development of the club application',
            'Contacting a large number of companies and organizations',
            'Receiving initial engagement and interest from multiple parties',
            'Preparing the structure for memberships, services, events, and media content',
            'Reaching an advanced stage of executive preparation',
          ],
          icon: 'task_alt',
        },
        {
          title: 'What Is Holol Real Estate Club?',
          text: '',
          paragraphs: [
            'Holol Real Estate Club is not a traditional real estate brokerage, not a real estate marketing company only, and not a commission platform. Rather, it is an integrated ecosystem that combines:',
          ],
          bullets: [
            'memberships',
            'specialized services',
            'media',
            'events',
            'exhibitions',
            'partnerships',
            'and international expansion',
          ],
          closingParagraph:
            'In doing so, it creates a new business environment that combines commercial value, media value, and institutional value within one framework.',
          icon: 'apartment',
        },
        {
          title: 'Core Strengths of the Real Estate Club',
          text: '',
          splitItemRows: true,
          splitItemChunkSize: 3,
          icon: 'military_tech',
          closingParagraph:
            'Thus, the club becomes a platform that serves not only individuals and companies, but whose benefit also extends to clubs, banks, institutions, government entities, national initiatives, and the government visions of nations.',
          items: [
            {
              label: 'First: Inclusiveness',
              text:
                'The Real Estate Club brings a large number of services together in one place, giving the client, partner, or member a fully integrated experience rather than dealing with multiple fragmented parties.',
            },
            {
              label: 'Second: Zero-Commission and No Traditional Middlemen',
              text:
                'The club does not rely on the traditional intermediary model or conventional commissions. Instead, it seeks to directly connect the different parties within the ecosystem, creating more clarity, greater value, and lower cost in many cases, while offering members, companies, and beneficiaries a more efficient and transparent experience.',
            },
            {
              label: 'Third: Media Power',
              text: 'The club relies on a large media arm that includes:',
              bullets: [
                'television programs',
                'newspapers',
                'real estate magazines',
                'events',
                'conferences',
                'and exhibitions',
              ],
            },
            {
              label: 'Fourth: International Reach',
              text:
                'The club starts with 15 countries in Phase 1, then expands gradually to 100 countries within five years.',
            },
            {
              label: 'Fifth: Partnerships with Clubs and Institutions',
              text: 'The Real Estate Club does not operate in isolation. It builds wide partnerships with:',
              bullets: ['clubs', 'institutions', 'banks', 'service providers', 'and other relevant entities'],
            },
            {
              label: 'Sixth: Serving Government Visions and Official Entities',
              text:
                'The Real Estate Club also extends its role to serve government entities and national development visions in the target countries by contributing to:',
              bullets: [
                'activating real estate and service sectors',
                'attracting investment',
                'supporting the country\'s international presence',
                'linking local markets to external opportunities',
                'and providing a platform that helps achieve growth, expansion, and institutional promotion objectives',
              ],
            },
          ],
        },
        {
          title: 'International expansion plan — Phase 1',
          text:
            'Phase 1 launches across 15 countries, then expands gradually through five phases to 100 countries within five years.',
          bullets: [
            'Phase 1: 15 countries',
            'Arab Group: Egypt — Saudi Arabia — UAE — Qatar — Sultanate of Oman',
            'European Group: France — Germany — Italy — United Kingdom — Spain',
            'Global Group: Turkey — Singapore — Malaysia — Greece — Cyprus',
            'Phase 2: 35 countries',
            'Phase 3: 60 countries',
            'Phase 4: 80 countries',
            'Phase 5: 100 countries',
          ],
          icon: 'public',
        },
        {
          title: 'What Do Partners and Service Providers Gain?',
          text: 'The club creates tangible value for every professional segment in the ecosystem:',
          bullets: [
            'Real estate developers — new markets, media presence, and international showcase of projects',
            'Advertising and marketing firms — sponsorships, campaigns, and exposure across multiple countries',
            'Construction and contracting companies — cross-border projects and long-term execution partnerships',
            'Asset management and maintenance — operational contracts and a recurring client network',
            'Legal, accounting, and tax firms — referrals and institutional presence within a strong network',
            'Banks and financing companies — real financing demand, partnerships, and institutional vision',
            'Clubs and institutions — new services for their members and access to an elite international network',
            'Government entities — support for institutional promotion and linking local investment with international opportunities',
            'Residency, immigration, and citizenship providers — high-value clients and cross-border investment flow',
          ],
          icon: 'handshake',
        },
        {
          title: 'What Does the Real Estate Club Offer to Partners?',
          text: '',
          paragraphs: ['The Real Estate Club grants partners and service providers:'],
          bullets: [
            'Presence within an integrated international platform.',
            'Opportunities to access new markets.',
            'Participation in events, exhibitions, and media programs.',
            'The chance to operate within a wide elite and institutional network.',
            'Higher professional standing within a selective ecosystem.',
            'The ability to reach new clients and partners.',
            'The benefit of the club\'s media and marketing power.',
            'An opportunity to align with the expansion paths and government visions in the target countries.',
          ],
          icon: 'volunteer_activism',
        },
        {
          title: 'Participation and Accreditation Criteria',
          text: '',
          paragraphs: [
            'The Real Estate Club does not open the door to everyone randomly, but relies on selection and vetting according to clear professional criteria. These criteria include:',
          ],
          bullets: [
            'That the company has a good reputation.',
            'That the company profile is strong and clear.',
            'Review of legal documents, accreditations, and licenses.',
            'Commitment to quality and professional standards.',
            'Acceptance of work according to the club\'s policies and professional discourse.',
            'The ability to deliver real value to the club\'s members and partners.',
            'The company\'s suitability for the nature of services and standards approved within the ecosystem.',
          ],
          closingParagraph:
            'Any partner or service provider is approved after an initial review that ensures their compatibility with the spirit and requirements of the club, preserving the quality, value, and reputation of the ecosystem.',
          icon: 'verified_user',
        },
        {
          title: 'The Real Estate Club\'s Distinct Identity',
          text: '',
          icon: 'diamond',
          items: [
            {
              paragraphs: [
                'The Real Estate Club stands out because it is: not a traditional sales platform, not a real estate intermediary only, and not a limited local project. Rather, it is a global ecosystem that combines:',
              ],
              bullets: [
                'media',
                'memberships',
                'services',
                'international expansion',
                'institutional partnerships',
                'and public service for government and developmental visions',
              ],
              closingParagraph:
                'This is the essence of the difference that gives it a higher value than traditional models.',
            },
            {
              label: 'Why Is Joining Considered an Opportunity?',
              paragraphs: ['Because joining the Real Estate Club means:'],
              bullets: [
                'entering a network with global expansion',
                'reaching a wider audience',
                'presence within an institutional and media ecosystem',
                'benefiting from new opportunities in several countries',
                'building a long-term relationship with a project capable of growth and expansion',
                'participating in an ecosystem that can serve the private sector and the government sector at the same time',
              ],
            },
          ],
        },
      ],
      conclusion: {
        step: '12',
        title: 'Conclusion',
        icon: 'summarize',
        paragraphs: [
            'Holol Real Estate Club operates under the "Club of 100" concept, which is based on bringing together 100 leading companies in each country where the club is present, representing a wide range of real estate specialties. These include real estate development, construction and contracting, asset management, maintenance and operations, as well as other services related to the real estate sector. The objective is to create an integrated ecosystem of partners and industry experts that delivers comprehensive real estate solutions while fostering collaboration, business growth, and investment opportunities.',
          'Holol Real Estate Club is far more than a real estate project. It is a broad, integrated platform designed to build an international network of services, opportunities, partnerships, media, and memberships in a way that creates real value for every party involved.',
          'We are seeking partners, service providers, and institutions that believe in inclusiveness, professionalism, reach, and integration, and who can be part of this global ecosystem in its first phase of execution.',
        ],
      },
      partnerApplication: {
        title: 'Official partnership application',
        subtitle:
          'Please complete the following sections so we can route your request to the correct administrative track.',
        intro:
          'We are not looking for subscribers; we are forging a global alliance. If you represent an institution that aspires to lead and to work under a banner of professionalism and safety, we invite you to submit your official application to join the Holol Real Estate Club. Join the elite that will redraw the real estate map across 100 countries.',
        next: 'Next',
        back: 'Back',
        stepProgress: 'Step {current} of {total}',
        sections: {
          category: 'Applicant classification (select category)',
          basic: 'Basic information',
          professional: 'Professional profile (institutions and companies only)',
          interests: 'Partnership interests',
          motivation: 'Statement of intent to join',
          confirmation: 'Seriousness confirmation',
        },
        categoryOptions: [
          'Real estate development / marketing company',
          'Financial institution / bank',
          'Government body / sovereign institution',
          'Sports / social / professional club or association',
        ],
        basicFields: {
          fullName: 'Full name / registered entity name',
          country: 'Country (from 100-country list)',
          city: 'City / headquarters',
          whatsapp: 'Contact number (international WhatsApp)',
          email: 'Official email',
        },
        professionalFields: {
          license: 'Commercial registration / professional license number',
          portfolio: 'Track record (website link or company profile)',
          impact: 'Geographic reach (local / regional / international)',
        },
        interestPrompt: 'What are you seeking from Holol Club?',
        interestOptions: [
          'Benefit from the international real estate exchange system.',
          'Market projects through the club media ecosystem.',
          'Access accredited real estate valuation services.',
          'Partner in major real estate auctions.',
          'Provide member-focused real estate financing solutions.',
          'Other',
        ],
        motivationPlaceholder:
          'Please write a short summary of your goals in joining the Holol Real Estate Club…',
        confirmationLabel:
          'I confirm the accuracy of the information provided and agree to the Real Estate Club policies and partnership terms.',
        submit: 'Submit official partnership application',
      },
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      audience: 'عضوية النادي',
      strategy: 'الرؤية',
      phaseOne: 'الشركاء',
      investment: 'الاستثمار',
      marketing: 'القوة الاعلامية',
      mediaInitiative: 'المبادرة الاعلامية',
      sportsClubs: 'الأندية الرياضية',
      visualHub: 'مركز حلول المرئي',
      ideas: 'أفكار جديدة',
      cta: 'انضم للنادي',
      who: 'من نحن',
      founder: 'المؤسس',
      aiAssistant: 'مساعد حلول الذكي',
    },
    hero: {
      badge: 'النادي العقاري ',
      title: 'وجهة العالم و منظومة المستقبل',
      subtitle:
        '"لاننا نؤمن ان العقار هو لغة العالم المشتركة اوجدنا منصة توحد القارات في نظام واحد نحن لسنا مجرد خيار بل نحن المحطة التي يلتقي فيها المستثمرون من 100 دولة لصناعة مستقبل عقاري ذكي - امن - عابر للحدود".',
      explore: 'استعرض الخدمات',
      latestProjects: 'أحدث مشاريعنا',
      previousWork: 'أعمالنا السابقة',
      latestProjectsHref: 'https://www.holol.club/',
      previousWorkHref: 'https://www.adhamelsharkawy.com/',
      marketing: 'لمعرفة المزيد',
      videoCaption: 'نادي حلول العقاري العالمي',
    },
    stats: [
      { value: '20', label: 'خدمة عقارية متكاملة' },
      { value: '5', label: 'شرائح مستهدفة' },
      { value: '0%', label: 'بدون عمولات أو وسطاء' },
      { value: '100', label: 'دولة' },
      { value: '∞', label: 'إمكانية الامتياز حول العالم' },
    ],
    intro: {
      eyebrow: '',
      title: 'مرحبًا بك في النادي العقاري',
      pairs: [
        {
          leadGold: 'نادي حلول العقاري:',
          leadRest: '"حيث تُدار الثروات.. وتتحقق الرؤى"',
          body: 'العقار ليس جدراناً، بل هو ثروة تحتاج إلى إدارة احترافية ورؤية ثاقبة. نحن نحول الطموحات الكبرى والمشاريع القومية إلى واقع ملموس، من خلال منظومة تربط بين رأس المال الذكي والفرص السيادية والوطنية الكبرى.',
        },
        {
          leadGold: 'نادي حلول العقاري:',
          leadRest: '"الثورة الكبرى في عالم الأصول"',
          body: 'جئنا لنغير قواعد اللعبة. في نادي حلول، نكسر قيود العمولات التقليدية ونلغي دور الوسطاء، لنعيد القوة للبائع والمشتري مباشرة تحت مظلة من الشفافية المطلقة والحلول الابتكارية التي لم يشهدها السوق من قبل.',
        },
        {
          leadGold: 'نادي حلول العقاري:',
          leadRest: '"استثمارٌ بلا حدود.. وثقةٌ بلا قيود"',
          body: 'نمنحك حرية التحرك في أسواق 100 دولة بضغطة زر، مدعومة بنظام تقييم وقانوني صارم. استثمر في أي مكان في العالم، وتبادل أصولك بكل مرونة، وأنت مطمئن بأن حقوقك محمية بأقوى منظومة ثقة عالمية.',
        },
        {
          leadGold: 'نادي حلول العقاري:',
          leadRest: '"المنظومة العالمية لإدارة الفكر والاستثمار العقاري"',
          body: 'الاستثمار الناجح يبدأ بفكر سليم. نحن لا نوفر منصة للبيع والشراء فحسب، بل ندير الثقافة العقارية ونضع المعايير الدولية للتقييم والإدارة. نحن المؤسسة التي تدمج قوة الإعلام بذكاء الاستثمار، لتصنع منظومة متكاملة تليق بنخبة المستثمرين.',
        },
      ],
      link: 'اكتشف رؤيتنا',
    },
    homeIntroVideo: {
      title: 'فلسفة نادي حلول العقاري',
      videoUrl: 'https://youtu.be/tu-cT9rajyg',
    },
    studyOverview: {
      eyebrow: 'دراسة المشروع',
      title: 'محاور الدراسة التأسيسية',
      subtitle: 'دراسة مختصرة لفكرة مشروع النادي العقاري بقلم د/ أدهم الشرقاوي، مدير شركة بنان للحلول المتكاملة.',
      chapters: [
        { title: 'أهداف النادي', icon: 'flag' },
        { title: 'مميزات الأعضاء', icon: 'workspace_premium' },
        { title: 'المستهدف من الدراسة', icon: 'gps_fixed' },
        { title: 'خدمات النادي', icon: 'apartment' },
        { title: 'أفكار جديدة', icon: 'lightbulb' },
        { title: 'طريقة التسويق', icon: 'campaign' },
        { title: 'التكاليف والإيرادات', icon: 'payments' },
        { title: 'ملاحظات عامة', icon: 'sticky_note_2' },
      ],
    },
    servicesHome: {
      title: 'خدماتنا الأساسية',
      subtitle: 'دورة حياة متكاملة من الحلول العقارية للأفراد والشركات والبنوك والجهات الحكومية.',
      moreTitle: 'تريد معرفة المزيد؟',
      moreText: 'استعرض القائمة الكاملة لكل الخدمات العقارية المتكاملة التي يقدمها النادي.',
      moreCta: 'اعرف أكثر',
      learnMoreCta: 'لمعرفة المزيد اضغط هنا',
      deckHint: 'مرّر المؤشر لاستكشاف خدماتنا',
      deckHintTouch: 'اضغط لاستكشاف خدماتنا',
    },
    cards: [
      {
        title: 'البيع والشراء',
        text: 'بيع وشراء مباشر للأفراد والشركات بدون عمولات أو وسطاء.',
        icon: 'real_estate_agent',
      },
      {
        title: 'التمويل العقاري',
        text: 'شراكات بنكية استراتيجية لتوفير تمويل شفاف للبائعين والمشترين.',
        icon: 'account_balance',
      },
      {
        title: 'الاستشارات القانونية',
        text: 'تغطية قانونية كاملة وعقود وامتثال يحمي جميع أطراف الصفقة.',
        icon: 'gavel',
      },
      {
        title: 'التقييم العقاري',
        text: 'تقييم فني وتسويقي دقيق يحمي المستثمرين ويدعم التسعير العادل.',
        icon: 'rule',
      },
      {
        title: 'التسويق العقاري',
        text: 'حملات إعلامية متكاملة لتسويق الوحدات والمشاريع للوصول إلى عملاء مؤهلين.',
        icon: 'campaign',
      },
      {
        title: 'إدارة الأملاك',
        text: 'إدارة تشغيل وصيانة احترافية للحفاظ على قيمة الأصل العقاري على المدى الطويل.',
        icon: 'apartment',
      },
    ],
    howItWorks: {
      eyebrow: 'كيف يعمل النادي',
      title: 'لماذا نحن مختلفون',
      subtitle: 'ستة مبادئ تجعل النادي العقاري مختلفًا عن أي طرف آخر في السوق.',
      ctaText: 'هل أنت مستعد للانضمام إلى منظومة عقارية موثوقة؟',
      ctaButton: 'قدّم طلب الانضمام',
      steps: [
        {
          number: '01',
          title: 'لقاء مباشر بين البائع والمشتري',
          text: 'ملتقى واحد يجمع البائعين والمشترين الجادين على منصة واحدة.',
          icon: 'handshake',
          image:
            'https://thehill.com/wp-content/uploads/sites/2/2022/01/tto2c2l.jpeg?strip=1',
        },
        {
          number: '02',
          title: 'بدون عمولات وبدون وسطاء',
          text: 'كل عمليات البيع والشراء والخدمات العقارية بلا عمولات ولا وسطاء.',
          icon: 'payments',
          image:
            'https://images.pexels.com/photos/4386431/pexels-photo-4386431.jpeg?auto=compress&cs=tinysrgb&w=1600',
        },
        {
          number: '03',
          title: 'ضمان بنكي',
          text: 'البنوك الكبرى تضمن كل صفقة وتحمي الثقة وحقوق جميع الأطراف.',
          icon: 'verified_user',
          image:
            'https://images.unsplash.com/photo-1684679674829-fc7b436ec8e8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fGJhbmt8ZW58MHx8MHx8fDA%3D',
        },
        {
          number: '04',
          title: 'الثورة العقارية',
          text: 'نستبدل الوسيط التقليدي بنظام إداري يحمي حقوقك.',
          icon: 'handshake',
          image:
            'https://plus.unsplash.com/premium_photo-1725404428224-664f5f0217b3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE3fHxiYW5rfGVufDB8fDB8fHww',
        },
        {
          number: '05',
          title: 'العبور الدولي',
          text: 'استثمر وبادل عقارك في 100 دولة بدعم شراكات حكومية وبنكية دولية.',
          icon: 'globe',
          image:
            'https://images.pexels.com/photos/346885/pexels-photo-346885.jpeg?auto=compress&cs=tinysrgb&w=1600',
        },
        {
          number: '06',
          title: 'التقييم العادل',
          text: 'تقييم فني وقانوني إلزامي يضمن أن كل صفقة تتم بسعرها العادل.',
          icon: 'balance',
          image:
            'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROsHUFQ9710us1aVf1Y9bcVPYkRwgFkpT7ADE6yDkLkg&s',
        }

      ],
    },
    goalsSection: {
      eyebrow: 'مهمتنا',
      title: 'أهداف النادي العقاري',
      subtitle: 'خمسة أهداف استراتيجية مأخوذة من الدراسة التأسيسية للنادي العقاري.',
      items: [
        {
          title: 'نشر الوعي العقاري',
          text: 'نشر الوعي والثقافة العقارية بين كل أطراف السوق.',
        },
        {
          title: 'تعميم الثقافة العقارية',
          text: 'تعميم مفهوم الثقافة العقارية لتصبح لغة مشتركة في السوق.',
        },
        {
          title: 'أفضل الممارسات العالمية',
          text: 'نشر أفضل الممارسات العقارية في العالم داخل السوق المحلي.',
        },
        {
          title: 'تسويق متكامل بالبيانات',
          text: 'تقديم كافة خدمات التسويق العقاري وتوفير البيانات لتحقيق أفضل النتائج الخلاقة غير التقليدية.',
        },
        {
          title: 'النهوض بالقطاع',
          text: 'النهوض بالقطاع العقاري وإيجاد حلول ابتكارية للبيع والتسويق.',
        },
      ],
    },
    ideasHome: {
      eyebrow: 'أفكار حصرية',
      titleLead: 'ابتكارات «حلول»',
      titleHighlight: 'الاستثمارية',
      certificate: {
        title: 'الشهادة العقارية الاستثمارية',
        text: 'تملك عقارك اليوم واسترِد كامل قيمته الشرائية بضمان بنكي.',
      },
      supermarket: {
        title: 'السوبر ماركت العقاري',
        text: 'كل عقارات العالم وخدماتها المتكاملة تحت سقف واحد.',
      },
      cta: 'شاهد جميع الأفكار',
    },
    founderHome: {
      eyebrow: 'المؤسس',
      title: 'رؤية المؤسس: إعادة تشكيل الثقافة العقارية عبر الإعلام والحلول المباشرة',
      name: 'د. أدهم الشرقاوي | مؤسس نادي حلول العقاري العالمي',
      text:
        'لم نبتكر نادي حلول ليكون مجرد منصة عقارية، بل أطلقناه كمحرك استراتيجي يعيد تشكيل الثقافة العقارية العالمية من خلال دمج قوة الإعلام بذكاء التكنولوجيا. إننا ننطلق من عقيدتنا بأن الإعلام المتخصص هو المدير الفعلي للاقتصاد، لنبني المرجع العالمي الأوحد الذي يربط الأفراد والمؤسسات عبر 100 دولة ببيئة استثمارية آمنة، شفافة، وبلا وسطاء، قائمة على العدالة والقيمة الحقيقية.',
    },
    investmentHome: {
      eyebrow: 'فرصة استثمارية',
      title: 'الفرصة الاستثمارية في "حلول"',
      subtitle: 'دعوة استراتيجية لكبار المستثمرين، المكاتب العائلية، وإدارات الثروات الخاصة عبر العالم.',
      paragraphs: [
        'يُشكل "نادي حلول العقاري العالمي" المنظومة الأولى من نوعها القائمة على نموذج استثماري مبتكر يُعيد تعريف إدارة ونمو الثروات العقارية على مستوى دولي. يرتكز النادي على هيكلية مالية متعددة الإيرادات (Multi-Revenue Platform) تضمن أعلى مستويات التحوط المالي وتنوع مصادر التدفقات النقدية، بدءاً من رسوم العضويات الدورية وحزمة الخدمات الفنية المعتمدة، مروراً بالمزادات العقارية الدولية والتبادل العقاري عابر للحدود، وصولاً إلى الرعايات الإعلامية، المعارض والمؤتمرات، وعمولات الصفقات المؤسسية الكبرى.',
        'وتكتمل هذه المنظومة الاستثمارية بخطة توسع مرحلية مدروسة تنطلق من 15 دولة وصولاً إلى تغطية 100 دولة حول العالم خلال 5 سنوات، مما يمنح الشركاء المستثمرين وإدارات الثروات فرصة استثنائية للمشاركة في ملكية ونمو منصة اقتصادية عالمية آمنة ومستدامة.',
      ],
      cta: 'لمعرفة المزيد',
    },
    membershipHome: {
      eyebrow: 'العضويات الذكية',
      title: 'استثمر بذكاء مع العضويات الذكية من نادي حلول العقاري العالمي',
      text:
        'في نادي حلول العقاري العالمي، ابتكرنا نظام العضويات الذكية كبديل ثوري للعمولات، مما يوفر لعملائنا من الشركات والأفراد والمؤسسات الحكومية ملايين الدولارات سنويًا. انضم إلينا اليوم واستمتع بمزايا حصرية وتوفير هائل في جميع معاملاتك العقارية.',
      cta: 'تعرّف على العضويات',
    },
    ctaBanner: {
      title: 'ارسم مستقبل استثمارك العقاري اليوم.. انضم للنخبة!',
      subtitle: 'منصة حصرية تجمع الأفراد، الشركات، البنوك، النوادي، والمؤسسات الحكومية.. في تحالف واحد.',
      primary: 'انضم للنادي',
      secondary: 'تواصل معنا',
    },
    comingSoon: {
      title: 'نادي حلول العقاري',
      subtitle: '…عصر جديد من الحلول … نقدّم لكم تجربة عقارية لا مثيل لها.',
    },
    visualHook: {
      mapTitle: 'خريطة الانتشار العالمية',
      mapSubtitle: '١٠٠ دولة مستهدفة مضاءة داخل شبكة عقارية إعلامية تعاونية.',
      revolutionTitle: 'الثورة العقارية',
      revolutionText:
        'أول نادي عقاري عالمي يدار بقوة الإعلام والذكاء الاصطناعي.. بدون عمولات، وبدون وسطاء.',
      mediaEngineTitle: 'التكامل الإعلامي',
      mediaEngineText:
        'نموذج يومي يحوّل العقار إلى مادة إعلامية مشوقة عبر البرنامج التليفزيوني والمنصات الاجتماعية والشراكات الإعلامية العالمية.',
      uspsTitle: 'حلول ابتكارية',
      uspsItems: [
        'الشهادة العقارية: أمان مالي أعلى وضمان ثقة المعاملة.',
        'سوبر ماركت العقارات: تجربة تسوق عقاري عالمية بضغطة زر.',
      ],
      noCommissionTitle: 'نظام النادي بلا عمولات',
      noCommissionText:
        'نظام عضوية ذكي يلغي دور الوسيط التقليدي ويحقق وفورات كبيرة للعملاء والمستثمرين.',
      partnersTitle: 'الشركاء الاستراتيجيون',
      partners: ['البنوك', 'الهيئات الحكومية', 'القنوات الإعلامية', 'منصات التكنولوجيا'],
      expoTitle: 'المعرض العالمي الدائم',
      expoText:
        'تصور رقمي-فعلي لمعرض ضخم يكون ملتقى سنوياً عالمياً يجمع البائعين والمشترين والشركات والمؤسسات في منصة واحدة.',
    },
    whoWeAre: {
      pageTitle: '',
      pageSubtitle: 'نادي حلول العقاري',
      visionTitle: 'الرؤية',
      visionText:
        'أن نكون المحرك العالمي الأول لإعادة تشكيل الثقافة العقارية، عبر منظومة رقمية وإعلامية تتخطى الحدود الجغرافية، لتصبح المرجع الموثوق والأوحد لكل من يبحث عن الأمان والاحترافية في عالم الأصول.',
      missionTitle: 'الرسالة',
      missionText:
        'تمكين المجتمع العقاري العالمي (أفراداً ومؤسسات ودولاً) من خلال بيئة استثمارية متكاملة، تدمج بين قوة الإعلام وذكاء التكنولوجيا، لتوفير حلول عقارية شاملة بدون عمولات أو وسطاء، قائمة على مبادئ الشفافية المطلقة والعدالة والقيمة الحقيقية.',
      goalsTitle: 'أهدافنا الاستراتيجية',
      goals: [
        'ريادة الفكر: نشر وتعميق الوعي والثقافة العقارية الصحيحة وتصحيح المفاهيم السائدة في السوق.',
        'الشمولية التشغيلية: تقديم منظومة خدمات عقارية متكاملة (20 خدمة) تحت سقف إداري واحد.',
        'العالمية الرقمية: ربط الأسواق العقارية في 100 دولة عبر سيستم إداري موحد يضمن سلاسة التبادل والاستثمار.',
        'الأمان المؤسسي: فرض معايير التقييم المهني والحماية القانونية كحقوق أساسية لكل طرف في المنظومة.',
      ],
      partnersTitle: 'رسائلنا لشركاء النجاح',
      partnersHint: 'اختر الشريحة لعرض الرسالة المخصصة لها.',
      partnerMessages: [
        {
          id: 'individuals',
          label: 'إلى الأفراد',
          message:
            'عقارك هو أغلى ما تملك، وحمايته هي مهمتنا الأولى. نوفر لك البيئة التي تشتري وتبيع فيها بكرامة وشفافية، مع ضمان القيمة العادلة والأمان القانوني الكامل، دون أعباء إضافية أو عمولات خفية.',
        },
        {
          id: 'companies',
          label: 'إلى الشركات العقارية والمطورين',
          message:
            'نحن ذراعكم التسويقي العالمي والذكي. نفتح أمامكم أبواب 100 دولة، ونحول مشاريعكم إلى قصص نجاح تذاع عبر أكبر المنصات الإعلامية، لنصل بمنتجكم إلى المستثمر الجاد في أي مكان في العالم.',
        },
        {
          id: 'banks',
          label: 'إلى المؤسسات المصرفية والبنوك',
          message:
            'نحن الشريك الذي يضمن لكم الجدية والجودة. نقدم لكم محفظة عقارية مفحوصة ومقيمة بدقة، وعملاء جادين، مما يقلل مخاطر الائتمان ويفتح آفاقاً جديدة لبرامج التمويل العقاري المستدامة.',
        },
        {
          id: 'clubs',
          label: 'إلى النوادي ',
          message:
            'نحن هنا لنضيف قيمة حقيقية لأعضائكم؛ نادي حلول ليس منافساً، بل هو المظلة التي تمنح منتسبيكم امتيازات عقارية حصرية وأماناً استثمارياً يعزز من رفاهيتهم وثقتهم.',
        },
        {
          id: 'governments',
          label: 'إلى الحكومات والمؤسسات السيادية',
          message:
            'نحن الجسر الذي يعبر برؤى أوطانكم إلى الساحة العالمية. نضع قوتنا الإعلامية والتقنية لتسويق المشاريع القومية والمدن الذكية، لنجذب الاستثمار الدولي الذي يليق بطموحاتكم الوطنية الكبرى.',
        },
      ],
    },
    founder: {
      heroEyebrow: 'المؤسس',
      heroName: 'د. أدهم الشرقاوي',
      heroRole: 'خبير استراتيجي في الإعلام وتطوير المشاريع الاستثمارية',
      heroTagline: 'أكثر من 25 عاماً من الخبرة القيادية',
      introVideo: {
        eyebrow: 'شاهد',
        title: 'هل يمكن للإعلام أن يتجاوز دور نقل الخبر ليكون محركاً أسبق للاقتصاد؟',
        text: 'على مدار أكثر من 25 عاماً في تقاطع الإعلام الاقتصادي، الاستثمار، والتطوير العقاري، كانت هناك دائماً قناعة راسخة: الإعلام التنموي والحديث ليس مجرد ناقل للأحداث، بل هو مدير فعال للمشهد الاقتصادي، يصنع التوجهات ويفتح آفاق الاستثمار.\n\nفي هذا المقطع القصير، أشارككم جانب من هذه الرحلة والمحطات التي شكلت الرؤية التأسيسية لمنظومة حلول، وكيف نعمل على ربط المعرفة الاستثمارية بالإعلام المتخصص من خلال ركائزنا الرئيسية:\n• حلول للاستشارات • حلول للإعلام • نادي حلول العقاري.',
        attribution: 'د. أدهم الشرقاوي — المؤسس ورئيس مجلس إدارة نادي حلول العقاري',
        videoSrc: 'https://www.youtube.com/watch?v=FhRuWFUoWsY',
        videoPlaceholder: 'الفيديو قريباً',
      },
      aboutEyebrow: 'نبذة',
      aboutTitle: 'الملف المهني',
      aboutTags: [
        'خبرة تزيد عن 25 عاماً',
        'الإعلام × تحالفات الأعمال',
        'الاستشارات والعقار',
        'نطاق إقليمي ودولي',
      ],
      aboutText:
        'رائد أعمال ومطوّر مفاهيم استراتيجية يمتلك أكثر من 25 عاماً في بناء وإدارة كيانات اقتصادية كبرى. متخصص في صياغة «التحالفات الاستراتيجية» التي تجمع قوة الإعلام والحلول الرقمية وواقع الاستثمار. يُعرف بقدرته على تحويل الرؤى المعقدة إلى مشاريع وطنية وإقليمية ناجحة، بتركيز خاص على قطاعي الاستشارات والعقار.',
      careerEyebrow: 'المسيرة',
      careerTitle: 'محطات بارزة',
      careerSubtitle: 'مسيرة تربط بين قوة الإعلام وواقع الاستثمار',
      milestones: [
        {
          num: '01',
          org: 'مجموعة قنوات سي بي سي',
          role: 'مدير تطوير المشاريع الإعلامية',
          bullets: [
            'قيادة الابتكار وتطوير المحتوى الاستثماري ضمن أحد أكبر التجمعات الإعلامية في الشرق الأوسط.',
            'بناء لغة مشتركة بين الإعلام التقليدي ومجتمع الأعمال وتعزيز التأثير المؤسسي.',
          ],
        },
        {
          num: '02',
          org: 'مشروع «مزادات»',
          role: 'المؤسس والمبتكر',
          bullets: [
            'الرؤية والإدارة المباشرة لأول مشروع يدمج الإعلام المرئي مع التبادل العقاري والاستثماري بالشراكة مع سي بي سي.',
            'تطوير مفهوم «المزادات التلفزيونية» ليصبح أداة اقتصادية فاعلة مع نجاحات موثقة على الشاشة.',
          ],
        },
        {
          num: '03',
          org: 'مجموعة بنان',
          role: 'القيادة المؤسسية — المدير العام',
          bullets: [
            'بنان للحلول المتكاملة: أنظمة إدارية واستراتيجية.',
            'بنان للتسويق العقاري: إدارة محافظ عقارية كبرى.',
            'بنان للخدمات الاستراتيجية والتسويق: بناء العلامات وتطوير الأسواق.',
          ],
        },
      ],
      media: {
        eyebrow: 'الإعلام والحضور',
        title: ' برنامج مزادات',
        subtitle: 'برنامج مزادات | دكتور أدهم الشرقاوي يتحدث عن تفعيل المشروع مع اللواء طارق مهدي محافظ الإسكندرية.',
        videoSrc: 'https://www.youtube.com/watch?v=eklsLyv3sUc&t=1s',
        linksTitle: 'التواصل مع دكتور/ ادهم الشرقاوي',
        links: [
          { label: 'www.holol.club', href: 'https://www.holol.club/', icon: 'language' },
          { label: 'adhamelsharkawy.com', href: 'https://www.adhamelsharkawy.com/', icon: 'work' },
          { label: 'Facebook | dr.adhamelsharkaawy', href: 'https://www.facebook.com/dr.adhamelsharkaawy/', icon: 'public' },
          { label: 'Youtube | adhamelsharkaawy', href: 'https://www.youtube.com/@adhamelsharkaawy', icon: 'language' },
          { label: 'Linkedin | adhamelsharkaawy', href: 'https://www.linkedin.com/in/adhamelsharkaawy/', icon: 'work' },
        ],
      },
      visionEyebrow: 'الخطوة التالية',
      visionTitle: 'الرؤية الحالية',
      visionIntro:
        'يواصل د. أدهم توجيه خبراته المتراكمة نحو إطلاق الجيل القادم من المنصات والنوادي، بما في ذلك:',
      visionItems: [
        {
          num: '01',
          title: 'نادي حلول الاستشارات',
          text: 'امتياز رقمي للاستشارات مدعوم بالذكاء الاصطناعي والإعلام.',
        },
        {
          num: '02',
          title: 'نادي حلول العقاري',
          text: 'منصة عالمية لتبادل وإدارة الخدمات العقارية (50 خدمة متكاملة).',
        },
        {
          num: '03',
          title: 'حلول الإعلامية',
          text: 'الذراع الإعلامي والإنتاجي الذي سيقود المحتوى الاستثماري في 50 دولة.',
        },
      ],
      philosophyEyebrow: 'فلسفة العمل',
      philosophyQuote:
        'الإعلام ليس مجرد أداة نشر إنه المحرك الأساسي لإدارة الأفكار العالمية وبناء الثقة في الأسواق.',
      philosophyAttribution: 'د. أدهم الشرقاوي',
      ctaJoin: 'انضم للنادي',
      ctaHome: 'العودة للرئيسية',
    },
    contact: {
      eyebrow: 'تواصل',
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا مباشرة عبر البريد الإلكتروني أو الهاتف.',
      phoneLabel: 'رقم الهاتف',
      phoneValue: '+44 7832 180705',
      phoneHref: '+447832180705',
      emailLabel: 'البريد الإلكتروني',
      emailValue: 'info@hololrealestate.club',
      whatsappAria: 'راسلنا على واتساب',
    },
    footer: {
      brand: 'النادي العقاري',
      tagline: 'مشروع من شركة حلول العالمية — د/ أدهم الشرقاوي.',
      copy: '© 2026 النادي العقاري. جميع الحقوق محفوظة.',
      socialNavAria: 'وسائل التواصل والمواقع',
      socialLinks: [
        { label: 'موقع نادي حلول', href: 'https://www.holol.club/', iconId: 'globe' },
        { label: 'موقع AdhamElSharkawy.com', href: 'https://www.adhamelsharkawy.com/', iconId: 'link' },
        { label: 'فيسبوك', href: 'https://www.facebook.com/dr.adhamelsharkaawy/', iconId: 'facebook' },
        { label: 'يوتيوب', href: 'https://www.youtube.com/@adhamelsharkaawy', iconId: 'youtube' },
        { label: 'لينكدإن', href: 'https://www.linkedin.com/company/hololrealestateclub', iconId: 'linkedin' },
      ],
    },
    servicesPage: {
      eyebrow: 'خدمات النادي',
      title: 'حلول عقارية شاملة',
      subtitle:
        '20 خدمة متكاملة تغطي دورة العقار بالكامل — من الشراء والتمويل وحتى المقاولات والتشطيبات والأثاث.',
      features: [
        {
          title: 'البيع والشراء',
          text: 'خدمة البيع والشراء للأفراد والشركات مباشرة من خلال النادي بدون عمولات.',
          icon: 'real_estate_agent',
        },
        {
          title: 'التبادل العقاري',
          text: 'خدمة التبادل العقاري بطريقة منظمة وشفافة.',
          icon: 'swap_horiz',
        },
        {
          title: 'التمويل العقاري',
          text: 'حلول تمويل عقاري مدعومة بالبنوك الشريكة ومصمَّمة لكل عميل.',
          icon: 'account_balance',
        },
        {
          title: 'التقييم العقاري',
          text: 'تقييمات دقيقة مبنية على البيانات وتحليلات السوق والخبرة الميدانية.',
          icon: 'analytics',
        },
        {
          title: 'الاستشارات القانونية',
          text: 'مراجعة عقود وهيكلة قانونية ومتابعة متخصصة.',
          icon: 'gavel',
        },
        {
          title: 'المزادات',
          text: 'مزادات عقارية حصرية تشمل مزادات خاصة بالبنوك الشريكة.',
          icon: 'campaign',
        },
        {
          title: 'المقاولات والإنشاءات',
          text: 'إدارة كاملة لأعمال المقاولات والإنشاءات للعملاء والشركاء.',
          icon: 'construction',
        },
        {
          title: 'الديكور والتشطيبات',
          text: 'تحسينات داخلية وتشطيبات مميزة ترفع قيمة العقار.',
          icon: 'format_paint',
        },
        {
          title: 'الفرش والأثاث',
          text: 'خدمات فرش وتجهيز متكاملة للعقارات السكنية والتجارية.',
          icon: 'chair',
        },
      ],
    },
    servicesCatalog: {
      groups: [
        {
          label: 'المحركات الأساسية',
          title: 'الخدمات الأساسية',
          items: [
            {
              id: '01',
              name: 'خدمة البيع والشراء (للأفراد والشركات)',
              platformTitle: 'سوق الحلول: صفقات مباشرة بلا حدود',
              video: buyingandselling,
              marketing:
                'منصة ذكية تجمع البائع والمشتري الجاد في مكان واحد. نلغي العمولات التقليدية والوسطاء لنمنحك أفضل قيمة عقارية بأعلى معايير الشفافية، سواء كنت فرداً يبحث عن سكن أو شركة تدير محفظة عقارية ضخمة.',
              detail: {
                heroDesc:
                  "احترافية وسرعة وأمان قانوني — منظومة بيع وشراء لا تشبه السمسرة التقليدية في شيء",
                details: [
                  "خدمة البيع والشراء في نادي حلول العقاري هي المحرك الأساسي للسوق — لكنها تعمل بنموذج يختلف تماماً عن السمسرة التقليدية. التركيز هنا على الاحترافية والسرعة والأمان القانوني، مع خدمات مميزة لتناسب الأفراد الباحثين عن سكن والشركات التي تستحوذ على أصول كبرى.",
                  "من الوصول للعقارات خارج السوق والتفاوض الاحترافي إلى جولات الواقع الافتراضي وخرائط الأسعار التفاعلية وعقود الضمان المُحصّنة قانونياً، تغطي خدماتنا الـ 25 المتخصصة كل مرحلة من مراحل أي صفقة لكل نوع من المشترين والبائعين.",
                  "يستبدل الأعضاء العمولة بعضوية ذكية تربطهم مباشرة بالأطراف الجادة وتدفق الصفقات الحصرية والحماية القانونية الكاملة — مما يجعل كل صفقة أسرع وأرخص وأكثر أماناً.",
                ],
                categories: [
                  {
                    title: "أولاً: خدمات المشتري",
                    icon: "search",
                    services: [
                      { name: "البحث والتقصي المخصص (Property Hunting)", desc: "فريق متخصص يبحث عن العقار الذي يطابق معايير العميل الدقيقة من حيث الموقع والميزانية والغرض." },
                      { name: "الوصول للعقارات خارج السوق (Off-Market)", desc: "يحصل الأعضاء على أولوية الاطلاع على صفقات حصرية قبل عرضها للجمهور العام." },
                      { name: "تحليل القيمة السوقية العادلة", desc: "تقرير يوضح ما إذا كان السعر المطلوب عادلاً أم مبالغاً فيه، مقارنةً بصفقات حقيقية مماثلة في المنطقة." },
                      { name: "التفاوض الاحترافي", desc: "تولي عملية التفاوض بالنيابة عن العميل للوصول إلى أدنى سعر ممكن وأفضل شروط سداد." },
                      { name: "المعاينة الفنية والهندسية", desc: "فحص إنشائي وأنظمة شامل للعقار قبل الشراء — التحقق من سلامة الجدران والسباكة والكهرباء." },
                      { name: "تسهيل التمويل العقاري", desc: "ربط المشتري بأفضل البرامج التمويلية من البنوك الشريكة في النادي بأكثر الأسعار تنافسية." },
                    ],
                  },
                  {
                    title: "ثانياً: خدمات البائع",
                    icon: "sell",
                    services: [
                      { name: "استراتيجية التسعير الذكي", desc: "تحديد السعر المثالي الذي يضمن البيع السريع دون إهدار قيمة العقار." },
                      { name: "الحزمة الإعلامية الاحترافية", desc: "تصوير فوتوغرافي وتصوير بالدرون وإنتاج فيديو سينمائي لتسويق العقار بأقوى صورة ممكنة." },
                      { name: "التسويق الموجه للنخبة", desc: "عرض العقار مباشرة على قاعدة بيانات المستثمرين والشركات الـ 100 المؤثرة داخل النادي." },
                      { name: "إدارة يوم العرض المفتوح (Open House)", desc: "تنظيم فعاليات لمعاينة العقار لمجموعة من المشترين الجادين في وقت واحد لخلق بيئة تنافسية صحية." },
                      { name: "تأهيل وتحليل المشترين", desc: "التحقق من الملاءة المالية لكل مشترٍ محتمل قبل إضاعة وقت البائع في معاينات غير جادة." },
                    ],
                  },
                  {
                    title: "ثالثاً: خدمات الشركات والمستثمرين",
                    icon: "domain",
                    services: [
                      { name: "شراء المباني الإدارية والمقرات", desc: "مساعدة الشركات في إيجاد مقرات تتناسب مع حجم أعمالها وصورتها المؤسسية." },
                      { name: "الاستحواذ على الأراضي الخام", desc: "خدمات متكاملة لشراء الأراضي الصالحة للتطوير سكنياً وتجارياً وصناعياً." },
                      { name: "صفقات البيع بالجملة (Bulk Deals)", desc: "الاستحواذ على أدوار كاملة أو عمارات بأكملها لإعادة بيعها أو تحقيق دخل إيجاري من المحفظة." },
                      { name: "تحليل المحفظة العقارية وإعادة التمركز", desc: "مراجعة أصول الشركة العقارية وتقديم توصيات ببيع استراتيجي للانتقال إلى مناطق أعلى عائداً." },
                      { name: "دراسات مخرج الاستثمار (Exit Strategy)", desc: "التخطيط لتوقيت وأسلوب التخلص من الأصل العقاري لتحقيق أقصى أرباح رأسمالية ممكنة." },
                    ],
                  },
                  {
                    title: "رابعاً: الأمان القانوني والتوثيق",
                    icon: "gavel",
                    services: [
                      { name: "التدقيق القانوني الكامل", desc: "تتبع سلسلة الملكية والتأكد من خلو العقار من مخالفات البناء أو الديون أو الأعباء." },
                      { name: "خدمة الوسيط المحايد (Escrow)", desc: "تأمين مبالغ التعاقد في حساب الضمان المحايد للنادي حتى اكتمال نقل الملكية رسمياً." },
                      { name: "صياغة العقود القانونية المحصّنة", desc: "إعداد عقود بيع وشراء خالية تماماً من الثغرات — تحمي الطرفين من أي نزاعات مستقبلية." },
                      { name: "إدارة التسجيل ونقل الملكية", desc: "تولي كافة الإجراءات الحكومية في دوائر التسجيل الرسمية حتى صدور سند الملكية الجديد." },
                    ],
                  },
                  {
                    title: "خامساً: تكنولوجيا البيع والشراء",
                    icon: "devices",
                    services: [
                      { name: "المعاينة الافتراضية (VR Tours)", desc: "تمكين المشترين الدوليين من معاينة العقار وكأنهم بداخله فعلياً — من أي مكان في العالم." },
                      { name: "نظام التنبيهات الفورية", desc: "إشعارات آنية للأعضاء فور توفر عقار يطابق رغباتهم المسجلة في المنصة." },
                      { name: "خريطة الأسعار التفاعلية", desc: "يتمكن العملاء من رؤية متوسطات أسعار البيع في أي منطقة بضغطة زر لاتخاذ قرارات مستنيرة." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات القيمة المضافة",
                    icon: "add_circle",
                    services: [
                      { name: "خدمة ما بعد الشراء", desc: "ربط المشتري فوراً بخدمات الديكور والمقاولات وإدارة الأملاك لحظة إتمام الصفقة." },
                      { name: "استشارات الضرائب العقارية", desc: "إرشادات متخصصة حول إدارة الرسوم والضرائب الناتجة عن الصفقة بأسلوب قانوني مالياً ذكي." },
                    ],
                  },
                ],
              },
            },
            {
              id: '02',
              name: 'خدمة التبادل العقاري الدولي',
              video: exchange,
              platformTitle: 'مقايضة الأصول: استبدل عقارك عالمياً',
              marketing:
                'الحل الثوري لنقل استثماراتك عابرة للقارات. بادل وحدتك العقارية في أي مكان في العالم بأخرى في بلد مختلف من خلال نظام تقييم دقيق يضمن تكافؤ الفرص وحماية الأصول.',
              detail: {
                heroDesc:
                  "بيع واشترِ في خطوة واحدة — نظام التبادل الذكي للأصول الذي يلغي العمولات ويُحرر رأس المال الجامد ويعيد تمركز المحافظ عبر الحدود",
                details: [
                  "خدمة التبادل العقاري في نادي حلول هي واحدة من أقوى الأدوات التي تحقق ثورة العقار — لأنها تعتمد على الذكاء في إدارة الأصول بدلاً من السيولة النقدية فقط، مما يوفر على المستثمرين مبالغ ضخمة من العمولات والضرائب.",
                  "من التقييم المزدوج وخوارزمية المطابقة الذكية إلى التبادل الدولي ونموذج الأرض مقابل الوحدات ودائرة التبادل المغلقة لكبار المستثمرين، تغطي خدماتنا الـ 25 المتخصصة كل سيناريو يتفوق فيه التبادل على البيع التقليدي.",
                  "النتيجة: ينتقل المستثمرون من القطاعات الراكدة إلى القطاعات النشطة، وتُعاد هيكلة المحافظ بأقل احتكاك، وتُحل مشاكل السيولة دون الحاجة لأي بيع نقدي.",
                ],
                categories: [
                  {
                    title: "أولاً: خدمات التقييم والمطابقة",
                    icon: "compare_arrows",
                    services: [
                      { name: "التقييم المزدوج المقارن", desc: "تقييم مستقل للعقارين طرفي التبادل لضمان العدالة السعرية بناءً على القيمة السوقية الفعلية." },
                      { name: "خوارزمية المطابقة الذكية (Smart Matchmaking)", desc: "نظام تقني يطابق طلبات التبادل باحترافية — كربط مالك أرض يبحث عن شقق بالطرف المقابل المثالي." },
                      { name: "تبادل الأصول غير المتجانسة", desc: "تبادل عقار سكني مقابل عقار تجاري أو إداري لإعادة هيكلة المحفظة الاستثمارية." },
                      { name: "تحليل أفضل استخدام", desc: "تقييم ما إذا كان التبادل سيحقق عائداً استثمارياً أعلى للطرفين مقارنة باحتفاظ كل منهما بعقاره الحالي." },
                    ],
                  },
                  {
                    title: "ثانياً: نماذج التبادل المبتكرة",
                    icon: "swap_horiz",
                    services: [
                      { name: "تبادل الأرض مقابل الوحدات", desc: "نموذج المطورين: تبادل أرض خام بنسبة من الوحدات التي سيتم بناؤها مستقبلاً عليها." },
                      { name: "تبادل الآجل بالجاهز", desc: "تبادل وحدة تحت الإنشاء (Off-plan) بوحدة جاهزة للسكن أو التأجير الفوري." },
                      { name: "تبادل المحافظ العقارية (Bulk Swap)", desc: "تبادل مجموعة وحدات صغيرة كحزمة واحدة مقابل مبنى إداري واحد أو أصل فندقي." },
                      { name: "التبادل الدولي (Cross-Border Swap)", desc: "تبادل عقار في دولة مقابل عقار في دولة أخرى ضمن الشبكة العالمية لنادي حلول." },
                      { name: "تبادل الارتقاء (Upgrade Swap)", desc: "تبادل عقار قديم أو بمساحة صغيرة مقابل عقار أحدث أو أكبر مع تسوية فارق السعر بشكل منفصل." },
                    ],
                  },
                  {
                    title: "ثالثاً: الهندسة المالية والحلول النقدية",
                    icon: "calculate",
                    services: [
                      { name: "تمويل فوارق التبادل (Boot Financing)", desc: "حلول تمويلية للطرف الملزم بدفع الفرق النقدي في القيمة بين العقارين المتبادلين." },
                      { name: "تصفية الرهن العقاري للتبادل", desc: "حل التعقيدات البنكية المتعلقة بالعقارات المرهونة لإتمام عملية التبادل بصورة نظيفة." },
                      { name: "التحسين الضريبي للتبادل", desc: "استشارات قانونية لتقليص الضرائب والرسوم الحكومية الناتجة عن المبادلة مقارنة بالبيع والشراء التقليدي." },
                      { name: "الضمان المالي الموقوت (Escrow)", desc: "تأمين المبالغ النقدية للفوارق في حساب وسيط محايد حتى اكتمال نقل الملكية المتزامن للطرفين." },
                    ],
                  },
                  {
                    title: "رابعاً: الخدمات القانونية والتوثيقية",
                    icon: "gavel",
                    services: [
                      { name: "عقود المقايضة القانونية", desc: "صياغة عقود تبادل احترافية تضمن حقوق الطرفين وتحمي من النزاعات المستقبلية." },
                      { name: "الفحص النافي للجهالة المزدوج", desc: "التحقق من صحة أوراق ملكية كلا العقارين وخلوهما من النزاعات والأعباء قبل المضي في التبادل." },
                      { name: "إدارة حسابات الوساطة (Escrow Services)", desc: "العمل كوسيط محايد يضمن نقل الملكية المتزامن للطرفين دون أي مخاطر." },
                      { name: "تنسيق التسجيل العقاري", desc: "إنهاء إجراءات نقل الملكية في دوائر التسجيل الحكومية لكلا العقارين في آنٍ واحد." },
                    ],
                  },
                  {
                    title: "خامساً: الخدمات الفنية واللوجستية",
                    icon: "engineering",
                    services: [
                      { name: "تقرير الحالة الإنشائية المزدوج", desc: "فحص فني وهندسي لكلا العقارين للكشف عن أي عيوب خفية قبل اكتمال التبادل." },
                      { name: "خدمة التجديد من أجل التبادل", desc: "رفع قيمة العقار الأضعف من خلال صيانة سريعة موجهة لزيادة قبوله في عملية تبادل قوية." },
                      { name: "إدارة المحتوى التسويقي للتبادل", desc: "تصوير احترافي وعرض كل عقار في قسم التبادل بالمنصة بأسلوب يبرز مميزاته للمقايضة." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات النخبة (VIP Exchange)",
                    icon: "workspace_premium",
                    services: [
                      { name: "دائرة التبادل المغلقة", desc: "شبكة خاصة لكبار المستثمرين لتبادل القصور والفنادق والأراضي الشاسعة بعيداً عن العرض العام." },
                      { name: "تبادل حق الانتفاع", desc: "تبادل عوائد الإيجار أو حق السكن لمدة معينة دون نقل ملكية الوحدة." },
                      { name: "تبادل الأصول العقارية بالأسهم", desc: "تبادل عقار مقابل حصص في شركة تطوير عقاري أو صندوق استثماري." },
                      { name: "التبادل مع الصيانة الشاملة", desc: "ضمان استلام العقار الجديد مع عقد صيانة مجاني لمدة عام كامل." },
                      { name: "استشارات إعادة التمركز", desc: "خطة استراتيجية توضح للمستثمر كيف ينتقل من قطاع عقاري خامل إلى قطاع نشط عبر سلسلة من التبادلات الذكية." },
                    ],
                  },
                ],
              },
            },
            {
              id: '03',
              name: 'خدمة التقييم العقاري المهني',
              video: realestateappraisal,
              platformTitle: 'ميزان القيمة: التقييم الذي تثق به',
              marketing:
                'نحن ندير الثقافة العقارية من خلال فرض التقييم المهني كمعيار أساسي. لا أسعار عشوائية بعد اليوم؛ كل عقار في النادي موثق بشهادة تقييم فني وقانوني تمنحك الثقة المطلقة قبل اتخاذ قرارك.',
              detail: {
                heroDesc:
                  "تقييم عقاري مهني يستند إلى المعايير الدولية (RICS / IVS) ويُدعم بالذكاء الاصطناعي — لتزويد البنوك والشركات والمستثمرين بأدق القيم العقارية لاتخاذ قرارات واثقة",
                details: [
                  "تُحوّل خدمة التقييم العقاري المهني في نادي حلول التخمين إلى دقة متناهية. من خلال اعتماد المعايير الدولية للتقييم — RICS وIVS — ودمجها بالذكاء الاصطناعي، نُصدر تقارير تثق بها البنوك للتمويل، وتعتمدها الشركات في تقاريرها المالية، ويبني عليها المستثمرون قراراتهم الكبرى.",
                  "من تقييمات الرهن العقاري وإعداد التقارير المالية وفق IFRS إلى تقييمات النزاعات القضائية ونماذج التقييم الآلي المدعومة بالتكنولوجيا، تغطي خدماتنا الـ 25 المتخصصة كل سيناريو يستلزم تحديد قيمة عقارية دقيقة.",
                  "يعمل مُقيّمونا المعتمدون عبر دول الخليج والأسواق العربية، لإصدار تقارير متوافقة مع RICS تُقبل لدى الجهات التنظيمية والمحاكم والمؤسسات المالية.",
                ],
                categories: [
                  {
                    title: "أولاً: التقييم للأغراض المالية والمصرفية",
                    icon: "account_balance",
                    services: [
                      { name: "التقييم لأغراض الرهن العقاري", desc: "تقارير معتمدة تُقدَّم للبنوك والمؤسسات التمويلية لدعم منح القروض والتمويل المضمون بالعقار." },
                      { name: "تقييم الأصول للتقارير المالية (IFRS)", desc: "تقدير القيمة العادلة للأصول العقارية للشركات لإدراجها في الميزانيات السنوية وفق معايير IFRS." },
                      { name: "تقييم القيمة التصفوية", desc: "تقدير السعر القابل للتحقق في حالات البيع الإجباري أو الإفلاس لحماية حقوق الدائنين." },
                      { name: "تقييم بدل الإحلال للتأمين", desc: "تقدير تكلفة إعادة بناء العقار في حالة الكوارث لتحديد قيمة بوليصة التأمين الصحيحة." },
                    ],
                  },
                  {
                    title: "ثانياً: التقييم الاستثماري والاستراتيجي",
                    icon: "trending_up",
                    services: [
                      { name: "تحليل الاستخدام الأنسب والأفضل (HBU)", desc: "دراسة العقار لتحديد النشاط الذي يحقق أعلى عائد مادي وأعلى قيمة سوقية ممكنة." },
                      { name: "تقييم المحافظ العقارية الكبرى", desc: "تقييم مئات الوحدات في تكليف واحد لصناديق الاستثمار وصناديق REITs التي تحتاج تقييمات جماعية للمحافظ." },
                      { name: "تقييم حق الانتفاع والإيجار الطويل", desc: "تقدير قيمة حق الاستخدام أو استغلال العقار على مدى طويل دون انتقال الملكية." },
                      { name: "تحليل عوائد الإيجار العادلة", desc: "تحديد القيمة الإيجارية الحقيقية في السوق لمنع خسائر الملاك وضمان معايرة عوائد المستثمرين بدقة." },
                    ],
                  },
                  {
                    title: "ثالثاً: التقييم القانوني والقضائي",
                    icon: "gavel",
                    services: [
                      { name: "تقييم التركات والمواريث", desc: "تقسيم الأصول العقارية بين الورثة بناءً على تقديرات مستقلة وقابلة للدفاع للقيمة السوقية العادلة." },
                      { name: "التقييم لأغراض النزاعات القضائية", desc: "إعداد تقارير خبير مُثمّن معتمد مقبولة أمام المحاكم في النزاعات العقارية." },
                      { name: "تقييم الاندماج والاستحواذ", desc: "تقدير قيمة الأصول العقارية خلال اندماج الشركات أو الاستحواذ أو البيع." },
                      { name: "التقييم لأغراض الضرائب والزكاة", desc: "تقدير القيمة الخاضعة للضريبة العقارية أو الزكاة الشرعية المستحقة." },
                    ],
                  },
                  {
                    title: "رابعاً: التقييم الفني للمشاريع والتطوير",
                    icon: "construction",
                    services: [
                      { name: "تقييم الأراضي الخام", desc: "تقدير قيمة الأرض بناءً على إمكانات التطوير المستقبلية باستخدام طريقة القيمة المتبقية (Residual Value)." },
                      { name: "تقييم المشاريع تحت الإنشاء", desc: "تقدير قيمة ما تم إنجازه والميزانية المطلوبة لإكمال المشروع حتى الاستلام الفعلي." },
                      { name: "تقييم العقارات المتعثرة", desc: "تحليل أسباب التعثر وتقدير القيمة السوقية الحالية مقابل تكلفة المعالجة والإصلاح." },
                      { name: "تقييم العقارات الخضراء والمستدامة", desc: "قياس القيمة المضافة التي تحققها العقارات الموفرة للطاقة والحاصلة على شهادات بيئية." },
                    ],
                  },
                  {
                    title: "خامساً: التقييم التكنولوجي والذكي (PropTech)",
                    icon: "smart_toy",
                    services: [
                      { name: "نمذجة التقييم الآلي (AVM)", desc: "تقييم عقاري فوري مدعوم بالذكاء الاصطناعي بناءً على بيانات السوق الآنية والتحليل الخوارزمي." },
                      { name: "تحليل البيانات الضخمة واتجاهات الأسعار", desc: "رصد تحركات الأسعار في المناطق المحيطة للتنبؤ بالقيم العقارية المستقبلية بثقة إحصائية." },
                      { name: "التقييم الجغرافي (GIS)", desc: "ربط قيمة العقار بالمخططات العمرانية ومشاريع البنية التحتية والمبادرات التنموية القومية المحيطة." },
                      { name: "خدمة مراقب القيمة", desc: "تحديثات ربع سنوية لقيمة محفظة العميل العقارية مع إشعارات فورية بأي زيادة أو نقصان جوهريين." },
                    ],
                  },
                  {
                    title: "سادساً: التقييم المتخصص (أسواق متخصصة)",
                    icon: "hotel",
                    services: [
                      { name: "تقييم المنشآت الفندقية والسياحية", desc: "تقييم متخصص بناءً على عدد الغرف ومعدلات الإشغال وإيرادات الغرفة المتاحة (RevPAR) والدخل التشغيلي." },
                      { name: "تقييم العقارات الصناعية والمخازن", desc: "التقييم بناءً على الطاقة التخزينية والبنية التحتية اللوجستية ومعايير الكفاءة التشغيلية." },
                      { name: "تقييم المراكز الطبية والمستشفيات", desc: "تطبيق معايير متخصصة تعتمد على التجهيزات والتراخيص والتدفقات النقدية التشغيلية." },
                      { name: "تقييم المجمعات التجارية (Malls)", desc: "تقييم المشاريع التجارية بناءً على تدفق الزوار والمستأجرين الرئيسيين والقوة الشرائية لمنطقة الامتداد." },
                      { name: "خدمة الرأي الثاني (Second Opinion)", desc: "مراجعة مستقلة لتقارير التقييم الصادرة عن جهات أخرى للتحقق من دقتها ومصداقيتها." },
                    ],
                  },
                ],
              },
            },
            {
              id: '04',
              name: 'خدمة المزادات العقارية',
              video: auctions,
              platformTitle: 'مسرح الصفقات: مزادات تحت الضوء',
              marketing:
                'قوة الإعلام في خدمة العقار. نحول العقارات المتميزة إلى صفقات رابحة عبر مزادات علنية تدار باحترافية، وتصل إلى ملايين المهتمين عبر قنواتنا الإعلامية الشريكة، لضمان أعلى سعر وأسرع سيولة.',
              detail: {
                heroDesc:
                  "الأداة الأقوى لتحويل العقار إلى سيولة — منصة مزادات رقمية عالمية مدعومة بالذكاء الاصطناعي والبث المباشر وشفافية البلوكشين",
                details: [
                  "المزادات العقارية في نادي حلول هي القلب النابض لعمليات البيع السريعة والشفافة. حوّلنا المزاد من تجمع محلي إلى منصة رقمية عالمية تربط أصحاب العقارات بالمستثمرين الجادين حول العالم في الوقت الفعلي.",
                  "من التدقيق القانوني قبل المزاد والتقييمات المدعومة بالذكاء الاصطناعي إلى المزايدة بالبث المباشر وأنظمة الوكالة وجولات VR والتوثيق عبر البلوكشين، تغطي خدماتنا الـ 25 المتخصصة كل مرحلة من مراحل دورة حياة المزاد.",
                  "سواء أكان تصفية أصول متعثرة أو مزاد على حقوق انتفاع أو تنفيذ عملية استحواذ عكسية، توفر بنية نادي حلول للمزادات أقصى قيمة بأقصى مستوى من الشفافية.",
                ],
                categories: [
                  {
                    title: "أولاً: التحضير والتقييم قبل المزاد",
                    icon: "checklist",
                    services: [
                      { name: "التقييم الفني المعتمد", desc: "تحديد السعر الافتتاحي بناءً على معايير السوق الحالية والتدفقات النقدية المتوقعة، مدعوماً بتقرير تقييم معتمد." },
                      { name: "الفحص القانوني النافي للجهالة", desc: "تجهيز ملف قانوني كامل لكل عقار معروض في المزاد لضمان خلوه من أي نزاعات أو معوقات قبل الإدراج." },
                      { name: "دراسة جدوى المزاد", desc: "تحديد ما إذا كان المزاد هو الوسيلة الأنسب لبيع هذا العقار تحديداً لضمان أعلى عائد ممكن للمالك." },
                      { name: "إدارة ضمانات المزايدة", desc: "إدارة ودائع المزايدين عبر حسابات وسيطة (Escrow) للتحقق من جدية كل مشارك مالياً قبل فتح باب المزايدة." },
                    ],
                  },
                  {
                    title: "ثانياً: الحلول التقنية والمزادات الذكية",
                    icon: "display_settings",
                    services: [
                      { name: "منصة المزاد الرقمية بالبث المباشر", desc: "مزايدة أونلاين بالصوت والصورة لحظياً يمكن الوصول إليها من أي مكان في العالم — دون الحاجة للحضور الجسدي." },
                      { name: "نظام المزايدة بالوكالة (Proxy Bidding)", desc: "نظام ذكي يسمح للمزايد بوضع أقصى سعر ويقوم النظام بالمزايدة تلقائياً عنه حتى بلوغ هذا السقف." },
                      { name: "جولات الواقع الافتراضي (VR)", desc: "جولات 360 درجة غامرة داخل كل عقار معروض في المزاد متاحة قبل انطلاق الجلسة." },
                      { name: "التوثيق عبر البلوكشين", desc: "تسجيل جميع المزايدات في سجل غير قابل للتعديل لضمان أعلى مستويات الشفافية وسجل تدقيق خالٍ من النزاعات." },
                    ],
                  },
                  {
                    title: "ثالثاً: التسويق والانتشار",
                    icon: "campaign",
                    services: [
                      { name: "حملات الوصول الموجه للمستثمرين", desc: "الوصول إلى أكثر 100 مستثمر تأثيراً في كل دولة مستهدفة — الجمهور الأكثر قدرةً على دفع أعلى سعر." },
                      { name: "الكتالوج الرقمي الفاخر", desc: "بروفايل احترافي لكل عقار يضم التفاصيل الفنية والقانونية والمالية الكاملة في عرض مصقول." },
                      { name: "الظهور الإعلامي للمزادات الكبرى", desc: "توظيف البرامج التليفزيونية ومنظومة السوشيال ميديا الخاصة بالنادي لتضخيم الوصول وإشعال المنافسة." },
                      { name: "أيام المعاينة قبل المزاد", desc: "تنظيم أيام مفتوحة للمهتمين لفحص العقار على أرض الواقع قبل موعد المزاد." },
                    ],
                  },
                  {
                    title: "رابعاً: إدارة المزاد المباشر",
                    icon: "gavel",
                    services: [
                      { name: "مدير مزاد محترف (Auctioneer)", desc: "إدارة المزاد بأسلوب يحفز التنافس بين المزايدين ويدفع السعر النهائي إلى أقصى مستوى يمكن تحقيقه." },
                      { name: "المزايدة متعددة العملات", desc: "تحويل العملات لحظياً للمزايدين الدوليين — إزالة كافة العوائق المالية أمام المشاركة العالمية." },
                      { name: "نظام الإشعارات اللحظية", desc: "تنبيهات فورية على الجوال للمزايدين في اللحظة التي يتخطى فيها عرضهم مزايد آخر، للإبقائهم منخرطين في المنافسة." },
                      { name: "إدارة المزادات المغلقة", desc: "تقديم عروض الأسعار في أظرفة مغلقة رقمية للحالات التي تستوجب التكتم والسرية التامة." },
                    ],
                  },
                  {
                    title: "خامساً: التمويل والحلول المالية",
                    icon: "payments",
                    services: [
                      { name: "الموافقة التمويلية المسبقة", desc: "ربط المزايدين بالبنوك الشريكة للحصول على موافقة تمويل فورية في حال رسو المزاد عليهم." },
                      { name: "تسهيلات سداد فارق السعر", desc: "حلول ائتمانية تساعد المستثمرين على تغطية الفجوة بين سعر الرسو والأموال المتاحة فوراً." },
                      { name: "إدارة التحصيل الفوري", desc: "نظام إلكتروني يحصّل الدفعة المقدمة لحظة سقوط المطرقة، مما يُغلق الصفقة دون تأخير." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات ما بعد المزاد",
                    icon: "task_alt",
                    services: [
                      { name: "النقل السريع للملكية", desc: "إنهاء كافة الإجراءات الحكومية والضريبية فور اكتمال السداد لتسليم ملكية نظيفة دون تأخير." },
                      { name: "إدارة العقار للفائز بالمزاد", desc: "تحويل العقار المُستحوَذ عليه مباشرة لقسم الإدارة الذكية للأصول لبدء تحقيق العوائد فوراً." },
                      { name: "تأمين سند الملكية", desc: "بوليصة تأمين تضمن صحة الملكية للمشتري الجديد في مواجهة أي طعون قانونية مستقبلية." },
                    ],
                  },
                  {
                    title: "سابعاً: أنواع المزادات المتخصصة",
                    icon: "shuffle",
                    services: [
                      { name: "مزادات البيع المتعثر (Distressed Assets)", desc: "تصفية عقارات البنوك والشركات التي تحتاج سيولة سريعة بأفضل سعر سوقي يمكن تحقيقه." },
                      { name: "مزادات حق الانتفاع", desc: "مزاد على حق استخدام العقار واستغلاله لفترات مطولة — دون نقل الملكية الأصلية." },
                      { name: "المزادات العكسية", desc: "يطرح النادي طلب استحواذ بمواصفات محددة ويتنافس الملاك بتقديم أدنى سعر للبيع." },
                    ],
                  },
                ],
              },
            },
            {
              id: '05',
              name: 'تمويل التجارة الدولية',
              video: financing,
              platformTitle: 'بوابتك للتجارة العالمية: اعتمادات مستندية وخطابات ضمان وحلول تمويل متكاملة',
              marketing:
                'نربطك بالمنظومة الكاملة لأدوات تمويل التجارة الدولية — من الاعتمادات المستندية التجارية إلى خطابات الضمان وكفالات الدفع المقدم — مدعومةً بعلاقاتنا الاستراتيجية مع كبرى البنوك المراسلة حول العالم.',
              detail: {
                heroDesc:
                  "تأمين صفقاتك عبر الحدود بدقة — منصة استشارية وتنفيذية متكاملة للاعتمادات المستندية وخطابات الضمان وتمويل التجارة، مدعومة بشبكة بنوك عالمية",
                details: [
                  "قسم تمويل التجارة الدولية في نادي حلول للاستشارات هو الجسر بين الطموح والتنفيذ في التجارة العالمية. بنينا منصةً استشارية وتنفيذية متكاملة تُزوّد الشركات بالأدوات المالية اللازمة للتداول بثقة عبر الحدود — من أول شحنة حتى أضخم عقود التوريد طويلة الأمد.",
                  "من الاعتمادات المستندية التجارية  إلى خطابات الضمان وكفالات الدفع المقدم وضمانات العطاءات، تغطي خدماتنا الـ 25 المتخصصة كل مرحلة من دورة حياة تمويل التجارة — من الهيكلة والإصدار وحتى التقديم والخصم والتسوية.",
                  "سواء كنت مستورداً يبحث عن ضمانات الدفع، أو مصدِّراً يحتاج سيولة مقابل اعتماد مؤكد، أو مقاولاً يتقدم لعطاءات حكومية تستلزم ضمان ابتدائي، توفر بنية نادي حلول للتجارة الدولية اليقين والسرعة والامتثال في كل خطوة.",
                ],
                categories: [
                  {
                    title: "أولاً: الاعتمادات المستندية — الأدوات الأساسية",
                    icon: "receipt_long",
                    services: [
                      { name: "الاعتماد المستندي التجاري (DLC)", desc: "الآلية المرجعية للدفع التجاري — يُصدره بنك المشتري ويضمن للبائع استلام المبلغ فور تقديم مستندات شحن مستوفية لشروط الاعتماد." },
                      { name: "الاعتماد المستندي الاستندبي (SBLC)", desc: "أداة ضمان ثانوية تُدفع فقط عند تخلف المتقدم عن التزاماته — تُستخدم على نطاق واسع في تمويل المشاريع وترتيبات التوريد المتكررة." },
                      { name: "الاعتماد الدوار (Revolving LC)", desc: "تسهيل ائتماني متجدد ذاتياً للشركات ذات التدفقات الاستيرادية أو التصديرية المتكررة — يُلغي الحاجة إلى فتح اعتماد جديد لكل صفقة." },
                      { name: "الاعتماد القابل للتحويل والمقابل", desc: "يُمكّن الوسطاء والمتداولين والسماسرة من تحويل الائتمان إلى المورد الفعلي دون الكشف عن هامش ربحهم أو علاقتهم التجارية." },
                    ],
                  },
                  {
                    title: "ثانياً: خطابات الضمان — ضمانات العطاء والتنفيذ والدفع",
                    icon: "verified_user",
                    services: [
                      { name: "ضمان العطاء (Bid Bond)", desc: "يُقدَّم لجهة الطرح لإثبات جدية المتقدم بالالتزام بالتوقيع على العقد في حال الفوز — بطاقة الدخول الإلزامية لعطاءات الحكومة والشركات الكبرى." },
                      { name: "ضمان حسن التنفيذ", desc: "يمنح صاحب المشروع ضمانةً مالية في حال أخفق المقاول في تسليم النطاق أو الجدول الزمني أو معايير الجودة المتفق عليها." },
                      { name: "ضمان الدفع المقدم", desc: "يُعاد إلى صاحب العمل في حال أساء المقاول استخدام الدفعة المقدمة أو أخفق في تسويتها خلال مدة العقد." },
                      { name: "ضمان الصيانة والعيوب", desc: "يغطي فترة ضمان إصلاح العيوب بعد الانتهاء، مما يمنح العميل ضماناً بالوفاء بجميع التزامات التصليح." },
                    ],
                  },
                  {
                    title: "ثالثاً: الهيكلة والاستشارة في تمويل التجارة",
                    icon: "account_balance",
                    services: [
                      { name: "مراجعة الوثائق قبل إصدار الاعتماد", desc: "مراجعة العقود وأوامر الشراء وشروط الإنكوترمز قبل الإصدار لضمان بناء الاعتماد أو الضمان بطريقة تُلغي مخاطر الاختلافات منذ اليوم الأول." },
                      { name: "إدارة تعديلات الاعتمادات وتسوية الاختلافات", desc: "التعامل الاحترافي مع تعديلات الاعتمادات والتمديدات والاختلافات الوثائقية لمنع تأخيرات الدفع على جانبي الصفقة." },
                      { name: "التأكيد البنكي وإعادة الإصدار", desc: "إضافة تأكيد من بنك من الدرجة الأولى للحد من مخاطر الدولة وبنك الإصدار للمصدِّرين العاملين في أسواق متقلبة أو ناشئة." },
                      { name: "امتثال رسائل SWIFT", desc: "ضمان توافق جميع رسائل MT700 وMT760 وMT799 مع أحكام UCP 600 وURDG 758 لتجنب إخفاقات الامتثال المكلفة." },
                    ],
                  },
                  {
                    title: "رابعاً: تمويل الاستيراد والتصدير",
                    icon: "import_export",
                    services: [
                      { name: "تمويل ما قبل الشحن", desc: "رأس مال عامل مقابل اعتماد مؤكد أو أمر شراء ثابت — يُمكّن المصدِّرين من تمويل الإنتاج دون استنزاف احتياطياتهم النقدية." },
                      { name: "خصم الاعتمادات بعد الشحن", desc: "تحريك السيولة الفورية بخصم الاعتمادات المقبولة أو الكمبيالات — تحويل الذمم المدينة المستقبلية إلى نقد آني بأسعار تنافسية." },
                      { name: "خدمات التحصيل الوثائقي (D/P و D/A)", desc: "بديل أقل كلفةً من الاعتمادات المستندية — إدارة تحصيلات المستندات عبر شبكة مراسلينا المصرفية لحماية مصالح الطرفين." },
                      { name: "تمويل الاستيراد (مرابحة / دفع مؤجل)", desc: "تسهيلات استيراد متوافقة مع الشريعة تُمكّن المستوردين من استلام البضاعة والسداد خلال أجل ائتماني متفق عليه." },
                    ],
                  },
                  {
                    title: "خامساً: إدارة المخاطر وتأمين الائتمان التجاري",
                    icon: "security",
                    services: [
                      { name: "تقييم المخاطر القُطرية والسياسية", desc: "تقييم المخاطر السيادية وقيود تحويل المدفوعات وعدم الاستقرار السياسي قبل الالتزام بشروط التجارة مع أي طرف مقابل جديد." },
                      { name: "التحقق من الجدارة الائتمانية للطرف المقابل", desc: "تحليل مالي مستقل لملاءة المشتري أو البائع — تحديد الإشارات التحذيرية قبل فتح أول اعتماد مستندي." },
                      { name: "تأمين الائتمان التجاري", desc: "ترتيب تغطية تأمينية ضد تخلف المشتري أو إعساره — مما يُمكّن المصدِّرين من التداول على أساس الحساب المفتوح بحماية مالية كاملة." },
                      { name: "استشارات تحوط العملات الأجنبية", desc: "استراتيجيات العقود الآجلة والخيارات لتثبيت أسعار الصرف والقضاء على تقلبات الفوركس في تدفقات التجارة الدولية." },
                    ],
                  },
                  {
                    title: "سادساً: التمويل التجاري الرقمي والامتثال",
                    icon: "cloud_sync",
                    services: [
                      { name: "منصة الاعتماد المستندي الإلكتروني (e-LC)", desc: "إصدار الاعتمادات ومعالجتها عبر المنصات الرقمية — تقليص وقت التنفيذ والتخلص من الورق وتبسيط متطلبات الامتثال." },
                      { name: "فرز غسيل الأموال والعقوبات (AML & Sanctions)", desc: "الفرز الآلي لجميع معاملات تمويل التجارة مقابل قوائم العقوبات العالمية لضمان الامتثال التنظيمي الكامل وقبول البنوك المراسلة." },
                      { name: "تتبع المعاملات لحظياً", desc: "لوحة تحكم توفر رؤية كاملة لكل اعتماد وضمان من الإصدار إلى التقديم حتى التسوية — مع تنبيهات فورية بالحالة وسجلات تدقيق شاملة." },
                      { name: "تدريب الفرق وبناء القدرات في تمويل التجارة", desc: "ورش عمل وبرامج شهادات لفرق الخزانة والمالية والمشتريات حول آليات الاعتمادات وإدارة الاختلافات وأفضل ممارسات تمويل التجارة الدولية." },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'الحلول الهندسية والتنفيذية',
          title: 'خدمات التنفيذ',
          items: [
            {
              id: '06',
              name: 'خدمة المقاولات والإنشاءات',
              video: contractingandconstruction,
              platformTitle: 'منظومة البناء: نبني رؤيتك',
              marketing:
                'لا تتوقف خدمتنا عند البيع. نقدم منظومة متكاملة للمقاولات والإنشاءات تشرف عليها نخبة من المهندسين، لضمان تنفيذ مشاريعك بأعلى جودة وأقل تكلفة، مع الالتزام التام بالجداول الزمنية.',
              detail: {
                heroDesc:
                  "حلول بناء ذكية ومستدامة تحول المخططات إلى صروح شاهقة — تكلفة أقل، جودة أعلى، بلا تنازلات",
                details: [
                  "الذراع التنفيذية لنادي حلول في قطاع المقاولات والإنشاءات هي القوة المحركة لثورة العقار — تحول مفهوم المقاول التقليدي إلى حلول بناء ذكية ومستدامة توفر التكلفة وترفع الجودة في آنٍ واحد.",
                  "من التصميم والبناء المتكامل وهندسة القيمة إلى أنظمة MEP والبنية التحتية الذكية والمباني الخضراء وخدمات إنقاذ المشاريع المتعثرة، تغطي خدماتنا الـ 25 المتخصصة كل مرحلة من وضع حجر الأساس حتى التسليم.",
                  "يستفيد الأعضاء من الوصول إلى شبكة نادي حلول من نخبة شركات الإنشاءات المعتمدة — تسليم بجودة فندق 5 نجوم بأسعار تنافسية وإشراف فني صارم لا يقبل الخطأ.",
                ],
                categories: [
                  {
                    title: "أولاً: خدمات التخطيط وما قبل البناء",
                    icon: "architecture",
                    services: [
                      { name: "التصميم والبناء المتكامل (Design-Build)", desc: "حل شامل يبدأ من المخططات الهندسية وينتهي بالتنفيذ، لضمان انسجام تام بين الرؤية التصميمية وحقيقة الموقع." },
                      { name: "هندسة القيمة (Value Engineering)", desc: "مراجعة التصاميم لتقليل التكاليف دون المساس بالجودة أو السلامة الإنشائية." },
                      { name: "دراسات فحص التربة والأساسات", desc: "تقييم جيوتقني للتحقق من سلامة المبنى وتحديد نوع الأساسات الأنسب للموقع." },
                      { name: "استخراج التراخيص والتصاريح", desc: "إدارة كافة الإجراءات البيروقراطية مع الجهات الحكومية لبدء العمل في الموقع بشكل قانوني سليم." },
                    ],
                  },
                  {
                    title: "ثانياً: الأعمال الإنشائية والمدنية",
                    icon: "foundation",
                    services: [
                      { name: "أعمال الهيكل الخرساني (Black Structure)", desc: "تنفيذ القواعد والأعمدة والأسقف بأعلى معايير الدقة والمتانة الإنشائية." },
                      { name: "أعمال المنشآت المعدنية (Steel Structures)", desc: "بناء الهناجر والمستودعات والمباني سريعة التجهيز بأنظمة الفولاذ المهيأ مسبقاً." },
                      { name: "ترميم وتدعيم المباني", desc: "معالجة الشروخ وتقوية الهياكل الإنشائية للمباني القديمة أو المتعثرة." },
                      { name: "أعمال البنية التحتية", desc: "تنفيذ شبكات المياه والصرف الصحي والطرق للمشاريع والمجمعات السكنية." },
                    ],
                  },
                  {
                    title: "ثالثاً: التشطيبات والديكور",
                    icon: "format_paint",
                    services: [
                      { name: "التشطيبات الفاخرة على المفتاح (Turnkey)", desc: "تسليم الوحدات مكتملة التشطيب بمعيار فنادق الـ 5 نجوم — جاهزة للسكن فور الاستلام." },
                      { name: "أعمال الواجهات الحديثة", desc: "تنفيذ واجهات الزجاج المعلق (Curtain Walls) والكلادينج والأحجار الطبيعية بأعلى معايير الحرفية." },
                      { name: "العزل المائي والحراري", desc: "حماية المباني من تسربات المياه وتحسين كفاءة الطاقة من خلال أنظمة عزل متطورة." },
                      { name: "أعمال اللاندسكيب والحدائق", desc: "تصميم وتنفيذ المساحات الخارجية وحمامات السباحة وأنظمة الري الذكي حول المبنى." },
                    ],
                  },
                  {
                    title: "رابعاً: الأنظمة الميكانيكية والكهربائية والسباكة (MEP)",
                    icon: "electrical_services",
                    services: [
                      { name: "أنظمة التكييف المركزي (HVAC)", desc: "تصميم وتنفيذ شبكات التكييف والتهوية الموفرة للطاقة لجميع أنواع المباني." },
                      { name: "الأعمال الكهربائية والإنارة الذكية", desc: "تنفيذ لوحات التوزيع وشبكات الإنارة الذكية التي تقلل الاستهلاك وترفع جودة الإضاءة." },
                      { name: "أنظمة مكافحة الحريق", desc: "تركيب أنظمة الإنذار والإطفاء التلقائي متوافقة بالكامل مع اشتراطات الدفاع المدني." },
                      { name: "أعمال السباكة والصرف الصحي", desc: "تنفيذ الشبكات الداخلية والخارجية بأحدث الخامات وتقنيات التركيب." },
                    ],
                  },
                  {
                    title: "خامساً: تكنولوجيا البناء والمباني الذكية",
                    icon: "smart_toy",
                    services: [
                      { name: "تأسيس البنية التحتية الذكية", desc: "تزويد المبنى بشبكة ألياف ضوئية وأنظمة تحكم مركزية — جاهز للمنزل الذكي وإدارة المبنى من اليوم الأول." },
                      { name: "أنظمة الطاقة الشمسية", desc: "تركيب الألواح الشمسية الكهروضوئية لتوفير طاقة نظيفة وتخفيض فواتير الكهرباء للملاك بشكل ملموس." },
                      { name: "البناء المسبق الصب (Pre-cast)", desc: "استخدام تقنيات البناء السريع المسبق الصب لضغط الجداول الزمنية للمشاريع الكبرى." },
                      { name: "حلول المباني الخضراء", desc: "البناء بمواد صديقة للبيئة معتمدة لتقليل البصمة الكربونية وخفض تكاليف التشغيل وإطالة عمر الأصل." },
                    ],
                  },
                  {
                    title: "سادساً: إدارة المواقع والجودة والخدمات التخصصية",
                    icon: "engineering",
                    services: [
                      { name: "الإشراف الهندسي المتكامل", desc: "مهندسون مقيمون في الموقع يضمنون تنفيذ كل تفصيلة طبقاً للمواصفات والرسومات بدقة متناهية." },
                      { name: "إدارة جداول التنفيذ الزمنية", desc: "ضمان تسليم المشاريع في مواعيدها المحددة وإدارة البرامج الزمنية بفاعلية لتجنب غرامات التأخير." },
                      { name: "مراقبة الجودة والاختبارات المعملية", desc: "إجراء اختبارات معملية للخرسانة وجميع المواد الإنشائية للتحقق من المتانة والامتثال للمعايير." },
                      { name: "خدمة إنقاذ المشاريع", desc: "تولي مسؤولية إكمال المشاريع التي توقف فيها المقاولون السابقون أو تعثرت فنياً." },
                      { name: "عقود الصيانة الإنشائية الشاملة", desc: "اتفاقيات صيانة ما بعد التسليم تغطي الهيكل الإنشائي والأنظمة الأساسية للمبنى على المدى البعيد." },
                    ],
                  },
                ],
              },
            },
            {
              id: '07',
              name: 'خدمة الديكور والفرش',
              video: design,
              platformTitle: 'لمسات الحلول: الفن في التفاصيل',
              marketing:
                'حول جدرانك إلى مساحات حياة ملهمة. نقدم خدمات التصميم الداخلي، الديكور، والفرش المتكامل بلمسات عالمية تناسب ذوقك وتضيف قيمة استثمارية حقيقية لعقارك.',
              detail: {
                heroDesc:
                  "اللمسة النهائية التي تمنح العقار روحه وقيمته — التصميم أداة لرفع العائد على الاستثمار، لا مجرد خيار جمالي",
                details: [
                  "الديكور والفرش في نادي حلول هو الفن الذي يحول الجدران الصماء إلى بيئات حياة تساوي أكثر من مجموع مواد بنائها. نقدم التصميم ليس كجماليات فحسب، بل كأداة مثبتة لرفع العائد على الاستثمار وجعل كل عقار جاهزاً للبيع أو الإيجار بأعلى سعر ممكن.",
                  "من التجسيد ثلاثي الأبعاد والأثاث المصنوع خصيصاً إلى دمج المنزل الذكي والمواد المستدامة والإعداد للبيع للمستثمرين، تغطي خدماتنا الـ 25 المتخصصة كل أبعاد المساحة الداخلية — سكنية وتجارية وفندقية وما بينها.",
                  "سواء كنت تشطب منزلاً فاخراً أو تجهز فندقاً أو تُهيئ عقاراً للبيع أو تصمم مكتباً عالي الأداء، تقدم شبكة متخصصي الديكور النخبة في النادي نتائج بمعايير عالمية مع مسؤولية كاملة على المفتاح.",
                ],
                categories: [
                  {
                    title: "أولاً: التصميم والهوية البصرية للمكان",
                    icon: "palette",
                    services: [
                      { name: "التصميم الداخلي ثلاثي الأبعاد (3D Visualization)", desc: "نماذج واقعية وتجول افتراضي شامل للمكان بأدق تفاصيله قبل البدء في أي أعمال تنفيذية." },
                      { name: "مخططات توزيع المساحات (Space Planning)", desc: "استغلال كل متر مربع بذكاء لضمان الراحة والانسيابية الوظيفية في الحركة." },
                      { name: "تصميم مود بورد مخصص (Mood Board)", desc: "لوحة مرجعية تضم الخامات والألوان والأقمشة لضمان توافق جميع الأطراف على الرؤية الفنية قبل التنفيذ." },
                      { name: "استشارات سيكولوجية الألوان", desc: "اختيار الألوان المعيّرة لغرض المكان — الإنتاجية للمكاتب، والهدوء للمنازل، والحيوية للتجزئة." },
                      { name: "تصميم الإضاءة التخصصي (Lighting Design)", desc: "توزيع مصادر الإضاءة لإبراز جماليات الديكور وتحقيق الأهداف الجمالية والوظيفية في آنٍ واحد." },
                    ],
                  },
                  {
                    title: "ثانياً: أعمال الديكور والتشطيب الفني",
                    icon: "brush",
                    services: [
                      { name: "الأسقف المعلقة من الجبس (Gypsum Board)", desc: "تصاميم أسقف عصرية تُخفي قنوات التكييف ومسارات الإنارة والعناصر الإنشائية بأسلوب أنيق." },
                      { name: "تجليد الحوائط بالأخشاب والرخام", desc: "إضافة طابع الفخامة باستخدام المواد الطبيعية أو بدائلها الهندسية عالية الجودة." },
                      { name: "ورق الحائط والدهانات الديكورية", desc: "تقنيات طلاء متطورة وورق حائط مقاوم للرطوبة والخدش يُطبَّق بدقة احترافية." },
                      { name: "الأرضيات التخصصية", desc: "تركيب الرخام والباركيه الطبيعي أو الإيبوكسي للمساحات الصناعية والتجارية." },
                      { name: "الأعمال المعدنية الديكورية", desc: "عناصر من الستانلس ستيل والنحاس للقواطع والحوائط المميزة والإكسسوارات المعمارية." },
                    ],
                  },
                  {
                    title: "ثالثاً: الفرش والأثاث المخصص",
                    icon: "chair",
                    services: [
                      { name: "تصميم وتصنيع الأثاث المخصص", desc: "تصنيع قطع فريدة مصممة خصيصاً لأبعاد العقار وهوية العميل." },
                      { name: "تجهيز المطابخ ودواليب الملابس المدمجة", desc: "حلول تخزين ذكية وعصرية متكاملة مع الحوائط بشكل سلس." },
                      { name: "الفرش الفندقي المتخصص", desc: "تجهيز الشقق الفندقية والمشاريع السياحية بأثاث مطابق للمعايير الدولية للمتانة." },
                      { name: "تنسيق المفروشات والستائر", desc: "اختيار الأقمشة والمنسوجات التي تنسجم مع طراز الأثاث وبالليتة الألوان." },
                      { name: "تنسيق التحف واللوحات الفنية", desc: "اختيار أعمال فنية ومقتنيات تضيف قيمة استثمارية وجمالية مميزة للمكان." },
                    ],
                  },
                  {
                    title: "رابعاً: الحلول الذكية والبيئية",
                    icon: "smart_toy",
                    services: [
                      { name: "دمج أنظمة المنزل الذكي (Smart Home Integration)", desc: "تضمين التحكم في الإضاءة والستائر والمناخ بشكل غير مرئي داخل التصميم الداخلي." },
                      { name: "الديكور الصديق للبيئة (Sustainable Design)", desc: "استخدام مواد معاد تدويرها ودهانات خالية من المركبات العضوية المتطايرة لتحقيق معايير البناء الأخضر." },
                      { name: "تنسيق الحدائق الداخلية (Indoor Landscaping)", desc: "دمج النباتات الحية داخل المساحات لتحسين جودة الهواء والصحة والجمال البصري." },
                      { name: "المعالجات الصوتية (Acoustic Solutions)", desc: "عزل الأصوات وتصميم غرف الاجتماعات وصالات السينما المنزلية والبيئات الحساسة للضوضاء." },
                    ],
                  },
                  {
                    title: "خامساً: خدمات استراتيجية للمستثمرين",
                    icon: "trending_up",
                    services: [
                      { name: "خدمة فرش العقار للبيع (Home Staging)", desc: "تجهيز العقار بأثاث مؤقت مُصمَّم لإبهار المشترين فوراً وتسريع البيع بأعلى سعر." },
                      { name: "باقات الفرش الاقتصادي للاستثمار", desc: "فرش الشقق الإيجارية بأعلى جودة وأقل تكلفة — أسرع مسار لتحقيق تدفق نقدي إيجابي." },
                      { name: "تجهيز المكاتب والمساحات الإدارية", desc: "تصميم بيئات عمل تحفز الموظفين وتعكس قوة الشركة أمام العملاء الزوار." },
                      { name: "إعادة تدوير الأثاث القديم (Renovation)", desc: "تحديث القطع القيمة الموجودة ودمجها في التصميم الجديد بأسلوب عصري وذي صلة." },
                    ],
                  },
                  {
                    title: "سادساً: الدعم اللوجستي والتسليم والصيانة",
                    icon: "local_shipping",
                    services: [
                      { name: "خدمة التسليم على المفتاح (Turnkey)", desc: "المسؤولية الكاملة من الفكرة التصميمية الأولى حتى وضع آخر إكسسوار في مكانه." },
                      { name: "عقود الصيانة الدورية للديكور والأثاث", desc: "اتفاقيات صيانة مجدولة للحفاظ على مظهر المكان وقيمته السوقية على مر الزمن." },
                    ],
                  },
                ],
              },
            },
            {
              id: '08',
              name: 'خدمة الصيانة والترميم',
              video: maintenance,
              platformTitle: 'رعاية الأصول: عقارك دائماً في أمان',
              marketing:
                'الحفاظ على قيمة العقار تبدأ من الاهتمام بتفاصيله. فريقنا المتخصص يتولى كافة أعمال الصيانة والترميم الدوري، لضمان استمرارية جودة عقارك وزيادة عمره الافتراضي.',
              detail: {
                heroDesc:
                  "إدارة صيانة هندسية متكاملة — تُبقي كل عقار عند مستوى الصفر من العيوب وتحمي الملاك من تكاليف الإهمال",
                details: [
                  "خدمة الصيانة والترميم في نادي حلول هي درع الحماية لكل أصل عقاري — تضمن بقاء العقار في حالة مثالية بصرف النظر عن عمره. ننتقل من فكرة الفني التقليدي إلى إدارة صيانة هندسية متكاملة ترفع القيمة السوقية للعقار وتوفر على المالك مصاريف الإصلاحات الكبرى الناتجة عن الإهمال.",
                  "من عقود الصيانة السنوية والرعاية التنبؤية لأنظمة التكييف إلى الترميم الإنشائي وصيانة الأنظمة الذكية والاستجابة الطارئة على مدار الساعة وتقارير الحالة الفنية الشاملة، تغطي خدماتنا الـ 25 المتخصصة كل بُعد مادي وتشغيلي في رعاية العقار.",
                  "سواء كنت تحمي وحدة سكنية أو تصون برجاً تجارياً أو تُعيد تأهيل أصل متعثر لإعادته للسوق، يقدم مهندسو الصيانة المعتمدون في النادي نتائج موثقة ومتسقة — مع تتبع كل تدخل وإبلاغ المالك به.",
                ],
                categories: [
                  {
                    title: "أولاً: خدمات الصيانة الدورية والوقائية",
                    icon: "event_repeat",
                    services: [
                      { name: "عقود الصيانة السنوية (AMC)", desc: "باقات اشتراك تغطي الفحص الدوري لكافة أنظمة المبنى — الكهرباء والسباكة والتكييف." },
                      { name: "صيانة أنظمة التكييف (HVAC)", desc: "تنظيف الفلاتر وفحص مستويات الفريون وصيانة وحدات التشغيل لضمان كفاءة تبريد مستدامة على مدار العام." },
                      { name: "الفحص الدوري للشبكات الكهربائية", desc: "اختبار الأحمال وفحص القواطع والتأكد من سلامة التوصيلات لمنع الحرائق وأعطال الطاقة." },
                      { name: "صيانة السباكة والصرف", desc: "الكشف المبكر عن التسريبات وتنظيف الخزانات وفحص كفاءة المضخات لمنع الأضرار المائية." },
                      { name: "صيانة المسابح والمسطحات المائية", desc: "تعقيم المياه وفحص الفلاتر وصيانة الإضاءة الغاطسة في المسابح والعناصر المائية الديكورية." },
                    ],
                  },
                  {
                    title: "ثانياً: خدمات الترميم الإنشائي",
                    icon: "foundation",
                    services: [
                      { name: "معالجة التصدعات والشروخ", desc: "ترميم الشروخ الإنشائية والسطحية باستخدام مواد كيميائية متخصصة مصممة للمتانة على المدى البعيد." },
                      { name: "تدعيم الأعمدة والأسقف", desc: "تقوية الهياكل الخرسانية للمباني القديمة لإطالة عمرها التصميمي بشكل ملموس." },
                      { name: "علاج صدأ حديد التسليح", desc: "إزالة الصدأ من حديد التسليح وتطبيق دهانات إيبوكسية مانعة للتآكل لحماية السلامة الإنشائية." },
                      { name: "ترميم الواجهات الخارجية", desc: "تجديد الدهانات ومعالجة الأحجار أو تحديث الكلادينج لإعادة بريق ومظهر العقار." },
                      { name: "تجديد عزل الأسطح والحمامات", desc: "استبدال أغشية العزل المائي والحراري المتدهورة بأحدث التقنيات للقضاء على تسربات مياه الأمطار." },
                    ],
                  },
                  {
                    title: "ثالثاً: خدمات الإصلاحات والتشطيبات",
                    icon: "build",
                    services: [
                      { name: "جلي وتلميع الرخام والأرضيات", desc: "إعادة بريق الأرضيات وإصلاح الفواصل المتهالكة لتجديد مظهر الأسطح." },
                      { name: "إعادة طلاء الحوائط والأسقف", desc: "خدمات دهان سريعة ونظيفة لتجديد شكل الغرف بأقل قدر من الإزعاج للساكنين." },
                      { name: "صيانة النجارة والأبواب", desc: "إصلاح الأبواب والنوافذ والمطابخ واستبدال التجهيزات والإكسسوارات التالفة." },
                      { name: "إصلاح أعمال الألومنيوم والزجاج", desc: "صيانة نوافذ uPVC والألومنيوم للحفاظ على أداء العزل الصوتي والحراري." },
                      { name: "تجديد الحمامات والمطابخ", desc: "إحلال وتجديد الأطقم الصحية والخلاط والسيراميك التالف." },
                    ],
                  },
                  {
                    title: "رابعاً: صيانة الأنظمة الذكية والمتخصصة",
                    icon: "settings",
                    services: [
                      { name: "صيانة المصاعد والسلالم المتحركة", desc: "عقود دورية تضمن أمان المستخدمين وانسيابية الحركة الرأسية بلا انقطاع." },
                      { name: "صيانة أنظمة مكافحة الحريق", desc: "فحص رشاشات المياه وطفايات الحريق وحساسات الدخان وفق اشتراطات الدفاع المدني." },
                      { name: "صيانة أنظمة المنزل الذكي", desc: "تحديث البرمجيات وفحص الكاميرات وأنظمة التحكم في الدخول وأتمتة المبنى." },
                      { name: "صيانة أنظمة الطاقة الشمسية", desc: "تنظيف الألواح الشمسية وفحص المحولات لضمان استمرارية وكفاءة إنتاج الطاقة." },
                    ],
                  },
                  {
                    title: "خامساً: الخدمات البيئية واللوجستية",
                    icon: "eco",
                    services: [
                      { name: "تنظيف وتعقيم الخزانات", desc: "ضمان جودة مياه الشرب من خلال تطهير الخزانات والقضاء على الرواسب والتلوث البكتيري." },
                      { name: "مكافحة الآفات الإنشائية", desc: "الحماية من النمل الأبيض والقوارض التي قد تُلحق أضراراً جسيمة بأساسات العقار وداخله." },
                      { name: "تنسيق وصيانة الحدائق (Landscaping)", desc: "قص الأشجار وصيانة شبكات الري وتجديد النجيلة للحفاظ على المساحات الخارجية في أبهى صورها." },
                      { name: "الجلي الميكانيكي للواجهات الزجاجية", desc: "استخدام أنظمة الرافعات والحبال للوصول إلى واجهات الأبراج والمباني الإدارية وتنظيفها." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات الطوارئ والتقييم الفني",
                    icon: "emergency",
                    services: [
                      { name: "خدمة الطوارئ على مدار الساعة", desc: "فريق استجابة سريعة متاح 24/7 للأعطال المفاجئة — انفجار مواسير وانقطاع كلي للكهرباء وأعطال حرجة." },
                      { name: "تقرير الحالة الفنية للعقار", desc: "فحص هندسي شامل يجريه مساحون متخصصون لتقييم الحالة الفنية الكاملة للعقار قبل أي عملية بيع أو شراء." },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'إدارة الاستثمار والخدمات اللوجستية',
          title: 'خدمات النمو',
          items: [
            {
              id: '09',
              video: legal,
              name: 'خدمة الاستشارات القانونية',
              platformTitle: 'درع الأمان: حماية قانونية شاملة',
              marketing:
                'استثمر وأنت مطمئن. نوفر مظلة قانونية قوية لمراجعة كافة العقود والأوراق، والتحقق من صحة الملكية، لضمان خلو كل صفقة داخل النادي من أي ثغرات أو معوقات قانونية.',
              detail: {
                heroDesc:
                  "الحصن القانوني لاستثمارك — 25 خدمة متخصصة تغطي كل مرحلة من تأسيس الشركة إلى تسوية النزاعات والمعاملات العقارية وخدمات العملاء المميزين وأصحاب الثروات",
                details: [
                  "الاستشارات القانونية هي حجر الزاوية في بناء ثقة المستثمر. في نادي حلول، نؤمن بأن كل استثمار ناجح لا بد أن يرتكز على أساس قانوني لا تشوبه شائبة — من لحظة تكوّن الفكرة وحتى النمو والتوسع أو التخارج.",
                  "تغطي خدماتنا القانونية الـ 25 المتخصصة سبعة قطاعات: تأسيس الشركات والحوكمة، والعقارات والإنشاءات، والعقود والعمليات التجارية، وقانون العمل والموارد البشرية، والملكية الفكرية والتجارة الرقمية، والتقاضي وتحصيل الديون، والخدمات الخاصة للأفراد وعائلات الثروات.",
                  "بدعم من شبكة مكاتب محاماة مرخصة ومستشارين قانونيين متخصصين عبر منطقة الخليج والعالم العربي، يوفر الذراع القانوني لنادي حلول لأعضائه مستوى الحماية القانونية الذي كان حكراً على كبار المستثمرين المؤسسيين.",
                ],
                categories: [
                  {
                    title: "أولاً: تأسيس الشركات والحوكمة",
                    icon: "business",
                    services: [
                      { name: "تأسيس الشركات (شركة شخص واحد، مساهمة، ذ.م.م)", desc: "اختيار الكيان القانوني الأمثل ضريبياً وقانونياً وإتمام إجراءات التسجيل لدى الجهات المختصة." },
                      { name: "صياغة النظام الأساسي وعقود التأسيس", desc: "إعداد وثائق تأسيسية وتعديلاتها لضمان حقوق الشركاء وتوزيع الأرباح وصلاحيات الإدارة منذ اليوم الأول." },
                      { name: "خدمات أمانة سر مجلس الإدارة", desc: "تنظيم اجتماعات المجلس وصياغة المحاضر الرسمية والحفاظ على السجلات النظامية التي يستلزمها القانون." },
                      { name: "اتفاقيات المساهمين (Shareholders' Agreements)", desc: "حماية حقوق المساهمين بالأقلية والأغلبية وتنظيم تخارج الشركاء ومنع الشلل في الحوكمة." },
                      { name: "الالتزام والحوكمة المؤسسية", desc: "التأكد من انسجام أعمال الشركة مع التشريعات المحلية والأنظمة القطاعية وأفضل الممارسات الدولية." },
                    ],
                  },
                  {
                    title: "ثانياً: العقارات والإنشاءات",
                    icon: "gavel",
                    services: [
                      { name: "فحص الملكية القانوني (Legal Due Diligence)", desc: "التحقق الكامل من سلامة سند الملكية والأعباء والسلسلة الملكية قبل أي التزام بالشراء." },
                      { name: "تسجيل ونقل الملكية", desc: "إدارة كافة إجراءات التسجيل العقاري والتوثيق الرسمي لضمان انتقال ملكية نظيفة للمشتري." },
                      { name: "عقود المقاولات والإنشاءات (FIDIC)", desc: "صياغة ومراجعة عقود الإنشاء — بما فيها نماذج FIDIC — التي تحكم المقاولين والمقاولين الفرعيين والموردين." },
                      { name: "إدارة النزاعات الإيجارية", desc: "صياغة عقود الإيجار السكني والتجاري وإدارة إجراءات الإخلاء وتحصيل المتأخرات الإيجارية." },
                      { name: "تأسيس الصناديق الاستثمارية العقارية", desc: "الهيكلة القانونية لأدوات التمويل والتطوير الخاصة بصناديق الاستثمار العقاري وشركات الغرض الخاص." },
                    ],
                  },
                  {
                    title: "ثالثاً: العقود والعمليات التجارية",
                    icon: "handshake",
                    services: [
                      { name: "صياغة العقود التجارية", desc: "عقود التوريد والتوزيع والوكالة التجارية والسمسرة، مصاغةً لحماية موقف الموكل وتقليص مخاطر التقاضي." },
                      { name: "عقود حقوق الامتياز التجاري (Franchise)", desc: "صياغة عقود الفرنشايز وحماية حقوق الملكية الفكرية لكلٍّ من المانح والممنوح له." },
                      { name: "تدقيق العقود القائمة وتقييم مخاطرها", desc: "قياس المخاطر القانونية المضمّنة في العقود الموقعة مسبقاً — وتحديد الثغرات قبل أن تتحول إلى نزاعات." },
                      { name: "اتفاقيات السرية وعدم المنافسة (NDA)", desc: "حماية الأسرار التجارية والمعلومات الحساسة خلال التفاوض مع الشركاء المحتملين أو الموظفين أو المستثمرين." },
                    ],
                  },
                  {
                    title: "رابعاً: قانون العمل والموارد البشرية",
                    icon: "people",
                    services: [
                      { name: "صياغة عقود العمل", desc: "عقود متوافقة مع قانون العمل المحلي تحمي صاحب العمل من الثغرات القانونية وتستوفي جميع المتطلبات التنظيمية." },
                      { name: "اللوائح الداخلية للشركات", desc: "إعداد لائحة الجزاءات والمكافآت المعتمدة من وزارة العمل لمنظومة العمل الداخلية للعميل." },
                      { name: "تمثيل المنشأة في القضايا العمالية", desc: "التمثيل القانوني للشركات أمام المحاكم العمالية ولجان تسوية النزاعات." },
                    ],
                  },
                  {
                    title: "خامساً: الملكية الفكرية والتجارة الرقمية",
                    icon: "verified",
                    services: [
                      { name: "تسجيل العلامات التجارية وحماية الملكية الفكرية", desc: "تسجيل العلامات التجارية والنماذج الصناعية وبراءات الاختراع — وملاحقة أي انتهاك لهذه الحقوق قانونياً." },
                      { name: "قانون التجارة الإلكترونية (T&C وسياسة الخصوصية)", desc: "صياغة شروط وأحكام وسياسات خصوصية وإشعارات حماية بيانات متوافقة قانونياً للمواقع والتطبيقات." },
                    ],
                  },
                  {
                    title: "سادساً: التقاضي وتحصيل الديون",
                    icon: "balance",
                    services: [
                      { name: "تحصيل الديون (ودياً وقضائياً)", desc: "إصدار الإنذارات القانونية الرسمية ومباشرة إجراءات التنفيذ لاسترداد الديون المعلقة بكفاءة." },
                      { name: "التمثيل القضائي", desc: "تمثيل كامل في الدعاوى المدنية والتجارية أمام كافة درجات المحاكم." },
                      { name: "التحكيم والوساطة", desc: "تسوية النزاعات خارج نطاق المحاكم عبر التحكيم والوساطة — أسرع وأكثر سرية وقابل للتنفيذ." },
                    ],
                  },
                  {
                    title: "سابعاً: الخدمات الخاصة (الأفراد والنخبة)",
                    icon: "family_restroom",
                    services: [
                      { name: "تخطيط المواريث والتركات", desc: "صياغة الوصايا وهيكلة انتقال الثروة بين الأجيال لحماية الأصول العائلية (دعم مكتب العائلة — Family Office)." },
                      { name: "استشارات الإقامة والجنسية عبر الاستثمار", desc: "استشارات قانونية متخصصة في برامج الإقامة والجنسية من خلال الاستثمار في مختلف الولايات القضائية المستهدفة." },
                      { name: "التدقيق القانوني الشامل للمستثمر", desc: "تقرير دوري يكشف الثغرات والإشكاليات القانونية عبر جميع استثمارات العميل الحالية وهياكله المؤسسية." },
                    ],
                  },
                ],
              },
            },
            {
              id: '10',
              name: 'خدمة إدارة الأملاك والعقارات',
              video: assetmanagement,
              platformTitle: 'إدارة النخبة: استثمارك ينمو وأنت مستريح',
              marketing:
                'نتحمل عنك عبء الإدارة اليومية. من تحصيل الإيجارات إلى متابعة المستأجرين وتشغيل العقارات الإدارية والتجارية، نحن نضمن لك أعلى عائد استثماري بأقل مجهود.',
              detail: {
                heroDesc:
                  "إدارة أملاك ذكية بتقنية PropTech تحول عقارك من أصل جامد إلى استثمار محسّن — أعلى العوائد بلا متاعب يومية",
                details: [
                  "تُحوّل خدمة إدارة الأملاك الذكية في نادي حلول المفهوم التقليدي كلياً؛ من مجرد تحصيل إيجارات إلى تعظيم شامل لقيمة الأصول بالتكنولوجيا. الهدف هو راحة بال المالك بالكامل وأعلى كفاءة تشغيلية لكل عقار في محفظتك.",
                  "من لوحة تحكم المالك الرقمية وفحص المستأجرين بالذكاء الاصطناعي إلى الصيانة التنبؤية بأجهزة الاستشعار وإعداد التقارير المالية الآلية وإدارة الإيجار قصير الأجل، تغطي خدماتنا الـ 25 المبتكرة كل أبعاد إدارة العقارات الحديثة.",
                  "نستبدل نموذج العمولة التقليدي بنظام عضوية احترافي يضمن للمستثمرين الجودة والشفافية وعوائد قابلة للقياس — محولاً كل عقار إلى مشروع استثماري ذكي يُدار بأقل تدخل بشري ممكن.",
                ],
                categories: [
                  {
                    title: "أولاً: المنصة الرقمية والتحكم عن بُعد",
                    icon: "dashboard",
                    services: [
                      { name: "لوحة تحكم المالك الرقمية (Owner Dashboard)", desc: "تطبيق يتيح للمالك متابعة كافة تفاصيل عقاراته وعقوده وتحصيلاته لحظة بلحظة — في أي وقت ومن أي مكان." },
                      { name: "بوابة المستأجر الذكية (Tenant App)", desc: "تمكين المستأجرين من دفع الإيجار وطلب الصيانة والتواصل مع الإدارة رقمياً عبر بوابة إلكترونية متكاملة." },
                      { name: "العقود الإلكترونية الموثقة", desc: "أتمتة إصدار وتجديد عقود الإيجار وربطها بالمنصات الحكومية الرسمية مثل منصة إيجار." },
                      { name: "نظام الدفع الآلي", desc: "تحصيل الإيجارات عبر قنوات دفع رقمية متعددة مع ميزة الخصم المباشر لضمان الالتزام في الموعد." },
                      { name: "المعاينات الافتراضية ثلاثية الأبعاد", desc: "عرض الوحدات الشاغرة بتقنيات الواقع الافتراضي لتقليل فترات الشغور وجذب مستأجرين مميزين أسرع." },
                    ],
                  },
                  {
                    title: "ثانياً: إدارة الصيانة والعمليات",
                    icon: "build",
                    services: [
                      { name: "الصيانة التنبؤية (IoT)", desc: "أجهزة استشعار ذكية ترصد الأعطال قبل وقوعها — من تسريبات المياه إلى أعطال المصاعد — للحد من الإصلاحات الطارئة المكلفة." },
                      { name: "نظام أوامر العمل الآلي", desc: "توجيه طلبات الصيانة مباشرة لأقرب فني معتمد مع تتبع التنفيذ بالصور والتقارير." },
                      { name: "إدارة المرافق الموفرة للطاقة", desc: "حلول ذكية لتقليل استهلاك الكهرباء والمياه في المناطق المشتركة لخفض المصاريف التشغيلية للمالك." },
                      { name: "التفتيش الدوري الرقمي", desc: "تقارير دورية مدعمة بالصور والفيديو عن الحالة الإنشائية والفنية للعقار ترسل للمالك تلقائياً." },
                      { name: "إدارة النفايات الذكية", desc: "التعاقد مع شركات تدوير وخدمات نظافة تعمل بنظام الاستجابة السريعة لضمان الامتثال والكفاءة." },
                    ],
                  },
                  {
                    title: "ثالثاً: الإدارة المالية والشفافية",
                    icon: "account_balance_wallet",
                    services: [
                      { name: "التقارير المالية الفورية", desc: "قوائم أرباح وخسائر وميزانيات عمومية لكل عقار بضغطة زر، محدّثة دائماً وشفافة تماماً." },
                      { name: "إدارة النفقات والضرائب", desc: "دفع فواتير المرافق والضرائب العقارية والتأمين نيابة عن المالك مع جدولة كاملة وتوثيق." },
                      { name: "تحليل العائد الإيجاري (Yield Analysis)", desc: "دراسات دورية لمقارنة إيجارات العقار بمتوسط السوق لضمان أعلى عائد يمكن تحقيقه." },
                      { name: "استراتيجية تعظيم القيمة", desc: "خطط تطوير وتحسين مخصصة لرفع القيمة السوقية للعقار استعداداً لأي بيع أو تبادل مستقبلي." },
                    ],
                  },
                  {
                    title: "رابعاً: علاقات المستأجرين والالتزام",
                    icon: "people",
                    services: [
                      { name: "الفحص الذكي للمستأجرين (AI Screening)", desc: "نظام آلي يقيّم الملاءة المالية والسلوك الائتماني للمستأجرين المحتملين قبل التوقيع على أي عقد." },
                      { name: "المساعد الافتراضي (AI Concierge)", desc: "روبوت دردشة ذكي يرد على استفسارات المستأجرين ويحل مشاكلهم على مدار الساعة دون تدخل بشري." },
                      { name: "برامج ولاء المستأجرين", desc: "خصومات ومميزات للمستأجرين الملتزمين طويلي الأمد لتعظيم معدلات الاستبقاء وتقليل التكاليف." },
                      { name: "فض النزاعات الرقمي", desc: "خدمات قانونية سريعة للتعامل مع المتأخرات والمخالفات التعاقدية باحترافية وكفاءة." },
                    ],
                  },
                  {
                    title: "خامساً: الأمن والخدمات اللوجستية",
                    icon: "security",
                    services: [
                      { name: "نظام الدخول الذكي (Keyless Entry)", desc: "إدارة الأقفال والمداخل إلكترونياً مع تغيير الأكواد فورياً للمستأجرين الجدد دون الحاجة لتغيير الأقفال." },
                      { name: "الأمن والمراقبة الذكية", desc: "ربط كاميرات العقار بنظام تحليل فيديو ذكي يرصد التحركات المشبوهة ويخطر الإدارة فوراً." },
                      { name: "إدارة مواقف السيارات الذكية", desc: "نظام للتعرف على أرقام اللوحات لتنظيم الدخول والوقوف للسكان والزوار بكفاءة." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات القيمة المضافة",
                    icon: "star",
                    services: [
                      { name: "تأجير المساحات المشتركة", desc: "إدارة استثمار الأسطح والقاعات والمساحات الإعلانية في العقار لتوليد دخل إضافي للمالك." },
                      { name: "خدمات التأثيث والفرش", desc: "باقات تأثيث ذكي للوحدات الشاغرة لرفع قيمتها الإيجارية وجذب مستأجرين متميزين." },
                      { name: "إدارة العقارات قصيرة الأجل", desc: "تشغيل الوحدات بنظام Airbnb والمنصات المشابهة في المواسم لتحقيق عوائد إيجارية مضاعفة مقارنة بالإيجار التقليدي." },
                      { name: "شهادة العقار الأخضر", desc: "تحويل العقار لمعايير صديقة للبيئة للحصول على تمويلات بنكية مفضلة وإعفاءات ضريبية محتملة." },
                    ],
                  },
                ],
              },
            },
            {
              id: '11',
              video: investment,
              name: 'خدمة الاستثمار العقاري (صناديق ومحافظ)',
              platformTitle: 'نادي المستثمرين: صناعة الثروة',
              marketing:
                'شارك في كبرى الفرص العقارية العالمية. نقدم استشارات استثمارية ومحافظ متنوعة تتيح لك الدخول في مشاريع كبرى لم تكن لتصل إليها بمفردك، مع ضمان التوزيع العادل للأرباح.',
              detail: {
                heroDesc:
                  "المستوى الأعلى في نادي حلول — من صفقات الوحدات الفردية إلى إدارة ثروات عقارية ضخمة عبر الصناديق والمحافظ والهياكل الاستثمارية المؤسسية",
                details: [
                  "تمثل صناديق ومحافظ الاستثمار العقاري قمة ما يقدمه نادي حلول — تجاوزاً لصفقات الوحدات الفردية نحو الإدارة الذكية للثروات العقارية الضخمة. هذه الخدمة هي المغناطيس الرئيسي للبنوك والمؤسسات السيادية والشركات التي تسعى لضخ ملايين الدولارات باحترافية وأمان.",
                  "من هيكلة الصناديق العقارية (REITs) وتأسيس الشركات ذات الغرض الخاص إلى التملك الجزئي والاستحواذ على الأصول المتعثرة ولوحات المستثمرين الرقمية والإعداد للطرح العام، تغطي خدماتنا الـ 25 المتخصصة كل مرحلة من مراحل دورة حياة الاستثمار من التأسيس حتى التخارج المربح.",
                  "يحصل الأعضاء على تدفق صفقات حصرية خارج السوق وهندسة مالية مؤسسية وأطر حوكمة تستوفي معايير هيئات سوق المال — مما يجعل النادي الشريك الاستثماري العقاري الأكثر ثقة في المنطقة.",
                ],
                categories: [
                  {
                    title: "أولاً: التخطيط وتأسيس المحافظ",
                    icon: "account_balance",
                    services: [
                      { name: "رسم الاستراتيجية الاستثمارية", desc: "تحديد أهداف العميل — عائد دوري أو نمو رأس مال أو كلاهما — بناءً على درجة تحمله للمخاطر." },
                      { name: "تأسيس الصناديق العقارية (REITs)", desc: "دعم الهيكلة القانونية والمالية للصناديق العقارية المتداولة علناً أو الخاصة." },
                      { name: "توزيع الأصول (Asset Allocation)", desc: "تنويع المحفظة بين القطاعات — سكني وتجاري وإداري وصناعي — لتحسين ملف المخاطرة والعائد." },
                      { name: "تأسيس الشركات ذات الغرض الخاص (SPVs)", desc: "إنشاء كيانات قانونية مستقلة لكل مشروع استثماري لعزل أصول المستثمر عن أي التزامات أخرى." },
                      { name: "نمذجة العائد الداخلي وصافي القيمة الحالية (IRR & NPV)", desc: "نماذج مالية متطورة تتوقع معدل العائد الداخلي وصافي القيمة الحالية لكل فرصة استثمارية." },
                    ],
                  },
                  {
                    title: "ثانياً: الاستحواذ واقتناص الفرص",
                    icon: "search",
                    services: [
                      { name: "اقتناص الفرص الحصرية خارج السوق", desc: "الوصول إلى أصول غير مدرجة علناً من خلال شبكة النادي الخاصة — الأسبقية في أفضل الفرص." },
                      { name: "الاستثمار الجماعي (Fractional Ownership)", desc: "تمكين صغار المستثمرين من امتلاك حصص نسبية في أصول كبرى — أبراج وفنادق ومشاريع مميزة." },
                      { name: "تجميع الأراضي (Land Banking)", desc: "الاستحواذ على أراضٍ في محاور النمو المستقبلي والاحتفاظ بها للتطوير أو البيع لاحقاً بعائد مرتفع." },
                      { name: "الاستحواذ على الأصول المتعثرة", desc: "شراء عقارات بأسعار أقل من قيمتها السوقية وتنفيذ تأهيل القيمة المضافة لتحقيق مكاسب الفجوة." },
                      { name: "الفحص النافي للجهالة الاستثماري", desc: "تقييم شامل للجدوى الاقتصادية والقانونية للأصل قبل ضخ أي رأس مال." },
                    ],
                  },
                  {
                    title: "ثالثاً: إدارة الأصول ونمو المحفظة",
                    icon: "trending_up",
                    services: [
                      { name: "إعادة هيكلة المحافظ", desc: "بيع الأصول ضعيفة الأداء وإعادة نشر رأس المال في عقارات ذات نمو أسرع وعائد أعلى." },
                      { name: "تعظيم القيمة الإيجارية", desc: "تطبيق استراتيجيات تشغيلية لرفع عوائد الإيجار السنوية عبر المحفظة بأكملها." },
                      { name: "إدارة التدفقات النقدية للصندوق", desc: "جدولة التحصيلات والمصاريف لضمان توزيع أرباح دورية موثوقة ومنتظمة للمساهمين." },
                      { name: "مراقبة أداء السوق (Benchmarking)", desc: "مقارنة أداء المحفظة بمؤشرات السوق العقاري العالمية والمحلية لرصد الفجوات والفرص." },
                      { name: "تحسين التكاليف الضريبية للمحفظة", desc: "استخدام هياكل استثمارية ذكية لتقليل العبء الضريبي على الأرباح والمكاسب الرأسمالية." },
                    ],
                  },
                  {
                    title: "رابعاً: التمويل والهندسة المالية",
                    icon: "calculate",
                    services: [
                      { name: "استراتيجية الرافعة المالية (Leverage)", desc: "توظيف التمويل البنكي المدروس لتوسيع حجم المحفظة ومضاعفة العائد على حقوق الملكية." },
                      { name: "إعادة تمويل الأصول (Refinancing)", desc: "سحب السيولة من عقارات ارتفعت قيمتها عبر إعادة التمويل وإعادة استثمارها في فرص عالية العائد." },
                      { name: "إصدار صكوك استثمار عقاري", desc: "تحويل الأصول العقارية إلى صكوك إسلامية قابلة للتداول لاستقطاب سيولة مؤسسية فورية." },
                    ],
                  },
                  {
                    title: "خامساً: تقارير المستثمرين والحوكمة",
                    icon: "dashboard",
                    services: [
                      { name: "لوحة تحكم المستثمر الرقمية", desc: "تطبيق يتيح لكل مستثمر متابعة نمو ثروته العقارية وتدفقاته النقدية لحظياً في أي وقت." },
                      { name: "تقييم دوري للمحفظة (ربع سنوي)", desc: "تقارير ربع سنوية معتمدة تُفصح عن القيمة السوقية الحالية لجميع أصول الصندوق لكل مساهم." },
                      { name: "تقارير الحوكمة والامتثال التنظيمي", desc: "ضمان توافق الصندوق الكامل مع الأنظمة المالية ومتطلبات هيئات سوق المال." },
                    ],
                  },
                  {
                    title: "سادساً: استراتيجيات التخارج",
                    icon: "exit_to_app",
                    services: [
                      { name: "التخطيط للتخارج المربح", desc: "تحديد التوقيت والأسلوب الأمثل لبيع أصول المحفظة لتحقيق أقصى مكاسب رأسمالية ممكنة." },
                      { name: "الطرح العام الأولي (IPO)", desc: "تجهيز المحفظة العقارية للتحول إلى شركة مساهمة عامة مدرجة في البورصة." },
                      { name: "التصفية المنظمة للصناديق", desc: "إدارة عملية بيع الأصول وتوزيع العوائد على جميع المستثمرين عند انتهاء عمر الصندوق." },
                      { name: "خدمة التبادل الكلي للمحفظة", desc: "مقايضة محفظة عقارية كاملة بمساهمة في مشروع قومي أو تطوير عقاري ضخم." },
                    ],
                  },
                ],
              },
            },
            {
              id: '12',
              video: leasing,
              name: 'خدمة التأجير العقاري (السكني والتجاري)',
              platformTitle: 'سوق الإيجارات: اختيارك الأول',
              marketing:
                'قاعدة بيانات ضخمة للمستأجرين والمؤجرين الجادين. نسهل لك عملية العثور على المستأجر المناسب أو الوحدة المثالية للإيجار في وقت قياسي وبشروط عادلة للطرفين.',
              detail: {
                heroDesc:
                  'خدمة التأجير في "نادي حلول" هي الرئة التي يتنفس بها المستثمر — لا مجرد "تأجير وحدة"، بل إدارة علاقة تعاقدية ذكية تضمن للمالك أعلى عائد وللمستأجر أفضل تجربة، مع تقليل فترات الشغور إلى الحد الأدنى.',
                details: [
                  'العقار الفارغ يكلّف المالك مالاً كل يوم. في نادي حلول، نتعامل مع التأجير كمنظومة إدارة فاعلة: تسعير مدروس وفق السوق، وفحص ذكي للمستأجرين، وتوثيق بصري احترافي، وحملات رقمية موجهة تضع أصلك أمام المستأجر المناسب — في أسرع وقت.',
                  'تغطي حزمتنا المكونة من 25 خدمة للتأجير دورة حياة العلاقة الإيجارية بالكامل: من أول إدراج للعقار، إلى صياغة العقد، وضمان الوديعة، والتحصيل الآلي للإيجارات، والتفاوض على التجديد، واستراتيجية تقليص الشغور. سواء كان الأصل شقة فاخرة أو مقراً للشركات أو وحدة تجارية، ندير كل مرحلة بإتقان مؤسسي.',
                  'وما وراء الصفقة، يضيف نادي حلول قيمة متراكمة من خلال إدارة الإيجار قصير الأجل، وخدمات الكونسيرج التي ترفع نسبة الاحتفاظ بالمستأجر، والنصائح الاستراتيجية لإعادة تموضع الأصل — لتحويل العقارات ضعيفة الأداء إلى محركات دخل عالية العائد.',
                ],
                categories: [
                  {
                    title: 'خدمات المالك (Landlord Services)',
                    icon: 'home_work',
                    services: [
                      { name: 'تحليل العائد الإيجاري المستهدف', desc: 'دراسة السوق لتحديد السعر الأعلى والمنافس لضمان سرعة التأجير.' },
                      { name: 'التسويق الرقمي الموجه', desc: 'عرض الوحدات في قسم "الإيجارات الفاخرة" بالمنصة للوصول للشركات والموظفين من الفئات العليا.' },
                      { name: 'الفحص الذكي للمستأجرين (Screening)', desc: 'التحقق من الملاءة المالية والسجل الائتماني والسلوكي للمستأجر قبل التوقيع.' },
                      { name: 'التصوير والتوثيق الاحترافي', desc: 'عمل ملف بصري كامل للوحدة (فيديو + صور + VR) لإبراز مميزاتها.' },
                      { name: 'خدمة "تجهيز الوحدة للإيجار"', desc: 'تقديم استشارات ديكور سريعة لرفع قيمة الإيجار (مثل دهانات حديثة أو إضاءة ذكية).' },
                    ],
                  },
                  {
                    title: 'خدمات المستأجر (Tenant Services)',
                    icon: 'person_search',
                    services: [
                      { name: 'البحث والترشيح المخصص', desc: 'توفير خيارات تطابق احتياجات السكن أو المقر الإداري للشركات بدقة.' },
                      { name: 'خدمة "المعاينة الرقمية"', desc: 'تمكين المستأجر (خاصة الدوليين) من معاينة الوحدة عبر الفيديو التفاعلي قبل الحضور.' },
                      { name: 'تسهيلات الدفع الرقمي', desc: 'توفير خيارات دفع الإيجار عبر البطاقات الائتمانية أو التحويلات الآلية.' },
                      { name: 'خدمة "تأمين السكن"', desc: 'توفير بوالص تأمين للمستأجر تحميه من الحوادث أو الأعطال الكبرى داخل الوحدة.' },
                    ],
                  },
                  {
                    title: 'إدارة العقود والحلول القانونية',
                    icon: 'description',
                    services: [
                      { name: 'صياغة العقود الموحدة المعتمدة', desc: 'إصدار عقود قانونية تضمن حقوق الطرفين وتتوافق مع المنصات الحكومية (مثل منصة "إيجار").' },
                      { name: 'التوثيق الإلكتروني الفوري', desc: 'إنهاء إجراءات توثيق العقد رقمياً ليكون سنداً تنفيذياً يحمي المالك.' },
                      { name: 'إدارة "حساب الضمان" للودائع', desc: 'الاحتفاظ بمبلغ التأمين في حساب وسيط للنادي لضمان ردّه أو استخدامه في الإصلاحات بعدالة.' },
                      { name: 'خدمة الوساطة في النزاعات', desc: 'حل أي خلاف بين المالك والمستأجر ودياً عبر خبراء النادي قبل اللجوء للقضاء.' },
                    ],
                  },
                  {
                    title: 'التأجير التجاري والإداري',
                    icon: 'business',
                    services: [
                      { name: 'تأجير المقرات الإدارية للشركات', desc: 'خدمات مخصصة للشركات العالمية لإيجاد مكاتب في المواقع الاستراتيجية.' },
                      { name: 'تأجير المحلات والمراكز التجارية', desc: 'دراسة "المزيج التسويقي" للمولات لضمان تأجير المحلات لأنشطة تتكامل مع بعضها.' },
                      { name: 'خدمة "التجهيز الفني للمكاتب"', desc: 'مساعدة الشركات المستأجرة في تخطيط المساحات المكتبية وتوزيع الموظفين (Space Planning).' },
                      { name: 'التأجير من الباطن المنظم (Sub-leasing)', desc: 'إدارة عمليات إعادة التأجير للمساحات الكبيرة بما يحقق ربحاً للمستثمر.' },
                    ],
                  },
                  {
                    title: 'الحلول المالية والتحصيل',
                    icon: 'payments',
                    services: [
                      { name: 'التحصيل الآلي للإيجارات', desc: 'نظام يرسل تنبيهات للمستأجرين ويقوم بالتحصيل وإيداع المبالغ في حساب المالك تلقائياً.' },
                      { name: 'تمويل "الإيجار المقدم"', desc: 'حلول مالية تسمح للمالك باستلام إيجار السنة مقدماً، بينما يدفع المستأجر للنادي/البنك بالتقسيط.' },
                      { name: 'تقارير التدفق النقدي', desc: 'تقرير شهري/سنوي للمالك يوضح صافي أرباحه الإيجارية بعد خصم المصاريف.' },
                    ],
                  },
                  {
                    title: 'خدمات القيمة المضافة والتشغيل',
                    icon: 'manage_accounts',
                    services: [
                      { name: 'إدارة التجديدات التعاقدية', desc: 'التفاوض على زيادة الإيجار السنوية ومتابعة تجديد العقود قبل انتهائها بمدة كافية.' },
                      { name: 'خدمة "الاستلام والتسليم"', desc: 'عمل محضر فني دقيق لحالة الوحدة عند استلامها من المستأجر لضمان عدم وجود تلفيات.' },
                      { name: 'التأجير "قصير الأجل" (Vacation Rentals)', desc: 'إدارة الوحدات بنظام الإيجار اليومي أو الأسبوعي لتعظيم الدخل في المواسم السياحية.' },
                      { name: 'خدمات "الكونسيرج" للمستأجرين', desc: 'توفير خدمات النظافة، الصيانة، والإنترنت للمستأجرين لزيادة نسبة الاحتفاظ بهم.' },
                      { name: 'استراتيجية "إعادة التموضع الإيجاري"', desc: 'نصائح للملاك لتحويل نشاط الوحدة (مثلاً من سكني إلى إداري) إذا كان ذلك يحقق إيجاراً أعلى.' },
                    ],
                  },
                ],
              },
            },
          ],
        },
        {
          label: 'الابتكار والتدريب',
          title: 'المستقبل والثقافة',
          items: [
            {
              id: '13',
              video: certificate,
              name: 'خدمة الشهادة العقارية',
              platformTitle: 'الشهادة الذهبية: ختم الثقة العقارية',
              marketing:
                'ابتكارنا الخاص لضمان الحقوق. شهادة معتمدة من النادي تضمن جدية المطور والمشتري، وتعمل كأداة مالية تدعم الثقة بين الأطراف، وتسهل التعاملات البنكية اللاحقة.',
              detail: {
                heroDesc:
                  'شهادة حلول العقارية ليست مجرد ورقة — بل هي "جواز سفر الثقة" و"ختم الجودة" الذي يضمن لكل مشتري ومستثمر أن هذا العقار أو هذا الشخص قد مر عبر فلاتر "حلول" الصارمة.',
                details: [
                  'في أسواق يكلّف فيها غياب المعلومات وعدم الإفصاح عن العيوب المشترين مليارات كل عام، تُعدّ شهادة حلول تحولاً جوهرياً. إنها ابتكار النادي الخاص: وثيقة موحدة وموثقة بصورة مستقلة تحذف الغموض وتستبدل "ثق بي" بحقائق مثبتة وموثقة — قانونياً وإنشائياً ومالياً وتاريخياً.',
                  'تتضمن منظومة الشهادة 25 خدمة تشمل شهادات سلامة الأصل العقاري، وامتيازات مالية للمستثمرين، واعتماداً مهنياً للأعضاء والشركات، وبيانات اعتماد رقمية مؤمّنة بالبلوكشين، وتسجيلاً حكومياً سريع المسار. كل عنصر مصمم ليجعل الأصول والمحترفين المعتمدين الخيار الأول البديهي في كل صفقة.',
                  'وما وراء الصفقات الفردية، تتحول الشهادة إلى قوة سوقية: نظام تصنيف بالنجوم يدفع الملاك للتنافس على الجودة، وجوائز "أوسكار العقار" السنوية التي تكرّم التميز، واعتراف دولي يُيسّر الاستثمار العابر للحدود — لتجعل حلول الوصيّ الموثوق للثقة في أسواق عقارات المنطقة.',
                ],
                categories: [
                  {
                    title: 'شهادة "سلامة الأصل" (للعقارات)',
                    icon: 'verified',
                    services: [
                      { name: 'ختم "الفحص النافي للجهالة"', desc: 'شهادة تؤكد أن العقار سليم قانونياً بنسبة 100% ولا توجد عليه نزاعات أو ديون.' },
                      { name: 'شهادة "الجودة الإنشائية"', desc: 'تقرير فني معتمد يثبت سلامة الهيكل والأساسات والمرافق (الكهرباء والسباكة).' },
                      { name: 'شهادة "السعر العادل"', desc: 'ضمان من النادي بأن سعر العقار يتماشى مع تقييم السوق الحقيقي، مما يمنع التلاعب.' },
                      { name: 'بطاقة "تاريخ العقار" (Property History)', desc: 'سجل رقمي يوضح تاريخ الملكية، الإصلاحات، والتحسينات التي تمت على العقار.' },
                      { name: 'شهادة "الاستدامة والطاقة"', desc: 'توضح مدى كفاءة العقار في استهلاك الطاقة، مما يرفع قيمته للمشترين الواعين بيئياً.' },
                    ],
                  },
                  {
                    title: 'امتيازات مالية وتمويلية (للمستثمرين)',
                    icon: 'savings',
                    services: [
                      { name: 'أولوية التمويل البنكي', desc: 'اتفاقيات مع البنوك الشركاء لاعتماد الشهادة كضمانة لسرعة صرف القروض العقارية.' },
                      { name: 'تخفيض بوالص التأمين', desc: 'خصومات خاصة من شركات التأمين للعقارات التي تحمل شهادة "حلول" نظراً لانخفاض نسبة المخاطرة.' },
                      { name: 'شهادة "العائد المتوقع"', desc: 'دراسة موثقة من النادي توضح العائد الإيجاري المتوقع للأصل، مما يشجع المستثمرين.' },
                      { name: 'ضمان "إعادة البيع"', desc: 'التزام من النادي بتسويق العقارات "المعتمدة" لديه كأولوية قصوى في منصاته العالمية.' },
                    ],
                  },
                  {
                    title: 'شهادة "الاحترافية" (للأعضاء والشركات)',
                    icon: 'badge',
                    services: [
                      { name: 'ختم "المطور المعتمد"', desc: 'تمنح للشركات التي تلتزم بمواعيد التسليم ومعايير الجودة، مما يبني ثقة فورية مع العملاء.' },
                      { name: 'رخصة "الوسيط النخبة"', desc: 'شهادة للأعضاء الأفراد تثبت اجتيازهم دورات التدريب وحصولهم على "كود أخلاقي" في التعامل.' },
                      { name: 'وسام "الشركاء الاستراتيجيين"', desc: 'يوضع على مكاتب الشركات ومواقعهم الإلكترونية كعضو معتمد في شبكة الـ 100 شركة المؤثرة.' },
                    ],
                  },
                  {
                    title: 'خدمات تقنية وتكنولوجية (PropTech)',
                    icon: 'qr_code_2',
                    services: [
                      { name: 'الشهادة الرقمية المشفرة (NFT/Blockchain)', desc: 'شهادة غير قابلة للتزوير مرتبطة بالعقار إلكترونياً لضمان ملكيتها الأصلية.' },
                      { name: 'كود الاستجابة السريع (QR Code)', desc: 'يوضع على مدخل العقار، وبمجرد مسحه يظهر للعميل كامل تفاصيل "الشهادة العقارية" ومميزاتها.' },
                      { name: 'التحديث الدوري للشهادة', desc: 'خدمة مراجعة سنوية لتحديث قيمة العقار وحالته الفنية في الشهادة.' },
                    ],
                  },
                  {
                    title: 'جذب وتسهيلات حكومية وقانونية',
                    icon: 'gavel',
                    services: [
                      { name: 'المسار السريع للتسجيل', desc: 'تعاون مع الجهات الحكومية لاعتماد تقارير النادي الفنية لتسريع إجراءات نقل الملكية.' },
                      { name: 'الحماية القانونية للشهادة', desc: 'توفير فريق قانوني يدافع عن صحة البيانات الواردة في الشهادة أمام أي جهة.' },
                      { name: 'شهادة "خلو من المخالفات"', desc: 'تأكيد رسمي بأن العقار مطابق للمخططات العمرانية ولا توجد عليه مخالفات بناء.' },
                    ],
                  },
                  {
                    title: 'التسويق والبراندنج',
                    icon: 'stars',
                    services: [
                      { name: 'نظام "النجوم" (Rating System)', desc: 'تصنيف العقارات في الشهادة من 1 إلى 5 نجوم بناءً على الفحص، مما يخلق منافسة بين الملاك للتميز.' },
                      { name: 'حفل "أوسكار العقار"', desc: 'تكريم أصحاب العقارات والشركات التي تحمل أعلى تقييمات في شهادات "حلول" سنوياً.' },
                      { name: 'نادي "حاملي الشهادة"', desc: 'منح ميزات حصرية (خصومات ديكور، صيانة) فقط لمن يحمل شهادة اعتماد لعقاره.' },
                      { name: 'الترويج الدولي للشهادة', desc: 'جعل الشهادة معترف بها لدى المستثمرين في السعودية والإمارات لسهولة "تصدير العقار".' },
                      { name: 'ضمان "الشفافية الكاملة"', desc: 'الشهادة تشمل "عيوب العقار" (إن وجدت) وكيفية إصلاحها، مما يبني مصداقية خرافية للنادي.' },
                      { name: 'خدمة "ما قبل الشهادة"', desc: 'تقديم نصائح للمالك حول ما يجب إصلاحه في عقاره ليحصل على "الفئة الماسية" في الشهادة.' },
                      { name: 'الاشتراك المجاني لأول 100 عقار', desc: 'فكرة تسويقية لجذب الأعضاء الأوائل للحصول على الشهادة وتجربة أثرها في سرعة البيع.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '14',
              name: 'خدمة المعارض والمؤتمرات العالمية',
              video: conference,
              platformTitle: 'ملتقى العمالقة: نبض العقار العالمي',
              marketing:
                'ننظم أكبر التجمعات العقارية التي تجمع المطورين والمستثمرين وصناع القرار تحت سقف واحد، لتبادل الخبرات وعقد الصفقات الكبرى المباشرة.',
              detail: {
                heroDesc:
                  'في "نادي حلول"، المعارض والمؤتمرات ليست مجرد تأجير مساحات — بل هي منصات لصناعة القرار، والتموضع الاستراتيجي، والوصول المباشر لنخبة المستثمرين العالميين.',
                details: [
                  'الشركات الكبرى (Class A) والبنوك والمؤسسات الحكومية لا تشارك في الفعاليات من أجل "التواجد" فقط، بل من أجل "الهيمنة" في قطاعها، وبناء علاقات عالية القيمة، وإغلاق صفقات لا يمكن إتمامها في أي مكان آخر. خدمة المعارض والمؤتمرات العالمية في نادي حلول مُصممة بدقة لهذا الطموح.',
                  'تغطي حزمة المعارض المكونة من 25 خدمة كل أبعاد الحضور المؤسسي العالمي: من التعرض الإعلامي الماسي وتصميم الأجنحة الحصرية، إلى توليد العملاء بالذكاء الاصطناعي، وعرض المشاريع بالواقع المعزز، واللقاءات المرتبة مسبقاً مع مستثمرين مؤهلين — كل ذلك في أجواء تجمعات النادي العقارية النخبوية.',
                  'وما وراء الفعالية ذاتها، تتحول المشاركة إلى دورة ترويجية على مدار العام عبر المنصات الرقمية والمطبوعة للنادي، وأولوية في جولاته الدولية القادمة، ومقعد دائم في نادي الشركاء — مما يجعل كل معرض استثماراً ذا عوائد متراكمة.',
                ],
                categories: [
                  {
                    title: 'الظهور الإعلامي والبراندنج (Elite Branding)',
                    icon: 'stars',
                    services: [
                      { name: 'رعاية "الفئة الماسية"', desc: 'منح الشركة المركز الصداري في كافة المواد الدعائية (أونلاين وأوفلاين) كشريك استراتيجي رسمي للنادي.' },
                      { name: 'التغطية التليفزيونية الحصرية', desc: 'تخصيص فقرات ولقاءات مع مسؤولي الشركة في البرامج التليفزيونية التابعة أو المتعاقد معها النادي.' },
                      { name: 'النشر في "المجلة العقارية" الدولية', desc: 'وضع تقارير صحفية وقصص نجاح للشركة في المطبوعات الرسمية للمؤتمر.' },
                      { name: 'فيلم وثائقي ترويجي', desc: 'إنتاج فيديو احترافي يعرض مشاريع الشركة ويُعرض على الشاشات الرئيسية طوال فترة المعرض.' },
                      { name: 'حملات "السوشيال ميديا" المكثفة', desc: 'إطلاق حملات ممولة تستهدف جمهور النادي النوعي للترويج لجناح الشركة قبل وأثناء الحدث.' },
                    ],
                  },
                  {
                    title: 'امتيازات الموقع والمساحة (Premium Presence)',
                    icon: 'villa',
                    services: [
                      { name: 'أجنحة الـ VIP Design', desc: 'تخصيص مساحات في المداخل الرئيسية أو في قلب المعرض مع تصميمات ديكورية استثنائية.' },
                      { name: 'غرف اجتماعات خاصة داخل الجناح', desc: 'لتوقيع العقود وإتمام الصفقات الكبرى بعيداً عن صخب الجمهور.' },
                      { name: 'قاعة "كبار الشخصيات" (VIP Lounge)', desc: 'حق دخول مسؤولي الشركة وعملائهم لمنطقة النخبة للاستراحة والضيافة الراقية.' },
                      { name: 'شاشات عرض عملاقة (LED Screens)', desc: 'وضع إعلانات الشركة على الشاشات الرئيسية في مداخل ومخارج قاعات المؤتمرات.' },
                    ],
                  },
                  {
                    title: 'التشبيك وصناعة الفرص (Networking & B2B)',
                    icon: 'group',
                    services: [
                      { name: 'لقاءات ثنائية مرتبة مسبقاً (Matchmaking)', desc: 'ترتيب مواعيد مؤكدة بين الشركة وبين المستثمرين المهتمين بقطاعها تحديداً.' },
                      { name: 'دعوة "عشاء النخبة"', desc: 'مقعد دائم لمسؤولي الشركة في حفلات العشاء المغلقة التي تضم كبار المسؤولين والمستثمرين الدوليين.' },
                      { name: 'الوصول لقاعدة بيانات الزوار', desc: 'تزويد الشركة ببيانات وتحليلات دقيقة عن اهتمامات الزوار (بما يتوافق مع الخصوصية) لمتابعة الصفقات.' },
                      { name: 'رعاية جلسات النقاش الرئيسية', desc: 'إتاحة الفرصة لرئيس مجلس إدارة الشركة ليكون متحدثاً رئيسياً في الندوات والمؤتمرات.' },
                    ],
                  },
                  {
                    title: 'الدعم اللوجستي المتكامل (Concierge Services)',
                    icon: 'room_service',
                    services: [
                      { name: 'إدارة الشحن والتخزين', desc: 'تولي مسؤولية نقل معروضات الشركة من وإلى المعرض وتخزينها بأمان.' },
                      { name: 'خدمات الاستضافة الفاخرة', desc: 'تأمين إقامة فريق الشركة في فنادق 5 نجوم وتوفير وسائل نقل (VIP) طوال فترة الفعالية.' },
                      { name: 'فريق استقبال احترافي', desc: 'توفير طاقم من المضيفين والمضيفات المدربين بلغات متعددة لتمثيل الشركة في جناحها.' },
                      { name: 'خدمات الترجمة الفورية', desc: 'توفير مترجمين متخصصين للمفاوضات الفنية والقانونية خلال اللقاءات الدولية.' },
                    ],
                  },
                  {
                    title: 'تكنولوجيا المعارض الذكية (Event Tech)',
                    icon: 'phone_iphone',
                    services: [
                      { name: 'البث المباشر للفعاليات', desc: 'بث لحظات إطلاق مشاريع الشركة عبر منصة النادي الرقمية لملايين المتابعين حول العالم.' },
                      { name: 'نظام الـ Lead Generation الذكي', desc: 'استخدام تقنيات الـ QR والذكاء الاصطناعي لجمع بيانات العملاء المهتمين فور زيارتهم للجناح.' },
                      { name: 'دمج الواقع المعزز (AR)', desc: 'مساعدة الشركة في عرض مشاريعها "تحت الإنشاء" بتقنيات الواقع المعزز داخل الجناح.' },
                    ],
                  },
                  {
                    title: 'خدمات القيمة المضافة ما بعد الفعالية',
                    icon: 'workspace_premium',
                    services: [
                      { name: 'تقرير تحليل الأداء', desc: 'تزويد الشركة بتقرير شامل يوضح حجم التفاعل مع جناحها والعائد التقريبي على الاستثمار في المشاركة.' },
                      { name: 'التسويق اللاحق (Remarketing)', desc: 'الاستمرار في عرض بروفايل الشركة على منصة النادي لمدة عام كامل بعد انتهاء المعرض.' },
                      { name: 'الأولوية في المعارض الدولية القادمة', desc: 'ضمان حجز أفضل المواقع للشركة في جولات النادي القادمة (مصر، السعودية، الإمارات، إلخ).' },
                      { name: 'جوائز "التميز العقاري"', desc: 'ترشيح الشركة لجوائز النادي السنوية التي تُوزع في ختام المؤتمرات الكبرى.' },
                      { name: 'عضوية "نادي الشركاء"', desc: 'إدراج الشركة كشريك دائم في كافة فعاليات النادي الصغيرة واللقاءات الشهرية.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '15',
              video: academy,
              name: 'خدمة التدريب والتطوير العقاري (Academy)',
              platformTitle: 'أكاديمية الحلول: صناعة خبراء المستقبل',
              marketing:
                'لا نكتفي بإدارة السوق، بل نصنعه. نقدم برامج تدريبية عالمية لتأهيل الكوادر العقارية ونشر الثقافة الصحيحة، لنرتقي بمهنة التسويق العقاري إلى مستويات احترافية جديدة.',
              detail: {
                heroDesc:
                  'أكاديمية الحلول هي "المصنع" الذي يُخرج الكوادر القادرة على تنفيذ ثورة العقار — كتالوج معرفي موحد واحترافي يحوّل الهواة إلى خبراء معتمدين دولياً.',
                details: [
                  'لضمان نجاح الـ 100 شركة وآلاف الأعضاء، يستثمر نادي حلول في البنية المعرفية التي تدعم كل صفقة. أكاديميتنا لا تُعلّم "السمسرة" — بل تُنمّي التفكير الاستراتيجي، والإتقان التقني، والمعايير الأخلاقية التي تُميّز المحترف العقاري النخبوي على المستوى العالمي.',
                  'يمتد المنهج عبر سبعة مسارات و25 برنامجاً، يشمل كل شيء من الدبلومات المعتمدة دولياً ومهارات PropTech، إلى علم نفس إغلاق الصفقات، والهندسة المالية، وقواعد الامتثال لمكافحة غسل الأموال. تُقدَّم المحتويات عبر تدريب مكثف حضوري، ومعايشة ميدانية في المشاريع الكبرى، ومحاكاة حية، ومكتبة رقمية متاحة 24/7.',
                  'للشركات، تقدم الأكاديمية حلولاً مخصصة: تقييم كفاءات الموظفين، وأكاديميات تدريبية بهوية الشركة، وبرنامج "صناعة المطور" الذي يحوّل المقاولين إلى مستثمرين عقاريين متكاملين. يحصل الخريجون على ختم "عضو النادي العقاري المعتمد" — شهادة جودة تعترف بها البنوك والجهات الحكومية والشركاء المؤسسيين في جميع أنحاء المنطقة.',
                ],
                categories: [
                  {
                    title: 'البرامج المعتمدة والدبلومات المهنية',
                    icon: 'school',
                    services: [
                      { name: 'دبلوم الوساطة العقارية الدولية', desc: 'تأهيل الوسطاء للعمل بمعايير عالمية تتجاوز مفهوم "السمسرة" التقليدي.' },
                      { name: 'شهادة المقيم العقاري المعتمد', desc: 'برنامج مكثف حول طرق التقييم العلمية (التكلفة، السوق، الدخل) بالتعاون مع جهات دولية.' },
                      { name: 'دورة إدارة الأصول والمحافظ الاستثمارية', desc: 'تدريب كبار المستثمرين ومديري الصناديق على كيفية تنمية الثروات العقارية.' },
                      { name: 'برنامج إدارة الأملاك الذكية', desc: 'تدريب أطقم العمل على استخدام تكنولوجيا العقار (PropTech) في تشغيل المباني.' },
                    ],
                  },
                  {
                    title: 'التدريب التقني والتكنولوجي (Smart Real Estate)',
                    icon: 'devices',
                    services: [
                      { name: 'التسويق العقاري الرقمي المتقدم', desc: 'التدريب على أدوات الاستهداف الذكي، والبيع عبر السوشيال ميديا، وصناعة المحتوى.' },
                      { name: 'تطبيقات الذكاء الاصطناعي في العقار', desc: 'كيف يستخدم العضو الـ AI لتحليل بيانات السوق والتنبؤ بالأسعار.' },
                      { name: 'التصوير العقاري والواقع الافتراضي (VR)', desc: 'ورش عمل للمصورين والمسوقين لتقديم العقار بشكل سينمائي مبهر.' },
                      { name: 'إدارة البيانات الضخمة (Big Data)', desc: 'تدريب الشركات على تحليل اتجاهات السوق لاتخاذ قرارات بيع وشراء مدروسة.' },
                    ],
                  },
                  {
                    title: 'المهارات القيادية والبيعية (Soft Skills)',
                    icon: 'psychology',
                    services: [
                      { name: 'فنون التفاوض في الصفقات الكبرى', desc: 'استراتيجيات إغلاق الصفقات المليارية مع الشركات والبنوك.' },
                      { name: 'لغة الجسد والبروتوكول العقاري', desc: 'تدريب المندوبين على كيفية التعامل مع النخبة (Elite Members) بأسلوب راقٍ.' },
                      { name: 'إدارة الأزمات العقارية', desc: 'كيف تتعامل الشركات مع ركود السوق أو تغير القوانين المفاجئ.' },
                      { name: 'القيادة الاستراتيجية لشركات التطوير', desc: 'برنامج مخصص لرؤساء مجلس الإدارة لتطوير الرؤية المؤسسية.' },
                    ],
                  },
                  {
                    title: 'الثقافة القانونية والمالية',
                    icon: 'account_balance',
                    services: [
                      { name: 'قوانين العقارات والتشريعات الدولية', desc: 'فهم العقود، الضرائب العقارية، وقوانين التسجيل في مصر والسعودية والإمارات.' },
                      { name: 'الهندسة المالية للمشاريع', desc: 'تدريب المحاسبين والمديرين على حسابات الـ IRR والـ ROI وجدوى المشاريع.' },
                      { name: 'مكافحة غسل الأموال في العقار', desc: 'ورش عمل للامتثال للقوانين الدولية والمحلية لضمان شفافية الصفقات.' },
                    ],
                  },
                  {
                    title: 'التطوير الميداني والمحاكاة',
                    icon: 'construction',
                    services: [
                      { name: 'برنامج "المعايشة الميدانية"', desc: 'تنظيم زيارات تعليمية للمشاريع القومية الكبرى لتعلم كيفية إدارة المواقع العملاقة.' },
                      { name: 'محاكاة المزادات العقارية', desc: 'تدريب عملي على كيفية إدارة المزايدات والتعامل مع المزايدين بذكاء.' },
                      { name: 'ورش عمل "التبادل العقاري"', desc: 'تدريب الأعضاء على فنون المقايضة العقارية وكيفية إقناع الطرفين بالصفقة.' },
                    ],
                  },
                  {
                    title: 'التحول الرقمي والتعليم المستمر (E-Learning)',
                    icon: 'laptop',
                    services: [
                      { name: 'منصة "حلول" للتعليم الذاتي', desc: 'مكتبة رقمية تضم مئات الساعات التدريبية المتاحة للأعضاء على مدار الساعة.' },
                      { name: 'بودكاست "أسرار العقار"', desc: 'لقاءات دورية مع خبراء عالميين لنقل الخبرات والدروس المستفادة.' },
                      { name: 'ندوات (Webinars) أسبوعية', desc: 'لمناقشة أحدث تغيرات السوق والفرص الاستثمارية اللحظية.' },
                    ],
                  },
                  {
                    title: 'خدمات الشركات والنخبة (Corporate Services)',
                    icon: 'corporate_fare',
                    services: [
                      { name: 'إعداد "الهوية المهنية" للعاملين', desc: 'تدريب موظفي الشركات على تمثيل "براند" الشركة بشكل احترافي.' },
                      { name: 'تقييم أداء الكوادر العقارية', desc: 'خدمة فحص واختبار الموظفين لدى الشركات لتحديد نقاط القوة والضعف.' },
                      { name: 'برنامج "صناعة المطور"', desc: 'تحويل المقاولين إلى مطورين عقاريين يمتلكون فكر الاستثمار والتطوير الشامل.' },
                      { name: 'شهادة "عضو النادي العقاري المعتمد"', desc: 'ختم جودة يمنحه النادي للأفراد والشركات الذين اجتازوا كافة الدورات بنجاح.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '16',
              name: 'دراسات الجدوى',
              platformTitle: 'دراسات جدوى',
              marketing: 'تحليل سوق قائم على البيانات ونماذج تنبؤية للمشاريع.',
              video: feasability,
              detail: {
                heroDesc:
                  'خريطة الطريق التي تحمي رؤوس أموال المستثمرين قبل البدء — تحليل بمستوى C-Suite يغطي الجوانب التسويقية والفنية والمالية والقانونية.',
                details: [
                  'قبل تخصيص رأس المال، تحتاج إلى وضوح تام. يُجري خبراء الجدوى في نادي حلول تحليلات سوقية ومالية صارمة تمنحك إجابة قاطعة حول جدوى المشروع.',
                  'تشمل دراساتنا تحليل الطلب ورسم خريطة المشهد التنافسي والتوقعات المالية وتقييم المخاطر ونمذجة العائد على الاستثمار — مصممة جميعها وفق قطاعك وموقعك الجغرافي.',
                  'بفضل تقرير جدوى نادي حلول، يمكنك التعامل مع البنوك والمستثمرين والجهات التنظيمية بثقة تامة.',
                ],
                categories: [
                  {
                    title: 'أولاً: دراسات السوق والتحليل الاستراتيجي',
                    icon: 'analytics',
                    services: [
                      { name: 'تحليل الطلب والعرض', desc: 'دراسة حجم السوق الفعلي والمتوقع والفجوات الاستثمارية المتاحة.' },
                      { name: 'تحليل المنافسين (Competitor Analysis)', desc: 'دراسة نقاط القوة والضعف للمنافسين المباشرين وغير المباشرين.' },
                      { name: 'دراسة سلوك المستهلك', desc: 'تحديد الفئات المستهدفة وفهم تفضيلاتهم وقدراتهم الشرائية.' },
                      { name: 'تحليل SWOT', desc: 'تحديد نقاط القوة والضعف والفرص والتهديدات الخاصة بالمشروع.' },
                      { name: 'تحليل PESTEL', desc: 'دراسة الظروف السياسية، الاقتصادية، الاجتماعية، التقنية، البيئية، والقانونية المحيطة.' },
                    ],
                  },
                  {
                    title: 'ثانياً: الدراسة الفنية والهندسية',
                    icon: 'engineering',
                    services: [
                      { name: 'تحديد الموقع الأمثل', desc: 'دراسة وتحليل المواقع المقترحة واختيار الأنسب لوجستياً.' },
                      { name: 'توصيف العملية الإنتاجية/الخدمية', desc: 'رسم مسار تدفق العمل (Workflow) من البداية للنهاية.' },
                      { name: 'تقدير الاحتياجات من الأصول', desc: 'تحديد الآلات، المعدات، والأجهزة المطلوبة ومواصفاتها الفنية.' },
                      { name: 'تخطيط الموارد البشرية', desc: 'تحديد الهيكل التنظيمي، الوظائف المطلوبة، والمهارات اللازمة.' },
                      { name: 'تقدير احتياجات المواد الخام والموردين', desc: 'تحديد مصادر الإمداد وتكلفتها التقديرية.' },
                    ],
                  },
                  {
                    title: 'ثالثاً: الدراسة المالية والنمذجة',
                    icon: 'price_change',
                    services: [
                      { name: 'تقدير التكاليف الرأسمالية (CAPEX)', desc: 'حساب تكاليف التأسيس والإنشاءات وشراء الأصول.' },
                      { name: 'تقدير التكاليف التشغيلية (OPEX)', desc: 'حساب المصاريف الشهرية والسنوية من رواتب وإيجارات ومرافق.' },
                      { name: 'بناء نماذج الإيرادات', desc: 'توقع المبيعات بناءً على سيناريوهات متفائل، واقعي، ومتشائم.' },
                      { name: 'تحليل المؤشرات المالية (ROI & IRR)', desc: 'حساب العائد على الاستثمار ومعدل العائد الداخلي.' },
                      { name: 'حساب فترة استرداد رأس المال (Payback Period)', desc: 'متى سيبدأ المشروع في تغطية تكاليفه؟' },
                      { name: 'تحليل نقطة التعادل (Break-even Point)', desc: 'تحديد حجم المبيعات اللازم لتجنب الخسارة.' },
                      { name: 'تحليل الحساسية (Sensitivity Analysis)', desc: 'اختبار مدى تأثر المشروع بتغير أسعار الصرف أو المواد الخام.' },
                    ],
                  },
                  {
                    title: 'رابعاً: دراسات الجدوى المتخصصة',
                    icon: 'real_estate_agent',
                    services: [
                      { name: 'دراسة الجدوى العقارية', desc: 'تحليل الاستخدام الأمثل للأراضي والمشاريع الإنشائية (النادي العقاري).' },
                      { name: 'دراسة الجدوى الصناعية', desc: 'للمشاريع التي تتطلب خطوط إنتاج وتراخيص صناعية معقدة.' },
                      { name: 'دراسة الجدوى للمشاريع التقنية (Startups)', desc: 'تركز على القابلية للتوسع (Scalability) وحصة السوق الرقمية.' },
                    ],
                  },
                  {
                    title: 'خامساً: الجوانب القانونية وتقييم المخاطر',
                    icon: 'gavel',
                    services: [
                      { name: 'الدراسة القانونية والتشريعية', desc: 'تحديد التراخيص المطلوبة والقوانين المنظمة للنشاط.' },
                      { name: 'تقييم المخاطر وخطط الطوارئ', desc: 'تحديد المخاطر المحتملة ووضع حلول استباقية لها.' },
                      { name: 'دراسة الأثر البيئي والاجتماعي', desc: 'ضمان توافق المشروع مع المعايير البيئية والمسؤولية المجتمعية.' },
                    ],
                  },
                  {
                    title: 'سادساً: مخرجات التطوير والاستثمار',
                    icon: 'present_to_all',
                    services: [
                      { name: 'إعداد خطة العمل (Business Plan)', desc: 'ملف شامل يوضح كيفية إدارة وتشغيل المشروع بعد الجدوى.' },
                      { name: 'تجهيز ملف عرض المستثمر (Investor Pitch Deck)', desc: 'تحويل دراسة الجدوى إلى عرض بصري جذاب لإقناع الممولين والشركاء.' },
                    ],
                  },
                ],
              },
            },
            {
              id: '17',
              name: 'الدعاية والتسويق',
              platformTitle: 'انطلاق علامتك التجارية عالمياً',
              video: marketing,
              marketing:
                'استراتيجية الحملة والإبداع وتنفيذ الإعلام لوضع مشروعك أمام الجمهور الصحيح وتسريع معدلات التحويل.',
              detail: {
                heroDesc:
                  "الأداة التي تحول أفكار المستثمرين إلى واقع ملموس وعلامات تجارية مسيطرة",
                details: [
                  "في سوق مزدحم، علامتك التجارية هي أقوى أصولك. يساعدك شركاء التسويق في نادي حلول على صياغة رسائل مقنعة ونشرها عبر القنوات المناسبة للوصول إلى جمهورك المستهدف.",
                  "تشمل خدماتنا استراتيجية العلامة التجارية والإعلان الرقمي وإدارة وسائل التواصل الاجتماعي وإنتاج المحتوى والتسويق عبر المؤثرين وتحليلات الأداء لتوفير رؤية شاملة لمشروعك.",
                  "سواء كنت تدخل سوقًا جديدًا أو تعزز حضورًا قائمًا، نبني حملات مصممة خصيصا لك.",
                ],
                categories: [
                  {
                    title: "أولاً: بناء الهوية والعلامة التجارية",
                    icon: "palette",
                    services: [
                      { name: "تصميم الهوية البصرية كاملة", desc: "الشعار والألوان والخطوط والأوراق الرسمية — كل عنصر بصري يعرّف علامتك التجارية." },
                      { name: "صياغة قصة العلامة التجارية", desc: "بناء الرؤية والرسالة والقيم في سردية مقنعة تتواصل مع جمهورك بعمق." },
                      { name: "بناء الأدلة الإرشادية", desc: "دليل شامل لضمان توحيد شكل العلامة التجارية وأسلوبها في كل مكان." },
                      { name: "خدمات إعادة تسمية العلامة", desc: "تطوير الشركات القائمة بهوية عصرية تواكب متطلبات السوق الحديث." },
                    ],
                  },
                  {
                    title: "ثانياً: التسويق الرقمي وإدارة المنصات",
                    icon: "ads_click",
                    services: [
                      { name: "إدارة حسابات التواصل الاجتماعي", desc: "إدارة متكاملة لفيسبوك وإنستجرام ولينكد إن وتويتر وتيك توك باستراتيجية محتوى تبني مجتمعاً متفاعلاً." },
                      { name: "إدارة الحملات الإعلانية الممولة", desc: "حملات إعلانية موجّهة نحو العائد على كافة المنصات لتحقيق أعلى معدلات الوصول والتحويل." },
                      { name: "تحسين محركات البحث (SEO)", desc: "ضمان ظهور موقعك في النتائج الأولى على جوجل لتحقيق أقصى وصول عضوي." },
                      { name: "إعلانات جوجل (Google Ads)", desc: "حملات شبكة البحث واليوتيوب للوصول إلى المشترين ذوي النية العالية في اللحظة المناسبة." },
                      { name: "التسويق عبر المؤثرين", desc: "اختيار الشخصيات المناسبة لكل قطاع لبناء مصداقية حقيقية مع جمهورك المستهدف." },
                    ],
                  },
                  {
                    title: "ثالثاً: إنتاج المحتوى الإبداعي",
                    icon: "movie",
                    services: [
                      { name: "صياغة المحتوى التسويقي", desc: "كتابة الإعلانات والمحتوى البيعي والبروفايلات التي تخاطب عملاءك مباشرة وتحرّكهم نحو القرار." },
                      { name: "إنتاج الفيديوهات الدعائية", desc: "موشن غرافيك وفيديوهات شرح وبروموهات تستأثر بالانتباه وتدفع للتفاعل." },
                      { name: "التصوير الفوتوغرافي الاحترافي", desc: "تصوير المنتجات والمقرات وفريق العمل لرفع مستوى الحضور البصري للعلامة." },
                      { name: "إنتاج البودكاست المؤسسي", desc: "تعزيز مكانة شركتك كخبير في تخصصها من خلال بودكاست مؤسسي احترافي يثق به الجمهور." },
                    ],
                  },
                  {
                    title: "رابعاً: العلاقات العامة والظهور الإعلامي",
                    icon: "newspaper",
                    services: [
                      { name: "النشر في الصحف والمجلات", desc: "تغطية إخبارية رسمية ومقالات رأي في المنشورات الورقية والإلكترونية لبناء المصداقية." },
                      { name: "تنسيق اللقاءات التلفزيونية والإذاعية", desc: "تنسيق المقابلات والتقارير التي تزيد موثوقية علامتك التجارية أمام جمهور واسع." },
                      { name: "تنظيم الفعاليات والمؤتمرات", desc: "تنظيم القمم والمؤتمرات وحفلات الإطلاق الرسمي للمشاريع مع كامل الدعم الإنتاجي." },
                      { name: "إدارة الأزمات الإعلامية", desc: "حماية سمعة العلامة التجارية بردود فعل سريعة واستراتيجية عند وقوع أي مشكلة." },
                    ],
                  },
                  {
                    title: "خامساً: الحلول التقنية والمباشرة",
                    icon: "devices",
                    services: [
                      { name: "تصميم صفحات الهبوط", desc: "صفحات هبوط محسّنة للتحويل لجمع بيانات العملاء المحتملين وتحقيق نتائج قابلة للقياس." },
                      { name: "التسويق عبر البريد الإلكتروني", desc: "نشرات إخبارية دورية وحملات متسلسلة للحفاظ على تواصل العملاء وتفاعلهم." },
                      { name: "خدمات التسويق عبر الواتساب", desc: "حملات بث موجّهة عبر الواتساب مع ردود آلية ذكية للتفاعل الفوري مع العملاء." },
                      { name: "تصميم وتطوير المواقع الإلكترونية", desc: "مواقع تعريفية ومتاجر رقمية متكاملة مصممة لتحقيق أعلى أداء وتحويل." },
                    ],
                  },
                  {
                    title: "سادساً: التسويق التقليدي والميداني",
                    icon: "storefront",
                    services: [
                      { name: "تصميم وتنفيذ أجنحة المعارض", desc: "تصاميم مبتكرة وجذابة لأجنحة المعارض تستأثر بالانتباه في صالات العرض." },
                      { name: "إعلانات الطرق (Outdoors)", desc: "لوحات إعلانية وشاشات رقمية في مواقع استراتيجية لتحقيق أقصى وصول جماهيري." },
                      { name: "المطبوعات الدعائية وهدايا الشركات", desc: "فلايرات وبروشورات وهدايا مؤسسية مميزة تترك انطباعاً دائماً لدى المتلقي." },
                      { name: "دراسات السوق وتحليل المنافسين", desc: "دراسات سوقية وذكاء تنافسي مبني على بيانات حقيقية لاتخاذ قرارات تسويقية ذكية." },
                    ],
                  },
                ],
              },
            },
            {
              id: '18',
              name: 'الإقامة والهجرة',
              platformTitle: 'بوابتك نحو حرية التنقل العالمي',
              video: immigration,
              marketing:
                'انتقال سلس عبر الدول من خلال دعم متكامل في الإقامة والجنسية والاستقرار، تحت إشراف فريق متخصص وشركاء موثوقين.',
              detail: {
                heroDesc:
                  "خدمات الجنسية والإقامة والاستقرار مصممة لمنح المستثمرين حرية التنقل وحماية إضافية لاستثماراتهم",
                details: [
                  "تعد خدمة الإقامة والهجرة والجنسية عبر الاستثمار من أكثر الخدمات جذباً للمستثمرين وأصحاب الثروات، وهي مكمل عبقري لخدمات نادي حلول لأنها تمنح العميل حرية الحركة وحماية لاستثماراته.",
                  "من خلال 25 خدمة متخصصة تشمل برامج الجنسية عبر الاستثمار والإقامات الذهبية وتأشيرات رواد الأعمال والهجرة المهنية والدعم القانوني وخدمات الاستقرار الكاملة، ندير كل خطوة في رحلتك الهجرية من الاستشارة الأولى حتى الاستقرار النهائي.",
                  "يعمل فريقنا من المحامين المرخصين ومتخصصي الانتقال عبر أكثر من 40 دولة، مما يضمن بناء ملفك بشكل صحيح وتقديمه في الوقت المناسب وقبوله بثقة.",
                ],
                categories: [
                  {
                    title: "أولاً: برامج الجنسية عبر الاستثمار",
                    icon: "travel_explore",
                    services: [
                      { name: "جنسيات الكاريبي", desc: "دومينيكا وسانت كيتس وأنتيغوا وغيرها — جوازات سفر تتيح دخول أكثر من 140 دولة بدون تأشيرة." },
                      { name: "الجنسية التركية عبر الاستثمار", desc: "إدارة كاملة للملف من الاستثمار العقاري أو الوديعة البنكية حتى استلام جواز السفر." },
                      { name: "برامج الجنسية الأوروبية", desc: "مالطا وغيرها من برامج الاتحاد الأوروبي التي تمنح حقوق المواطنة الكاملة وحرية التنقل." },
                      { name: "تجهيز ملفات التقصي الأمني", desc: "فحوصات الخلفية الأمنية لضمان قبول ملف العميل قبل التقديم الرسمي." },
                    ],
                  },
                  {
                    title: "ثانياً: الإقامات الذهبية والدائمة",
                    icon: "star",
                    services: [
                      { name: "الإقامة الذهبية الإماراتية (10 سنوات)", desc: "إقامة طويلة الأمد للمستثمرين والنوابغ وأصحاب العقارات في الإمارات." },
                      { name: "الإقامة المميزة السعودية", desc: "جميع المسارات — المستثمر ورائد الأعمال والكفاءات الاستثنائية." },
                      { name: "الإقامة الذهبية الأوروبية", desc: "برامج اليونان وإسبانيا والبرتغال التي تمنح الإقامة وحرية التنقل في منطقة الشنغن." },
                      { name: "برنامج المستثمر الأمريكي EB-5", desc: "مسار للحصول على الجرين كارد عبر الاستثمار في مشاريع معتمدة من USCIS." },
                    ],
                  },
                  {
                    title: "ثالثاً: تأشيرات رواد الأعمال والشركات الناشئة",
                    icon: "rocket_launch",
                    services: [
                      { name: "تأشيرة رائد الأعمال البريطانية (UK Innovator Founder)", desc: "للمؤسسين الراغبين في بناء أعمالهم وتوسيعها في السوق البريطاني." },
                      { name: "تأشيرات الشركات الناشئة (Start-up Visa)", desc: "كندا وفرنسا وغيرها من الوجهات التي ترحب بالمبتكرين وأصحاب المشاريع الواعدة." },
                      { name: "تأشيرات العمل الحر (Freelance Visas)", desc: "مصممة للمهنيين المستقلين والمستشارين الدوليين الراغبين في إقامة قانونية خارج بلدهم." },
                      { name: "تأشيرة الرحالة الرقميين (Digital Nomad Visa)", desc: "لمن يعملون عن بُعد ويرغبون في الإقامة طويلة الأمد في دول سياحية أو تجارية." },
                    ],
                  },
                  {
                    title: "رابعاً: خدمات الهجرة المهنية والتخصصية",
                    icon: "workspace_premium",
                    services: [
                      { name: "الهجرة الكندية (Express Entry & PNP)", desc: "أسرع مسار للإقامة الدائمة في كندا عبر البرامج الفيدرالية وبرامج ترشيح الأقاليم." },
                      { name: "تأشيرة المواهب العالمية (Global Talent)", desc: "مسار سريع للإقامة للمتميزين في مجالات التكنولوجيا والفن والبحث العلمي." },
                      { name: "البطاقة الزرقاء الأوروبية (EU Blue Card)", desc: "استقطاب الكفاءات المهنية العالية للعمل والإقامة في أي دولة داخل الاتحاد الأوروبي." },
                      { name: "استشارات الدراسة للهجرة", desc: "تأمين القبول الجامعي كمدخل للحصول على تصريح العمل ثم الإقامة الدائمة." },
                    ],
                  },
                  {
                    title: "خامساً: الدعم القانوني والإجرائي",
                    icon: "gavel",
                    services: [
                      { name: "تصديق وتوثيق المستندات (Apostille)", desc: "إنهاء إجراءات السفارات والخارجية لتوثيق كافة الوثائق المطلوبة في ملفات الهجرة." },
                      { name: "الترجمة القانونية المعتمدة", desc: "ترجمة معتمدة لكافة الوثائق إلى اللغة المطلوبة لملف الهجرة." },
                      { name: "استخراج السجلات الجنائية الدولية", desc: "الحصول على شهادات حسن السيرة وتسهيل الفحوصات الطبية المطلوبة للهجرة." },
                      { name: "خدمات لم الشمل", desc: "استخراج تأشيرات الزوجة والأبناء والوالدين التابعين للمستثمر." },
                    ],
                  },
                  {
                    title: "سادساً: خدمات الاستقرار والدمج",
                    icon: "home_pin",
                    services: [
                      { name: "فتح الحسابات البنكية الدولية", desc: "إعداد حسابات مصرفية لغير المقيمين لتسهيل تحويل مبالغ الاستثمار بسلاسة." },
                      { name: "استخراج الأرقام الضريبية", desc: "الحصول على الرقم الضريبي في بلد الإقامة الجديد لضمان الامتثال القانوني الكامل." },
                      { name: "البحث عن العقار السكني", desc: "إيجاد العقارات التي تستوفي شروط الإقامة أو الجنسية في البلد المستهدف." },
                      { name: "الاستشارات المدرسية والجامعية", desc: "تأمين قبول الأبناء في أفضل المدارس الدولية ببلد المقصد." },
                      { name: "خدمات الهبوط الناعم (Soft Landing)", desc: "الاستقبال في المطار واستخراج الهوية المحلية ورخصة القيادة والتأمين الصحي — كل ما تحتاجه لبداية جديدة." },
                    ],
                  },
                ],
              },
            },
            {
              id: '19',
              name: 'الاستشارات المحاسبية والمالية',
              video: accounting,
              platformTitle: 'لغة الأرقام: وضوح مالي لاستثمار ذكي',
              marketing:
                'خدمات محاسبية وضريبية ومالية متكاملة تمنح المستثمرين الوضوح الرقمي الذي يحتاجونه لاتخاذ قرارات سليمة — من التسجيل اليومي للقيود إلى التخطيط المالي الاستراتيجي.',
              detail: {
                heroDesc:
                  "خدمات محاسبية وضريبية واستراتيجية مالية شاملة للشركات في كل مرحلة — من إمساك الدفاتر والامتثال الضريبي إلى تقييم الشركات وإعداد العروض للمستثمرين",
                details: [
                  "الأرقام هي اللغة العالمية للأعمال — وإتقانها هو أساس كل قرار استثماري صحيح. تقدم خدمة الاستشارات المحاسبية والمالية من نادي حلول خبرة على مستوى المدير المالي للشركات بكل أحجامها، من الشركات الناشئة حتى المؤسسات الكبرى.",
                  "من خلال 25 خدمة متخصصة تشمل تصميم الأنظمة المحاسبية وإعداد القوائم المالية الدورية والامتثال لضريبة القيمة المضافة وضريبة الشركات والتخطيط الضريبي الاستراتيجي ودراسات الجدوى المالية وإدارة التدفقات النقدية وتقييم الشركات ودعم التمويل الكامل، نغطي كل بُعد مالي في مشروعك.",
                  "يعمل فريقنا من المحاسبين القانونيين والمستشارين الضريبيين والمحللين الماليين عبر دول الخليج ومصر وسائر العالم العربي — لضمان أن أرقامك دائماً دقيقة ومتوافقة مع الأنظمة ومهيأة للنمو.",
                ],
                categories: [
                  {
                    title: "أولاً: المحاسبة والامتثال",
                    icon: "calculate",
                    services: [
                      { name: "تصميم الهياكل المحاسبية", desc: "بناء الدورة المستندية واختيار أنظمة المحاسبة السحابية المناسبة لطبيعة نشاطك." },
                      { name: "إمساك الدفاتر المحاسبية", desc: "تسجيل العمليات اليومية ومراجعة القيود المحاسبية لضمان الدقة في كل خطوة." },
                      { name: "إعداد القوائم المالية الدورية", desc: "ميزانيات وقوائم أرباح وخسائر وتدفقات نقدية شهرياً وربع سنوياً وفق المعايير الدولية." },
                      { name: "خدمات المدير المالي الخارجي (Outsourced CFO)", desc: "خبرة مالية رفيعة المستوى متاحة للشركات الناشئة والمتوسطة بنموذج تعاقد مرن وفعال من حيث التكلفة." },
                      { name: "التدقيق والمراجعة الداخلية", desc: "فحص مستقل للسجلات للتحقق من دقة البيانات وسلامة الأداء المالي." },
                      { name: "إعداد الحسابات الختامية", desc: "تجهيز الحسابات الختامية وإعداد الملفات للتدقيق الخارجي السنوي والتقديم للجهات الرقابية." },
                    ],
                  },
                  {
                    title: "ثانياً: الخدمات الضريبية والزكاة",
                    icon: "receipt_long",
                    services: [
                      { name: "ضريبة القيمة المضافة (VAT)", desc: "التسجيل وإعداد الإقرارات والاستشارات الضريبية لضمان امتثال كامل لأنظمة ضريبة القيمة المضافة." },
                      { name: "ضريبة الشركات (الإمارات والسعودية ومصر)", desc: "امتثال كامل لأحدث قوانين ضريبة الشركات في الأسواق الخليجية والعربية الرئيسية." },
                      { name: "التخطيط الضريبي الاستراتيجي", desc: "تقليص العبء الضريبي من خلال جميع الهياكل والإعفاءات المتاحة قانوناً." },
                      { name: "تمثيل العميل أمام الهيئات الضريبية", desc: "تمثيل العملاء أمام السلطات الضريبية في عمليات الفحص والاعتراضات وتسوية النزاعات." },
                      { name: "تسعير التحويل (Transfer Pricing)", desc: "توثيق واستشارات تسعير التحويل المتوافقة للشركات ذات الفروع الدولية أو المعاملات مع الأطراف ذات الصلة." },
                    ],
                  },
                  {
                    title: "ثالثاً: التخطيط المالي والاستراتيجية الاستثمارية",
                    icon: "trending_up",
                    services: [
                      { name: "دراسات الجدوى الاقتصادية", desc: "تحليل مالي وتشغيلي شامل للمشاريع الجديدة للتحقق من الجدوى قبل ضخ رأس المال." },
                      { name: "إعداد الموازنات التقديرية والتوقعات المالية", desc: "بناء موازنات سنوية تفصيلية وخطط إنفاق منسجمة مع استراتيجية العمل." },
                      { name: "إدارة التدفقات النقدية (Cash Flow Management)", desc: "ضمان توافر السيولة اللازمة للتشغيل اليومي والنمو المستدام في جميع الأوقات." },
                      { name: "تقييم الشركات (Business Valuation)", desc: "تحديد القيمة السوقية العادلة عند البيع أو الاندماج أو الاستحواذ أو دخول شركاء جدد." },
                      { name: "الفحص المالي النافي للجهالة (Financial Due Diligence)", desc: "تحقيق مالي عميق قبل عمليات الاستحواذ أو الشراكة للكشف عن كافة المخاطر والفرص." },
                    ],
                  },
                  {
                    title: "رابعاً: التمويل والنمو",
                    icon: "rocket_launch",
                    services: [
                      { name: "هيكلة رأس المال", desc: "تحسين التوازن بين التمويل الذاتي والمديونية البنكية لخفض تكلفة رأس المال وتعظيم العوائد." },
                      { name: "تجهيز ملفات التمويل البنكي", desc: "إعداد حزمة التوثيق الكاملة لمساعدة الشركات في الحصول على قروض وتسهيلات ائتمانية." },
                      { name: "إعداد العروض المالية للمستثمرين (Pitch Decks)", desc: "صياغة سرديات مالية مقنعة وتوقعات مالية محكمة لجذب رأس المال الجريء والمستثمرين الاستراتيجيين." },
                      { name: "الاكتتاب العام والتحول المؤسسي", desc: "إدارة الجوانب المالية لإصدار الأسهم والتحول المؤسسي وتوسيع قاعدة الملكية." },
                    ],
                  },
                  {
                    title: "خامساً: خدمات متخصصة (العقار والامتثال)",
                    icon: "domain",
                    services: [
                      { name: "تحليل العائد على الاستثمار العقاري (ROI & IRR)", desc: "تحليل دقيق للعائد على الاستثمار ومعدل العائد الداخلي للمحافظ العقارية." },
                      { name: "محاسبة التكاليف والمشاريع", desc: "تتبع متخصص للتكاليف لشركات المقاولات والمطورين العقاريين عبر دورات حياة المشاريع." },
                      { name: "خدمات الرواتب والأجور (Payroll)", desc: "معالجة الرواتب الكاملة وإدارة المستحقات والامتثال للتأمينات الاجتماعية لفريق عملك." },
                      { name: "الامتثال لمكافحة غسيل الأموال (AML)", desc: "إعداد تقارير وسياسات وإجراءات مكافحة غسيل الأموال المطلوبة قانوناً." },
                      { name: "المحاسبة الجنائية (Forensic Accounting)", desc: "محاسبة تحقيقية لقضايا الاختلاس والنزاعات المالية المعقدة التي تستلزم خبرة احترافية." },
                    ],
                  },
                ],
              },
            },
          ],
        },
      ],
      sovereign: {
        id: '20',
        video: nationalProjects,
        name: 'قطاع المشاريع القومية والتعاون الحكومي',
        platformTitle: 'بوابة المستقبل: تسويق الرؤى والمشاريع السيادية',
        marketing:
          'نحن لا نسوّق لوحدات فحسب، بل نسوّق لرؤى الدول ومستقبل الشعوب. من خلال بروتوكولات تعاون استراتيجية مع وزارات الإسكان والاستثمار في مختلف الدول، يعمل نادي حلول العقاري كذراع تسويقي عالمي للمشاريع القومية والمدن الذكية (مثل العاصمة الإدارية الجديدة ورؤية المملكة 2030). نضع قوتنا الإعلامية والتقنية لربط المستثمرين الدوليين بالفرص السيادية الكبرى، لنكون الجسر الذي يعبر من خلاله الطموح الوطني إلى الساحة العالمية.',
        detail: {
          heroDesc:
            'يعمل نادي حلول العقاري شريكاً استراتيجياً للحكومات — يحوّل الأصول العامة إلى محركات اقتصادية، ويجذب مليارات الاستثمارات، ويسوّق الرؤى السيادية على الساحة العالمية.',
          details: [
            'تمثل المشاريع القومية والعقارات السيادية الساحة الأكثر أهمية في التنمية الاقتصادية. في "نادي حلول"، لا نتعامل مع الحكومات كمجرد جهة ترخيص، بل كشريك استراتيجي نساعده في تحويل الرؤى الوطنية إلى مشاريع قابلة للتمويل، ربطاً بين طموح الدولة ورأس المال والتكنولوجيا والخبرة اللازمة لتحقيقها.',
            'من دراسات الجدوى للمشاريع الكبرى إلى سجلات الأراضي الرقمية، ومن هيكلة الـ PPP إلى بناء العلامة التجارية للدولة، تغطي مجموعتنا المتكاملة من 25 خدمة سيادية كل أبعاد التعامل الحكومي مع العقارات — مما يضمن أن الأصول العامة تولّد أقصى قيمة وطنية وأن أطر الاستثمار تجذب رؤوس الأموال العالمية.',
            'من خلال بروتوكولات التعاون مع وزارات الإسكان والاستثمار في جميع أنحاء المنطقة، يوظف النادي قوته الإعلامية وصرامته التحليلية وقدراته في مجال PropTech لسد الفجوة بين الرؤية السيادية والتنفيذ على أرض الواقع — مما يجعلنا الذراع التسويقي العالمي المفضل للمشاريع القومية والمدن الذكية.',
          ],
          categories: [
            {
              title: 'الاستشارات الاستراتيجية والتخطيط القومي',
              icon: 'account_balance',
              services: [
                { name: 'دراسات الجدوى للمشاريع الكبرى (Mega-Projects)', desc: 'تقديم دراسات متكاملة للمدن الجديدة، المناطق الصناعية، والمنتجعات السياحية العالمية.' },
                { name: 'المخططات العامة للتطوير العمراني', desc: 'استشارات في رسم الخرائط العمرانية واستخدامات الأراضي لتحقيق أقصى عائد للدولة.' },
                { name: 'تطوير استراتيجيات "المدن الذكية"', desc: 'وضع البنية التحتية التكنولوجية للمدن الحديثة لضمان استدامتها.' },
                { name: 'تحليل الأثر الاقتصادي والاجتماعي', desc: 'دراسة مدى تأثير المشاريع القومية على خلق فرص العمل والنمو السكاني.' },
              ],
            },
            {
              title: 'إدارة وتسييل الأصول الحكومية',
              icon: 'real_estate_agent',
              services: [
                { name: 'حصر وتقييم الأصول غير المستغلة', desc: 'بناء قاعدة بيانات رقمية للأراضي والمباني الحكومية وتقدير قيمتها السوقية الحالية.' },
                { name: 'خطط طرح الأراضي للاستثمار', desc: 'تصميم نماذج الطرح (بيع، حق انتفاع، أو مشاركة) لجذب المطورين.' },
                { name: 'تحويل المباني التاريخية لأصول استثمارية', desc: 'إعادة تأهيل القصور والمباني التراثية لتصبح فنادق أو مراكز ثقافية بربحية عالية.' },
                { name: 'إدارة المحافظ العقارية السيادية', desc: 'تقديم خدمات الإدارة الاحترافية للصناديق السيادية العقارية.' },
              ],
            },
            {
              title: 'الشراكة بين القطاعين العام والخاص (PPP)',
              icon: 'handshake',
              services: [
                { name: 'هيكلة مشاريع الـ PPP', desc: 'وضع الأطر القانونية والمالية التي تضمن حقوق الدولة وتحفز المستثمر الخاص.' },
                { name: 'جذب المستثمرين الدوليين (FDI)', desc: 'تسويق المشاريع القومية في المحافل الدولية لجذب رؤوس الأموال الأجنبية.' },
                { name: 'تأسيس "الشركات المشتركة"', desc: 'تسهيل إنشاء كيانات تضم الحكومة مع كبار المستثمرين لتنفيذ مشاريع محددة.' },
                { name: 'إدارة المناقصات والمزايدات القومية', desc: 'تنظيم عمليات الطرح الحكومي بشفافية واحترافية عالمية.' },
              ],
            },
            {
              title: 'الدعم التشريعي والرقابي',
              icon: 'gavel',
              services: [
                { name: 'صياغة مسودات القوانين العقارية', desc: 'تقديم توصيات لتطوير التشريعات التي تسهل الاستثمار العقاري وتدعم "تصدير العقار".' },
                { name: 'تبسيط إجراءات التراخيص (One-Stop Shop)', desc: 'تصميم أنظمة رقمية تنهي البيروقراطية وتسرع إصدار تصاريح البناء والاستثمار.' },
                { name: 'إنشاء "المناطق الاستثمارية الخاصة"', desc: 'استشارات في تأسيس مناطق ذات قوانين ضريبية وجمركية محفزة للمستثمرين.' },
              ],
            },
            {
              title: 'التسويق والترويج الإعلامي للدولة',
              icon: 'campaign',
              services: [
                { name: 'تنظيم القمم الاستثمارية العالمية', desc: 'إقامة فعاليات كبرى لترويج الفرص الاستثمارية في الدولة (مثل معارض العقارات القومية).' },
                { name: 'الحملات الإعلامية للمشاريع الكبرى', desc: 'استخدام منصات النادي لتسليط الضوء على إنجازات الدولة إعلامياً.' },
                { name: 'بناء "العلامة التجارية للدولة" (Nation Branding)', desc: 'الترويج للدولة كوجهة آمنة ومربحة للاستثمار العقاري العالمي.' },
              ],
            },
            {
              title: 'التكنولوجيا والتحول الرقمي الحكومي',
              icon: 'developer_board',
              services: [
                { name: 'رقمنة السجل العقاري (Blockchain)', desc: 'مساعدة الحكومة في تحويل ملكيات الأراضي إلى نظام "البلوكشين" لضمان عدم التلاعب.' },
                { name: 'خرائط الاستثمار الرقمية (GIS)', desc: 'بناء منصات تفاعلية تظهر الفرص الاستثمارية المتاحة على مستوى الدولة لحظياً.' },
                { name: 'أنظمة المراقبة والتحكم للمدن', desc: 'تنفيذ غرف عمليات ذكية لإدارة المرافق والخدمات في المشاريع القومية.' },
              ],
            },
            {
              title: 'المسؤولية الاجتماعية والتنمية المستدامة',
              icon: 'eco',
              services: [
                { name: 'نماذج "السكن الاقتصادي والاجتماعي"', desc: 'تصميم حلول مبتكرة لمشاريع الإسكان لمحدودي الدخل بمشاركة القطاع الخاص.' },
                { name: 'استشارات "المباني الخضراء" القومية', desc: 'وضع معايير الاستدامة البيئية للمشاريع التي تنفذها الدولة.' },
                { name: 'إدارة الأزمات العقارية', desc: 'تقديم خطط استباقية للحكومات للتعامل مع تقلبات السوق أو الفقاعات العقارية.' },
                { name: 'برامج تدريب الكوادر الحكومية', desc: 'رفع كفاءة الموظفين في الهيئات العقارية والاستثمارية للتعامل بمعايير النادي الاحترافية.' },
              ],
            },
          ],
        },
      },
    },
    serviceDetail: {
      backLink: 'العودة إلى الخدمات',
      overviewTitle: 'نظرة عامة على الخدمة',
      detailsTitle: 'تفاصيل الخدمة',
      otherServices: 'خدمات أخرى',
      videoTitle: 'تعرّف أكثر',
      knowMore: 'اعرف المزيد',
    },
    audiencePage: {
      eyebrow: 'الفئات المستهدفة',
      title: 'مصمم لكل طرف في السوق العقاري',
      subtitle:
        'تفتح عضوية نادي حلول العقاري العالمي آفاقاً استثمارية مخصصة لكل مكونات السوق العقاري — الأفراد، البنوك والمؤسسات المالية، الشركات والمطورين، والهيئات الحكومية — عبر توفير أدوات تنفيذية وحوافز استثنائية تُلبي تجربة كل شريحة وتضمن تعظيم قيمة أصولها وتبادلاتها عالمياً.',
      who: 'نظام وعضوية النادي',
      conceptTitle: 'المفهوم الأساسي',
      conceptText:
        'وداعاً للوسطاء.. أهلاً بالمنظومة. لقد استبدلنا نموذج العمولات التقليدي بنظام عضوية ذكي يوفر الملايين، ويمنحك وصولاً مباشراً لخدمات عقارية شاملة تحت سقف واحد، وبمنتهى الشفافية.',
      benefitsTitle: 'تفاصيل المزايا حسب الفئات',
      storyTitle: 'كيف تعمل العضوية على أرض الواقع',
      cards: [
        {
          title: 'للأفراد (المشتري والبائع)',
          text: 'تجربة مباشرة وآمنة للشراء والبيع بدون عمولات وبمرونة تبادل دولية.',
          icon: 'person',
          bullets: [
            'صفر عمولات: وفر مبالغ طائلة كانت تذهب للوسطاء، واستثمرها في جودة عقارك.',
            'الأمان المطلق: الوصول فقط للعقارات المقيمة فنياً والمفحوصة قانونياً من قبل النادي.',
            'التبادل الدولي: إمكانية استبدال وحدتك السكنية داخل أو خارج الدولة عبر نظام المقايضة الذكي.',
          ],
        },
        {
          title: 'للشركات العقارية والمطورين',
          text: 'وصول أسرع للعملاء الجادين مع تكلفة تسويق أقل وقوة إعلامية أكبر.',
          icon: 'domain',
          bullets: [
            'تكلفة تسويق أقل: الوصول المباشر لقاعدة بيانات تضم ملايين المشتركين الجادين (Verified Leads).',
            'قوة الإعلام: إدراج مشاريع الشركة ضمن البرامج الإعلامية والتغطيات الخاصة بالنادي.',
            'تسريع المبيعات: نظام النادي يقلل من الدورة المستندية والزمنية لإتمام الصفقات.',
          ],
        },
        {
          title: 'للبنوك والمؤسسات المصرفية',
          text: 'أصول أكثر موثوقية وقناة مباشرة للتمويل وزيادة التدفقات النقدية.',
          icon: 'account_balance',
          bullets: [
            'تقليل مخاطر الائتمان: الحصول على أصول مقيمة بدقة وشفافية تجعل عملية التمويل أكثر أماناً.',
            'قناة بيع مباشرة: طرح برامج التمويل العقاري والادخار مباشرة للفئات المستهدفة داخل النادي.',
            'زيادة الودائع: جذب تدفقات نقدية ضخمة من خلال عمليات البيع والشراء والتبادل التي تتم عبر النظام.',
          ],
        },
        {
          title: 'للنوادي الاجتماعية والرياضية',
          text: 'شراكة تمنح الأعضاء قيمة إضافية وتفتح للنادي عوائد تشغيلية جديدة.',
          icon: 'sports_soccer',
          bullets: [
            'قيمة مضافة للأعضاء: تقديم خدمات النادي العقاري كامتياز حصري لأعضاء ناديكم.',
            'عوائد تشغيلية: خلق فرص تعاون واستثمار مشترك يعود بالنفع المادي على ميزانية النادي.',
            'تنظيم المعارض: استضافة فعاليات عقارية نخبوية داخل مقار النوادي برعاية "نادي حلول".',
          ],
        },
      ],
      partnershipPortal: {
        title: 'بوابة الشركاء: انضم إلى المنظومة العالمية',
        subtitle:
          'ليست مجرد استمارة تواصل، بل بوابة شراكة استراتيجية للمؤسسات التي تطمح للريادة.',
        bullets: [],
        cta:
          'نحن لا نبحث عن مشتركين، نحن نصنع تحالفاً عالمياً. إذا كنت تمثل مؤسسة تطمح للريادة والعمل تحت مظلة من الاحترافية والأمان، فإننا ندعوك لتقديم طلب الانضمام الرسمي لنادي حلول العقاري. انضم إلى النخبة التي ستعيد رسم خريطة العقار في 100 دولة.',
      },
      applicationSection: {
        title: 'طلب عضوية فردية',
        subtitle: 'انضم إلى نادي حلول العقاري العالمي',
        subtitleSecond: 'واختر العضوية التي تناسب احتياجاتك.',
        intro:
          'هذا النموذج مخصص للأفراد الراغبين في الانضمام بإحدى عضويات النادي: الأفراد، الرواد، أو النخبة. يرجى اختيار مستوى العضوية المناسب لك واستكمال بياناتك — سنراجع طلبك ونتواصل معك لإتمام عملية الانضمام وبدء الاستفادة من المنظومة العقارية الدولية للنادي.',
        next: 'التالي',
        back: 'السابق',
        stepProgress: 'الخطوة {current} من {total}',
        sections: {
          category: 'اختر نوع العضوية',
          basic: 'البيانات الأساسية',
          professional: 'الملف المهني (للمؤسسات والشركات فقط)',
          interests: 'اهتمامات العضوية',
          motivation: 'رسالة الرغبة في الانضمام',
          confirmation: 'تأكيد الجدية',
        },
        basicFields: {
          fullName: 'الاسم الكامل',
          country: 'الدولة (من قائمة 100 دولة)',
          city: 'المدينة',
          whatsapp: 'رقم التواصل (الواتس آب الدولي)',
          email: 'البريد الإلكتروني',
        },
        professionalFields: {
          license: 'رقم السجل التجاري / الترخيص المهني',
          portfolio: 'سابقة الأعمال (رابط الموقع الإلكتروني أو ملف البروفايل)',
          impact: 'نطاق التأثير الجغرافي (محلي / إقليمي / دولي)',
        },
        interestPrompt: 'ما الذي تبحث عنه في نادي حلول؟',
        interestOptions: [
          'الاستفادة من نظام "التبادل العقاري الدولي".',
          'تسويق مشاريع عبر "المنظومة الإعلامية للنادي".',
          'الحصول على خدمات "التقييم العقاري المعتمد".',
          'الشراكة في "المزادات العقارية الكبرى".',
          'تقديم حلول "التمويل العقاري للأعضاء".',
          'اخري.'
        ],
        motivationPlaceholder:
          'يرجى كتابة نبذة مختصرة عن أهدافك من الانضمام لنادي حلول العقاري...',
        confirmationLabel:
          'أقر بصحة البيانات المقدمة وأوافق على سياسات النادي العقاري وشروط العضوية الذكية.',
        submit: 'تقديم طلب العضوية',
      },
    },
    strategyPage: {
      eyebrow: 'رؤيتنا وأهدافنا',
      title: 'الدقة في استراتيجية العقار',
      subtitle:
        'مهمتنا الارتقاء بثقافة العقار عبر رؤى مبنية على البيانات وحلول تسويقية مبتكرة ترفع السوق بالكامل.',
      goals: 'أهدافنا الاستراتيجية',
      items: [
        {
          title: 'نشر الثقافة العقارية',
          text: 'نشر الوعي العقاري وتعميم مفهوم الثقافة العقارية.',
          icon: 'public',
        },
        {
          title: 'أفضل الممارسات العالمية',
          text: 'نقل أفضل الممارسات العقارية في العالم إلى السوق المحلي.',
          icon: 'language',
        },
        {
          title: 'خدمات تسويق متكاملة',
          text: 'تقديم كافة خدمات التسويق العقاري المدعومة بالبيانات.',
          icon: 'campaign',
        },
        {
          title: 'نتائج خلاقة غير تقليدية',
          text: 'تحقيق نتائج غير تقليدية وخلاقة من خلال البيانات الدقيقة.',
          icon: 'auto_awesome',
        },
        {
          title: 'النهوض بالقطاع',
          text: 'النهوض بالقطاع العقاري وإيجاد حلول ابتكارية للبيع والتسويق.',
          icon: 'rocket_launch',
        },
      ],
      benefitsEyebrow: 'مزايا العضوية',
      benefitsTitle: 'مزايا لكل شريحة',
      benefits: {
        companies: {
          title: 'للشركات',
          items: [
            'تسريع المبيعات وتحقيق المستهدفات البيعية',
            'توفير كل وسائل الإعلام لنشر مشاريع الشركات المشاركة',
            'توفير معارض ومقار لتسويق العقارات حول العالم',
            'حل مشاكل تعثر العملاء والمشاكل الإدارية عبر الشهادة العقارية',
          ],
        },
        banks: {
          title: 'للبنوك',
          items: [
            'شريك استراتيجي أساسي يضمن الجدية والثقة وحقوق جميع الأطراف',
            'جذب عدد كبير من العملاء للاستثمار عبر البنك',
            'توسيع نشاط البنك لشرائح جديدة من العملاء والشركات',
            'زيادة حجم التمويل العقاري',
            'استخدام كل وسائل الإعلام لنشر خدمات البنك',
            'تسويق مزادات البنك عبر النادي',
          ],
        },
        clubs: {
          title: 'للنوادي',
          items: [
            'تقديم خدمة جديدة لجميع الأعضاء',
            'الاستفادة المادية للنادي من هذه الفكرة',
            'الدعاية والتسويق للنادي وخدماته من خلال الحملة التسويقية الضخمة',
          ],
        },
        customers: {
          title: 'للعملاء',
          items: [
            'ملتقى مباشر للبائعين والمشترين فقط',
            'جميع الخدمات بدون عمولات',
            'جميع الخدمات بدون وسطاء',
            'اشترِ العقار واسترد أموالك عبر الشهادة العقارية',
          ],
        },
      },
    },
    principlesSection: {
      eyebrow: 'مبادئ النجاح',
      title: 'كيف نحقق الرؤية',
      subtitle: 'ملاحظات عامة لإنجاح المشروع — مأخوذة مباشرة من الدراسة التأسيسية.',
      items: [
        {
          title: 'اختيار ممتاز للوسائل الإعلانية',
          text: 'يجب اختيار الوسائل الإعلانية بشكل جيد حتى تُقدَّم الخدمة على أكمل وجه.',
          icon: 'ads_click',
        },
        {
          title: 'بروتوكولات تعاون',
          text: 'عمل بروتوكولات تعاون مع البنوك والنوادي للاستفادة الكاملة من الفكرة.',
          icon: 'handshake',
        },
        {
          title: 'قيادة من أعلى مستوى',
          text: 'اختيار فريق إداري على أعلى مستوى لإدارة هذه الفكرة بنجاح.',
          icon: 'workspace_premium',
        },
        {
          title: 'انطلاق تدريجي',
          text: 'توجد دراسة أخرى لتطبيق الفكرة بشكل مختصر على وسائل التواصل الاجتماعي أولًا حتى الوصول للشكل الكامل.',
          icon: 'route',
        },
      ],
    },
    marketingPage: {
      sectionTitle: 'القوة الإعلامية',
      title: 'استراتيجية التسويق الشاملة والقوة الإعلامية',
      points: [
        {
          label: 'التوجيه الإعلامي الاستراتيجي',
          text: 'بناء شراكات مع كبريات الشبكات والقنوات الاقتصادية العالمية لتوجيه الرأي العام الاستثماري وصناعة الزخم المالي.',
        },
        {
          label: 'التسويق الاقتصادي للدولة',
          text: 'التنسيق مع المنصات الرسمية والمؤسسات السيادية لتأطير الفرص العقارية وتفعيل الجذب الاستثماري المباشر.',
        },
        {
          label: 'الانتشار الرقمي العابر للحدود',
          text: 'توظيف المنصات الرقمية المتقدمة والشبكات التنفيذية للوصول المباشر إلى شرائح النخبة والمؤسسات الاستثمارية عالمياً.',
        },
      ],
      homeEyebrow: 'حضور إعلامي بلا حدود',
      titleLead: 'استراتيجية الشمول الإعلامي',
      titleHighlight: 'والتسويق السيادي',
      homeText:
        'منظومة تسويقية عابرة للحدود ترتكز على عقيدة "الإعلام مدير الاقتصاد"، وتعتمد نهجاً متكاملاً متعدد القنوات يدمج بين كبرى الشبكات الإعلامية العالمية، والمنصات الرقمية المتقدمة، وأذرع التسويق الاقتصادي للدول؛ لصناعة زخم استثماري وتوجيه التدفقات الرأسمالية نحو الفرص العقارية الكبرى عالمياً.',
      globeLabel:
        'كرة أرضية دوّارة تحيط بها القنوات الإعلامية التسع للنادي: التلفزيون والإذاعة والمعارض والبنوك والمجلة والنوادي الرياضية والتواصل الاجتماعي والموقع الإلكتروني وتطبيق الجوال.',
      methods: 'القوة الإعلامية',
      methodsSub: '"العقار تحت الاضواء" نحن المحرك الإعلامي الذي لا ينام, نحول عقارك الي قصة نجاح من خلال قنواتنا التسويقية المختلفة و منصة عالمية, لنصل بفرصتك الاستثمارية الي النخبة في كل مكان.',
      items: [
        {
          title: 'برنامج تليفزيوني',
          text: 'برنامج تلفزيوني عالمي بالتعاون مع قناة إعلامية مرموقة، يهدف إلى ترسيخ مكانة النادي كمرجع عقاري دولي، من خلال استعراض الرؤى المستقبلية والحلول المبتكرة والفرص الواعدة التي تشكل ملامح القطاع العقاري الحديث حول العالم.',
          icon: 'tv',
          video: televisionprogram,
        },
        {
          title: 'برنامج إذاعي',
          text: 'برنامج إذاعي نوعي يُعنى بتسليط الضوء على خدمات النادي العقاري ومزاياه الحصرية، واستعراض الفرص والحلول المبتكرة التي يقدمها لأعضائه وشركائه في مختلف الأسواق العقارية.',
          icon: 'radio',
          video: radioprogram,
        },
        {
          title: 'المعارض العقارية',
          text: 'المعرض العقاري الدولي للنادي العقاري، وجهة عالمية تجمع رواد القطاع العقاري من أكثر من ألف شركة ومؤسسة دولية، لتقديم أحدث الابتكارات والخدمات والحلول المتقدمة، وخلق فرص نوعية للاستثمار والتعاون والشراكات العابرة للحدود، بما يعزز مكانة المعرض كأحد أهم التجمعات العقارية العالمية.',
          icon: 'storefront',
          video: realestateexhibition,
        },
        {
          title: 'البنوك',
          text: 'يتعاون النادي العقاري مع كبرى المؤسسات المصرفية العالمية لتقديم حلول تمويل واستثمار متكاملة لعملائه، بما يضمن إتاحة خدمات مالية متطورة تدعم وتعزز فرص الاستثمار العقاري على المستوى العالمي.',
          icon: 'account_balance',
          video: bankbranchs,
        },
        {
          title: 'مجلة عقارية',
          text: 'مجلة عقارية متخصصة تضم نخبة من الخبراء والمتخصصين في القطاع العقاري، وتهدف إلى إبراز ونشر الحلول الابتكارية والرؤى المتقدمة التي تسهم في تطوير هذا المجال وتعزيز كفاءته.',
          icon: 'menu_book',
          video: realestatemagazine,
        },
        {
          title: 'النوادي الرياضية',
          text: 'يقدم النادي العقاري خدماته العقارية المتكاملة لكبرى الأندية الرياضية العالمية، بما يعكس خبرته الريادية في دعم وتطوير الحلول العقارية وفق أعلى المعايير الدولية.',
          icon: 'newsmode',
          video: sportsclub,
        },
        {
          title: 'التواصل الاجتماعي',
          text: 'حملات تسويقية وإعلامية مكثفة يطلقها النادي العقاري عبر منصات يوتيوب وفيسبوك وإنستغرام وتويتر، بهدف ترسيخ الفكرة وتعزيز انتشارها والترويج لها بأسلوب احترافي واسع التأثير.',
          icon: 'share',
          video: socialmedia,
        },
        {
          title: 'الموقع الإلكتروني',
          text: 'موقع إلكتروني متكامل وواسع النطاق مخصص للنادي العقاري، يمثل منصة رقمية متقدمة تعكس هويته المؤسسية وتعرض خدماته ورؤيته الاستراتيجية بأسلوب احترافي يعزز حضوره في القطاع العقاري.',
          icon: 'language',
          video: website,
        },
        {
          title: 'تطبيق الجوال',
          text: 'تطبيق إلكتروني مخصص للنادي العقاري، يهدف إلى نشر رؤيته وتعزيز انتشاره، مع توفير منصة رقمية متكاملة تُسهل على العملاء الوصول إلى جميع الخدمات والاستفادة منها بسلاسة وكفاءة عالية.',
          icon: 'smartphone',
          video: mobileapp,
        },
      ],
      partnerships: {
        eyebrow: 'طريقة تسويق الفكرة',
        title: 'وصول مباشر عبر عقود استراتيجية',
        subtitle:
          'إعلان مباشر لكل المهتمين بالعقارات، مع عقود استراتيجية تحوّل كل بنك وكل نادٍ إلى قناة توزيع لخدمات النادي.',
        items: [
          {
            title: 'إعلان مباشر',
            text: 'الإعلان المباشر عبر البرنامج التليفزيوني والإذاعي والمعرض العقاري والمجلة العقارية والموقع الإلكتروني وجميع وسائل التواصل الاجتماعي.',
            icon: 'campaign',
          },
          {
            title: 'تعاقد مع جميع النوادي',
            text: 'التعاقد مع جميع النوادي لتقديم كل خدمات النادي العقاري لعملائها.',
            icon: 'groups',
          },
          {
            title: 'تعاقد مع جميع البنوك',
            text: 'التعاقد مع جميع البنوك لتقديم كل خدمات النادي العقاري لعملائها.',
            icon: 'account_balance',
          },
        ],
      },
    },
    ideasPage: {
      eyebrow: 'أفكار حصرية',
      title: 'أفكار جديدة داخل النادي العقاري',
      subtitle:
        'فكرتان فريدتان تنشّطان السوق العقاري وتقدمان نموذجًا جديدًا للشراء والتداول.',
      cards: [
        {
          title: 'الشهادة العقارية الاستثمارية',
          text:
            'نموذج استثماري مبتكر يُعيد صياغة قواعد الاستثمار العقاري؛ يتيح للمستثمر شراء أصله العقاري الفعلي، مع ضمان استرداد إجمالي القيمة الشرائية للوحدة بالكامل (100%) بعد انقضاء مدة زمنية محددة. يتم تطبيق هذا المفهوم عبر شراكات وهيكلة مالية رفيعة المستوى مع كبرى المؤسسات المصرفية للاستفادة من أدوات العائد التجميعي المضمون، بما يحقق للمستثمر معادلة التملك العقاري مع الحفاظ التام على رأس المال.',
          icon: 'verified',
        },
        {
          title: 'السوبر ماركت العقاري',
          text:
            'منصة استثمارية وتنفيذية شاملة تجمع تحت سقف واحد أرقى الفرص العقارية عبر مختلف دول العالم، إلى جانب كافة الخدمات الاستشارية، القانونية، والهندسية المعتمدة التي تقدمها منظومة "نادي حلول العقاري العالمي". يوفر هذا المفهوم تجربة تملك متكاملة تتيح للمستثمر استكشاف، اختيار، وإدارة عقاراته العالمية وسلة خدماتها المصاحبة من نقطة مركزية واحدة بأعلى معايير السهولة والشفافية.',
          icon: 'storefront',
        },
      ],
      certificateDeep: {
        eyebrow: 'ابتكار محوري',
        title: 'داخل فكرة الشهادة العقارية',
        subtitle: 'فكرة ثلاثية تعيد تعريف الملكية العقارية.',
        points: [
          {
            title: 'تشجيع حركة البيع والشراء',
            text: 'تُسرّع حركة البيع والشراء في السوق العقاري بالكامل.',
            icon: 'rocket_launch',
          },
          {
            title: 'تنشيط السوق العقاري',
            text: 'إعادة تدوير رؤوس الأموال والعقارات الراكدة في السوق.',
            icon: 'bolt',
          },
          {
            title: 'العقار وأموالك كاملة',
            text: 'يحصل العميل على العقار وأمواله كاملة بعد مدة معينة بضمان من كبرى البنوك الشريكة.',
            icon: 'verified_user',
          },
        ],
      },
      extrasEyebrow: 'المسار السيادي',
      extrasTitle: 'نحن الجسر الذي يعبر برؤي الاوطان الي الساحة العالمية',
      extras: [
        {
          title: 'المسار السيادي لتسويق رؤى الدول',
          subtitle: 'الجسر الاستراتيجي لنقل المشاريع السيادية ورؤى الأوطان إلى الساحة العالمية.',
          text: 'منظومة استراتيجية تُعنى بالتعاون المباشر مع الهيئات والوزارات الحكومية (كوزارات الاستثمار، الإسكان، والإعلام) لتأطير وتسويق المشاريع العقارية الكبرى والأصول المملوكة للدول عبر أذرعنا الإعلامية والتنفيذية عالمياً. يركز "المسار السيادي" على تطبيق مفهوم "التسويق الاقتصادي للدولة"، لتحويل الفرص والمخططات الوطنية إلى وجهات استثمارية عالية الجاذبية لرؤوس الأموال المؤسسية والعابرة للحدود.',
          icon: 'domain',
        },
        {
          title: 'الامتياز العقاري العالمي',
          subtitle: 'التوسع المؤسسي العالمي عبر النموذج الأول للفرنشايز العقاري المتكامل.',
          text: 'نموذج تشغيلي مبتكر يُتيح توسيع وتصدير العلامة التجارية لـ "نادي حلول العقاري العالمي" وفق نظام الامتياز التجاري (Franchise) في مختلف أنحاء العالم. يمنح هذا المفهوم الشركاء والمستثمرين ترخيص العمل بالهوية المؤسسية المعتمدة لنادي حلول، مدعوماً بالنظم التشغيلية، وبشبكتنا الإعلامية والاستثمارية الممتدة، والحلول القانونية والهندسية المتكاملة، مما يُمكّن الفروع والمكاتب الإقليمية من قيادة السوق المحلي برؤية وأدوات عالمية.',
          icon: 'language',
        },
      ],
    },
    investmentPage: investmentPageAr,
    mediaInitiativePage: mediaInitiativePageAr,
    sportsClubsPage: sportsClubsPageAr,
    phaseOnePage: {
      eyebrow: 'للشركاء الاستراتيجيين ومقدمي الخدمات',
      title: 'ملف تعريف شبكة نادي حلول العقاري العالمي',
      subtitle:
        'منصة دولية متكاملة لبناء شبكة مؤسسية وخدمية وإعلامية تربط شركات العقار ومقدمي الخدمات المتخصصين والأندية والبنوك والمؤسسات والأسواق ضمن منظومة واحدة.',
      video: {
        title: 'نظرة عامة لمؤدي الخدمة و الشركاء الاستراتيجيين',
        placeholder: 'الفيديو قريبًا',
        videoUrl: "https://www.youtube.com/watch?v=gLxAmW89Vyc",
        videoSrc: null,
      },
      sections: [
        {
          title: 'من نحن',
          text: '',
          paragraphs: [
            'نادي حلول العقاري العالمي هو منصة دولية متكاملة تهدف إلى بناء شبكة مؤسسية وخدمية وإعلامية تربط بين الشركات العقارية، ومقدمي الخدمات المتخصصة، والأندية، والمؤسسات، والبنوك، والجهات الحكومية، والأسواق المحلية والدولية، ضمن منظومة واحدة تقوم على الشمول، والانتشار، والتكامل، والقيمة المضافة.',
            'نحن لا نقدم نموذجًا تقليديًا قائمًا على الوساطة أو البيع المباشر، بل نبني نظام متكاملًا يربط بين الطلب والعرض والخدمة والإعلام والعضوية، بحيث تصبح المنصة نقطة التقاء بين مختلف أطراف السوق العقاري والخدمي في أكثر من دولة.',
          ],
          icon: 'hub',
        },
        {
          title: 'لماذا نحن الآن؟',
          text: '',
          paragraphs: [
            'يشهد السوق العقاري، والخدمي، والاستثماري في المنطقة والعالم تحولاً واضحًا في طريقة تقديم الخدمة، وبناء الثقة، وإدارة العلاقات، وتوسيع نطاق التأثير.',
            'فلم يعد النجاح قائمًا على تقديم خدمة منفردة، بل أصبح مرتبطًا بقدرة المنصة على:',
          ],
          bullets: [
            'جمع الخدمات في مكان واحد.',
            'فتح أسواق جديدة.',
            'بناء علاقات مؤسسية قوية.',
            'توفير قيمة إعلامية وتجارية حقيقية.',
            'تسهيل الوصول إلى العملاء والفرص بطريقة أكثر احترافية.',
          ],
          closingParagraph:
            'ومن هنا جاء نادي حلول العقاري العالمي ليقدّم نموذجًا مختلفًا عن النماذج التقليدية، نموذجًا يتجاوز حدود التسويق العقاري أو الوساطة العقارية إلى منظومة أوسع وأشمل، تخلق قيمة حقيقية لكل طرف داخلها.',
          icon: 'trending_up',
        },
        {
          title: 'ما تم إنجازه حتى الآن',
          text:
            'تم بالفعل تطوير الأسس الجوهرية للمشروع — مما يؤكد أنه ليس فكرة نظرية فحسب، بل منصة تتطور فعليًا نحو التشغيل الحقيقي.',
          bullets: [
            'تحديد الرؤية العامة للنادي',
            'بناء نموذج متعدد الخدمات والمسارات',
            'إطلاق منصة ترويجية للمشروع',
            'البدء في تطوير تطبيق النادي',
            'التواصل مع عدد كبير من الشركات والمؤسسات',
            'تلقي اهتمام ومشاركة أولية من جهات متعددة',
            'إعداد الهيكل العام للعضويات والخدمات والفعاليات والمحتوى الإعلامي',
            'الوصول إلى مرحلة متقدمة من التحضير التنفيذي',
          ],
          icon: 'task_alt',
        },
        {
          title: 'ما هو نادي حلول العقاري العالمي؟',
          text: '',
          paragraphs: [
            'نادي حلول العقاري العالمي ليس شركة وساطة عقارية تقليدية، ولا شركة تسويق عقاري فقط، ولا منصة عمولات. بل هو منظومة متكاملة تجمع بين:',
          ],
          bullets: [
            'العضويات.',
            'والخدمات المتخصصة.',
            'والإعلام.',
            'والفعاليات.',
            'والمعارض.',
            'والشراكات.',
            'والتوسع الدولي.',
          ],
          closingParagraph:
            'وهو بذلك يخلق بيئة عمل جديدة تجمع بين القيمة التجارية، والقيمة الإعلامية، والقيمة المؤسسية في إطار واحد.',
          icon: 'apartment',
        },
        {
          title: 'نقاط القوة الأساسية للنادي العقاري',
          text: '',
          splitItemRows: true,
          splitItemChunkSize: 3,
          icon: 'military_tech',
          closingParagraph:
            'وبهذا، يصبح النادي منصة لا تخدم الأفراد والشركات فقط، بل تمتد فائدته إلى الأندية والبنوك والمؤسسات والجهات الحكومية والمبادرات الوطنية والرؤى الحكومية للدول.',
          items: [
            {
              label: 'أولاً: الشمولية',
              text:
                'النادي العقاري يجمع عددًا كبيرًا من الخدمات في مكان واحد، ما يمنح العميل أو الشريك أو العضو تجربة متكاملة بدلًا من التعامل مع أطراف متعددة ومجزأة.',
            },
            {
              label: 'ثانيًا: عمولة صفر ونموذج بدون وسطاء تقليديين',
              text:
                'النادي لا يعتمد على نموذج الوسيط التقليدي، ولا على العمولات التقليدية، بل يسعى إلى ربط مباشر بين الأطراف المختلفة داخل المنظومة، بما يحقق وضوحًا أعلى وقيمة أكبر وتكلفة أقل في كثير من الحالات، ويمنح الأعضاء والشركات والمستفيدين تجربة أكثر كفاءة وشفافية.',
            },
            {
              label: 'ثالثًا: القوة الإعلامية',
              text: 'يعتمد النادي على ذراع إعلامية ضخمة تشمل:',
              bullets: [
                'البرامج التلفزيونية',
                'الصحف',
                'المجلات العقارية',
                'الفعاليات',
                'المؤتمرات',
                'والمعارض',
              ],
            },
            {
              label: 'رابعًا: الانتشار الدولي',
              text:
                'يبدأ النادي من 15 دولة في المرحلة الأولى، ثم يتوسع تدريجيًا إلى 100 دولة خلال خمس سنوات.',
            },
            {
              label: 'خامسًا: الشراكة مع الأندية والمؤسسات',
              text: 'النادي العقاري لا يعمل منفردًا، بل يبني شراكات واسعة مع:',
              bullets: ['الأندية', 'المؤسسات', 'البنوك', 'مقدمي الخدمات', 'والجهات ذات الصلة'],
            },
            {
              label: 'سادسًا: خدمة الرؤى الحكومية والجهات الرسمية',
              text:
                'يمتد دور النادي العقاري ليخدم أيضًا الجهات الحكومية والرؤى التنموية الوطنية في الدول المستهدفة، من خلال المساهمة في:',
              bullets: [
                'تنشيط القطاعات العقارية والخدمية',
                'جذب الاستثمارات',
                'دعم الحضور الدولي للدولة',
                'ربط السوق المحلي بالفرص الخارجية',
                'وتوفير منصة تساعد على تحقيق مستهدفات النمو والتوسع والترويج المؤسسي',
              ],
            },
          ],
        },
        {
          title: 'خطة التوسع الدولي — المرحلة الأولى',
          text:
            'تنطلق المرحلة الأولى في 15 دولة، ثم يتوسع النادي تدريجيًا عبر خمس مراحل إلى 100 دولة خلال خمس سنوات.',
          bullets: [
            'المرحلة الأولى: 15 دولة',
              'المجموعة العربية : مصر - السعودية - الإمارات - قطر - سلطنة عمان',
              'المجموعة الأوروبية : فرنسا - ألمانيا - إيطاليا - بريطانيا - اسبانيا',
              'المجموعة العالمية : تركيا - سنغافورا - ماليزيا - اليونان - قبرص',
            'المرحلة الثانية: 35 دولة',
            'المرحلة الثالثة: 60 دولة',
            'المرحلة الرابعة: 80 دولة',
            'المرحلة الخامسة: 100 دولة',
          ],
          icon: 'public',
        },
        {
          title: 'ماذا يكسب الشركاء ومقدمو الخدمات؟',
          text: 'يخلق النادي قيمة ملموسة لكل شريحة مهنية داخل المنظومة:',
          bullets: [
            'المطورون العقاريون — أسواق جديدة وحضور إعلامي وعرض دولي للمشاريع',
            'شركات الإعلان والتسويق — رعايات وحملات وانتشار عبر دول متعددة',
            'شركات المقاولات والتشييد — مشاريع عابرة للحدود وشراكات تنفيذ طويلة الأمد',
            'إدارة الأصول والصيانة — عقود تشغيل وشبكة عملاء متكررة',
            'المكاتب القانونية والمحاسبية والضريبية — إحالات وحضور مؤسسي داخل شبكة قوية',
            'البنوك وشركات التمويل — طلب تمويلي حقيقي وشراكات ورؤية مؤسسية',
            'الأندية والمؤسسات — خدمات جديدة لأعضائها والانضمام لشبكة دولية نخبوية',
            'الجهات الحكومية — دعم الترويج المؤسسي وربط الاستثمار المحلي بالفرص الدولية',
            'مقدمو الإقامة والهجرة والجنسية — عملاء عالي القيمة وتدفق استثماري عابر للحدود',
          ],
          icon: 'handshake',
        },
        {
          title: 'ما الذي يقدمه النادي العقاري للشركاء؟',
          text: '',
          paragraphs: ['النادي العقاري يمنح الشركاء ومقدمي الخدمات:'],
          bullets: [
            'ظهورًا داخل منصة دولية متكاملة.',
            'فرصًا للوصول إلى أسواق جديدة.',
            'مشاركة في فعاليات ومعارض وبرامج إعلامية.',
            'فرصة للعمل داخل شبكة نخبوية ومؤسسية واسعة.',
            'مكانة مهنية أعلى ضمن منظومة منتقاة.',
            'القدرة على الوصول إلى عملاء وشركاء جدد.',
            'الاستفادة من القوة الإعلامية والتسويقية للنادي.',
            'فرصة للتوافق مع مسارات التوسع والرؤى الحكومية في الدول المستهدفة.',
          ],
          icon: 'volunteer_activism',
        },
        {
          title: 'شروط المشاركة والاعتماد',
          text: '',
          paragraphs: [
            'النادي العقاري لا يفتح الباب للجميع بشكل عشوائي، بل يعتمد على الاختيار والانتقاء وفق معايير مهنية واضحة، وتشمل\n' +
            'هذه المعايير:',
          ],
          bullets: [
            'أن تكون سمعة الشركة جيدة.',
            'أن يكون الملف التعريفي للشركة قويًا وواضحًا.',
            'مراجعة الأوراق القانونية والاعتمادات والرخص.',
            'الالتزام بمعايير الجودة والمهنية.',
            'قبول العمل وفق سياسات النادي وخطابه المهني.',
            'القدرة على تقديم قيمة حقيقية لأعضاء النادي وشركائه.',
            'ملاءمة الشركة لطبيعة الخدمات والمعايير المعتمدة داخل المنظومة.',
          ],
          closingParagraph:
            'ويتم اعتماد أي شريك أو مقدم خدمة بعد مراجعة أولية تضمن توافقه مع روح النادي ومتطلباته، بما يحافظ على جودة المنظومة وقيمتها وسمعتها.',
          icon: 'verified_user',
        },
        {
          title: 'الطبيعة الخاصة للنادي العقاري',
          text: '',
          icon: 'diamond',
          items: [
            {
              paragraphs: [
                'النادي العقاري يتميز بأنه: ليس منصة بيع تقليدية وليس وسيطاً عقارياً فقط وليس مشروعاً محلياً محدوداً. بل منظومة عالمية تجمع بين:',
              ],
              bullets: [
                'الإعلام.',
                'والعضويات.',
                'والخدمات.',
                'والتوسع الدولي.',
                'والشراكات المؤسسية.',
                'والخدمة العامة للرؤى الحكومية والتنموية.',
              ],
              closingParagraph: 'وهذا هو جوهر الاختلاف الذي يمنحه قيمة أعلى من النماذج التقليدية.',
            },
            {
              label: 'لماذا يعتبر الانضمام فرصة؟',
              paragraphs: ['لأن الانضمام إلى النادي العقاري يعني:'],
              bullets: [
                'دخول شبكة ذات توسع عالمي.',
                'الوصول إلى جمهور أوسع.',
                'الحضور داخل منظومة مؤسسية وإعلامية.',
                'الاستفادة من فرص جديدة في عدة دول.',
                'بناء علاقة طويلة الأجل مع مشروع قابل للنمو والتوسع.',
                'المشاركة في منظومة يمكن أن تخدم القطاع الخاص والقطاع الحكومي في آن واحد.',
              ],
            },
          ],
        },
      ],
      conclusion: {
        step: '11',
        title: 'الخلاصة',
        icon: 'summarize',
        paragraphs: [
            'يعتمد نادي حلول العقاري على مفهوم "نادي الـ100"، والذي يقوم على ضم 100 شركة رائدة في كل دولة من مختلف التخصصات العقارية، بما في ذلك التطوير العقاري، والإنشاءات والمقاولات، وإدارة الأصول، والصيانة والتشغيل، وغيرها من الخدمات المرتبطة بالقطاع العقاري، بهدف تكوين منظومة متكاملة من الشركاء والخبراء لتقديم حلول عقارية شاملة وتعزيز فرص التعاون والاستثمار.',
          'نادي حلول العقاري العالمي ليس مجرد مشروع عقاري، بل منصة متكاملة واسعة النطاق تهدف إلى بناء شبكة دولية من الخدمات والفرص والشراكات والإعلام والعضويات، بطريقة تخلق قيمة حقيقية لكل طرف داخلها.',
          'ونحن نبحث عن شركاء ومقدمي خدمات ومؤسسات يؤمنون بقيمة الشمول، والاحتراف، والانتشار، والتكامل، ويستطيعون أن يكونوا جزءًا من هذه المنظومة العالمية في مرحلتها الأولى من التنفيذ.',
        ],
      },
      partnerApplication: {
        title: 'طلب الانضمام الرسمي',
        subtitle:
          'يرجى استكمال الأقسام التالية لتوجيه طلبك إلى المسار الإداري الصحيح.',
        intro:
          'نحن لا نبحث عن مشتركين، نحن نصنع تحالفاً عالمياً. إذا كنت تمثل مؤسسة تطمح للريادة والعمل تحت مظلة من الاحترافية والأمان، فإننا ندعوك لتقديم طلب الانضمام الرسمي لنادي حلول العقاري. انضم إلى النخبة التي ستعيد رسم خريطة العقار في 100 دولة.',
        next: 'التالي',
        back: 'السابق',
        stepProgress: 'الخطوة {current} من {total}',
        sections: {
          category: 'تصنيف مقدم الطلب (Select Category)',
          basic: 'البيانات الأساسية',
          professional: 'الملف المهني (للمؤسسات والشركات فقط)',
          interests: 'اهتمامات الشراكة',
          motivation: 'رسالة الرغبة في الانضمام',
          confirmation: 'تأكيد الجدية',
        },
        categoryOptions: [
          'شركة تطوير عقاري / شركة تسويق',
          'مؤسسة مصرفية / بنك',
          'جهة حكومية / مؤسسة سيادية',
          'نادٍ رياضي / اجتماعي / جمعية مهنية',
        ],
        basicFields: {
          fullName: 'الاسم الكامل / اسم الكيان المؤسسي',
          country: 'الدولة (من قائمة 100 دولة)',
          city: 'المدينة / المقر الرئيسي',
          whatsapp: 'رقم التواصل (الواتس آب الدولي)',
          email: 'البريد الإلكتروني الرسمي',
        },
        professionalFields: {
          license: 'رقم السجل التجاري / الترخيص المهني',
          portfolio: 'سابقة الأعمال (رابط الموقع الإلكتروني أو ملف البروفايل)',
          impact: 'نطاق التأثير الجغرافي (محلي / إقليمي / دولي)',
        },
        interestPrompt: 'ما الذي تبحث عنه في نادي حلول؟',
        interestOptions: [
          'الاستفادة من نظام "التبادل العقاري الدولي".',
          'تسويق مشاريع عبر "المنظومة الإعلامية للنادي".',
          'الحصول على خدمات "التقييم العقاري المعتمد".',
          'الشراكة في "المزادات العقارية الكبرى".',
          'تقديم حلول "التمويل العقاري للأعضاء".',
          'اخري.',
        ],
        motivationPlaceholder:
          'يرجى كتابة نبذة مختصرة عن أهدافكم من الانضمام لنادي حلول العقاري...',
        confirmationLabel:
          'أقر بصحة البيانات المقدمة وأوافق على سياسات النادي العقاري وشروط الشراكة.',
        submit: 'تقديم طلب الانضمام الرسمي',
      },
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');
  const t = translations[language];

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      toggleLanguage: () => setLanguage((prev) => (prev === 'en' ? 'ar' : 'en')),
      isArabic: language === 'ar',
      t,
    }),
    [language, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
